const communityMaterialIcons = [
  { n: 'access-point', c: 'F002' },
  { n: 'access-point-network', c: 'F003' },
  { n: 'access-point-network-off', c: 'FBBD' },
  { n: 'account', c: 'F004' },
  { n: 'account-alert', c: 'F005' },
  { n: 'account-alert-outline', c: 'FB2C' },
  { n: 'account-arrow-left', c: 'FB2D' },
  { n: 'account-arrow-left-outline', c: 'FB2E' },
  { n: 'account-arrow-right', c: 'FB2F' },
  { n: 'account-arrow-right-outline', c: 'FB30' },
  { n: 'account-badge', c: 'FD83' },
  { n: 'account-badge-alert', c: 'FD84' },
  { n: 'account-badge-alert-outline', c: 'FD85' },
  { n: 'account-badge-outline', c: 'FD86' },
  { n: 'account-box', c: 'F006' },
  { n: 'account-box-multiple', c: 'F933' },
  { n: 'account-box-outline', c: 'F007' },
  { n: 'account-card-details', c: 'F5D2' },
  { n: 'account-card-details-outline', c: 'FD87' },
  { n: 'account-check', c: 'F008' },
  { n: 'account-check-outline', c: 'FBBE' },
  { n: 'account-child', c: 'FA88' },
  { n: 'account-child-circle', c: 'FA89' },
  { n: 'account-circle', c: 'F009' },
  { n: 'account-circle-outline', c: 'FB31' },
  { n: 'account-clock', c: 'FB32' },
  { n: 'account-clock-outline', c: 'FB33' },
  { n: 'account-convert', c: 'F00A' },
  { n: 'account-details', c: 'F631' },
  { n: 'account-edit', c: 'F6BB' },
  { n: 'account-group', c: 'F848' },
  { n: 'account-group-outline', c: 'FB34' },
  { n: 'account-heart', c: 'F898' },
  { n: 'account-heart-outline', c: 'FBBF' },
  { n: 'account-key', c: 'F00B' },
  { n: 'account-key-outline', c: 'FBC0' },
  { n: 'account-minus', c: 'F00D' },
  { n: 'account-minus-outline', c: 'FAEB' },
  { n: 'account-multiple', c: 'F00E' },
  { n: 'account-multiple-check', c: 'F8C4' },
  { n: 'account-multiple-minus', c: 'F5D3' },
  { n: 'account-multiple-minus-outline', c: 'FBC1' },
  { n: 'account-multiple-outline', c: 'F00F' },
  { n: 'account-multiple-plus', c: 'F010' },
  { n: 'account-multiple-plus-outline', c: 'F7FF' },
  { n: 'account-network', c: 'F011' },
  { n: 'account-network-outline', c: 'FBC2' },
  { n: 'account-off', c: 'F012' },
  { n: 'account-off-outline', c: 'FBC3' },
  { n: 'account-outline', c: 'F013' },
  { n: 'account-plus', c: 'F014' },
  { n: 'account-plus-outline', c: 'F800' },
  { n: 'account-question', c: 'FB35' },
  { n: 'account-question-outline', c: 'FB36' },
  { n: 'account-remove', c: 'F015' },
  { n: 'account-remove-outline', c: 'FAEC' },
  { n: 'account-search', c: 'F016' },
  { n: 'account-search-outline', c: 'F934' },
  { n: 'account-settings', c: 'F630' },
  { n: 'account-star', c: 'F017' },
  { n: 'account-star-outline', c: 'FBC4' },
  { n: 'account-supervisor', c: 'FA8A' },
  { n: 'account-supervisor-circle', c: 'FA8B' },
  { n: 'account-switch', c: 'F019' },
  { n: 'account-tie', c: 'FCBF' },
  { n: 'accusoft', c: 'F849' },
  { n: 'adchoices', c: 'FD1E' },
  { n: 'adjust', c: 'F01A' },
  { n: 'adobe', c: 'F935' },
  { n: 'air-conditioner', c: 'F01B' },
  { n: 'air-filter', c: 'FD1F' },
  { n: 'air-horn', c: 'FD88' },
  { n: 'air-purifier', c: 'FD20' },
  { n: 'airbag', c: 'FBC5' },
  { n: 'airballoon', c: 'F01C' },
  { n: 'airplane', c: 'F01D' },
  { n: 'airplane-landing', c: 'F5D4' },
  { n: 'airplane-off', c: 'F01E' },
  { n: 'airplane-takeoff', c: 'F5D5' },
  { n: 'airplay', c: 'F01F' },
  { n: 'airport', c: 'F84A' },
  { n: 'alarm', c: 'F020' },
  { n: 'alarm-bell', c: 'F78D' },
  { n: 'alarm-check', c: 'F021' },
  { n: 'alarm-light', c: 'F78E' },
  { n: 'alarm-light-outline', c: 'FBC6' },
  { n: 'alarm-multiple', c: 'F022' },
  { n: 'alarm-off', c: 'F023' },
  { n: 'alarm-plus', c: 'F024' },
  { n: 'alarm-snooze', c: 'F68D' },
  { n: 'album', c: 'F025' },
  { n: 'alert', c: 'F026' },
  { n: 'alert-box', c: 'F027' },
  { n: 'alert-box-outline', c: 'FCC0' },
  { n: 'alert-circle', c: 'F028' },
  { n: 'alert-circle-outline', c: 'F5D6' },
  { n: 'alert-decagram', c: 'F6BC' },
  { n: 'alert-decagram-outline', c: 'FCC1' },
  { n: 'alert-octagon', c: 'F029' },
  { n: 'alert-octagon-outline', c: 'FCC2' },
  { n: 'alert-octagram', c: 'F766' },
  { n: 'alert-octagram-outline', c: 'FCC3' },
  { n: 'alert-outline', c: 'F02A' },
  { n: 'alien', c: 'F899' },
  { n: 'all-inclusive', c: 'F6BD' },
  { n: 'alpha', c: 'F02B' },
  { n: 'alpha-a', c: '0041' },
  { n: 'alpha-a-box', c: 'FAED' },
  { n: 'alpha-a-box-outline', c: 'FBC7' },
  { n: 'alpha-a-circle', c: 'FBC8' },
  { n: 'alpha-a-circle-outline', c: 'FBC9' },
  { n: 'alpha-b', c: '0042' },
  { n: 'alpha-b-box', c: 'FAEE' },
  { n: 'alpha-b-box-outline', c: 'FBCA' },
  { n: 'alpha-b-circle', c: 'FBCB' },
  { n: 'alpha-b-circle-outline', c: 'FBCC' },
  { n: 'alpha-c', c: '0043' },
  { n: 'alpha-c-box', c: 'FAEF' },
  { n: 'alpha-c-box-outline', c: 'FBCD' },
  { n: 'alpha-c-circle', c: 'FBCE' },
  { n: 'alpha-c-circle-outline', c: 'FBCF' },
  { n: 'alpha-d', c: '0044' },
  { n: 'alpha-d-box', c: 'FAF0' },
  { n: 'alpha-d-box-outline', c: 'FBD0' },
  { n: 'alpha-d-circle', c: 'FBD1' },
  { n: 'alpha-d-circle-outline', c: 'FBD2' },
  { n: 'alpha-e', c: '0045' },
  { n: 'alpha-e-box', c: 'FAF1' },
  { n: 'alpha-e-box-outline', c: 'FBD3' },
  { n: 'alpha-e-circle', c: 'FBD4' },
  { n: 'alpha-e-circle-outline', c: 'FBD5' },
  { n: 'alpha-f', c: '0046' },
  { n: 'alpha-f-box', c: 'FAF2' },
  { n: 'alpha-f-box-outline', c: 'FBD6' },
  { n: 'alpha-f-circle', c: 'FBD7' },
  { n: 'alpha-f-circle-outline', c: 'FBD8' },
  { n: 'alpha-g', c: '0047' },
  { n: 'alpha-g-box', c: 'FAF3' },
  { n: 'alpha-g-box-outline', c: 'FBD9' },
  { n: 'alpha-g-circle', c: 'FBDA' },
  { n: 'alpha-g-circle-outline', c: 'FBDB' },
  { n: 'alpha-h', c: '0048' },
  { n: 'alpha-h-box', c: 'FAF4' },
  { n: 'alpha-h-box-outline', c: 'FBDC' },
  { n: 'alpha-h-circle', c: 'FBDD' },
  { n: 'alpha-h-circle-outline', c: 'FBDE' },
  { n: 'alpha-i', c: '0049' },
  { n: 'alpha-i-box', c: 'FAF5' },
  { n: 'alpha-i-box-outline', c: 'FBDF' },
  { n: 'alpha-i-circle', c: 'FBE0' },
  { n: 'alpha-i-circle-outline', c: 'FBE1' },
  { n: 'alpha-j', c: '004A' },
  { n: 'alpha-j-box', c: 'FAF6' },
  { n: 'alpha-j-box-outline', c: 'FBE2' },
  { n: 'alpha-j-circle', c: 'FBE3' },
  { n: 'alpha-j-circle-outline', c: 'FBE4' },
  { n: 'alpha-k', c: '004B' },
  { n: 'alpha-k-box', c: 'FAF7' },
  { n: 'alpha-k-box-outline', c: 'FBE5' },
  { n: 'alpha-k-circle', c: 'FBE6' },
  { n: 'alpha-k-circle-outline', c: 'FBE7' },
  { n: 'alpha-l', c: '004C' },
  { n: 'alpha-l-box', c: 'FAF8' },
  { n: 'alpha-l-box-outline', c: 'FBE8' },
  { n: 'alpha-l-circle', c: 'FBE9' },
  { n: 'alpha-l-circle-outline', c: 'FBEA' },
  { n: 'alpha-m', c: '004D' },
  { n: 'alpha-m-box', c: 'FAF9' },
  { n: 'alpha-m-box-outline', c: 'FBEB' },
  { n: 'alpha-m-circle', c: 'FBEC' },
  { n: 'alpha-m-circle-outline', c: 'FBED' },
  { n: 'alpha-n', c: '004E' },
  { n: 'alpha-n-box', c: 'FAFA' },
  { n: 'alpha-n-box-outline', c: 'FBEE' },
  { n: 'alpha-n-circle', c: 'FBEF' },
  { n: 'alpha-n-circle-outline', c: 'FBF0' },
  { n: 'alpha-o', c: '004F' },
  { n: 'alpha-o-box', c: 'FAFB' },
  { n: 'alpha-o-box-outline', c: 'FBF1' },
  { n: 'alpha-o-circle', c: 'FBF2' },
  { n: 'alpha-o-circle-outline', c: 'FBF3' },
  { n: 'alpha-p', c: '0050' },
  { n: 'alpha-p-box', c: 'FAFC' },
  { n: 'alpha-p-box-outline', c: 'FBF4' },
  { n: 'alpha-p-circle', c: 'FBF5' },
  { n: 'alpha-p-circle-outline', c: 'FBF6' },
  { n: 'alpha-q', c: '0051' },
  { n: 'alpha-q-box', c: 'FAFD' },
  { n: 'alpha-q-box-outline', c: 'FBF7' },
  { n: 'alpha-q-circle', c: 'FBF8' },
  { n: 'alpha-q-circle-outline', c: 'FBF9' },
  { n: 'alpha-r', c: '0052' },
  { n: 'alpha-r-box', c: 'FAFE' },
  { n: 'alpha-r-box-outline', c: 'FBFA' },
  { n: 'alpha-r-circle', c: 'FBFB' },
  { n: 'alpha-r-circle-outline', c: 'FBFC' },
  { n: 'alpha-s', c: '0053' },
  { n: 'alpha-s-box', c: 'FAFF' },
  { n: 'alpha-s-box-outline', c: 'FBFD' },
  { n: 'alpha-s-circle', c: 'FBFE' },
  { n: 'alpha-s-circle-outline', c: 'FBFF' },
  { n: 'alpha-t', c: '0054' },
  { n: 'alpha-t-box', c: 'FB00' },
  { n: 'alpha-t-box-outline', c: 'FC00' },
  { n: 'alpha-t-circle', c: 'FC01' },
  { n: 'alpha-t-circle-outline', c: 'FC02' },
  { n: 'alpha-u', c: '0055' },
  { n: 'alpha-u-box', c: 'FB01' },
  { n: 'alpha-u-box-outline', c: 'FC03' },
  { n: 'alpha-u-circle', c: 'FC04' },
  { n: 'alpha-u-circle-outline', c: 'FC05' },
  { n: 'alpha-v', c: '0056' },
  { n: 'alpha-v-box', c: 'FB02' },
  { n: 'alpha-v-box-outline', c: 'FC06' },
  { n: 'alpha-v-circle', c: 'FC07' },
  { n: 'alpha-v-circle-outline', c: 'FC08' },
  { n: 'alpha-w', c: '0057' },
  { n: 'alpha-w-box', c: 'FB03' },
  { n: 'alpha-w-box-outline', c: 'FC09' },
  { n: 'alpha-w-circle', c: 'FC0A' },
  { n: 'alpha-w-circle-outline', c: 'FC0B' },
  { n: 'alpha-x', c: '0058' },
  { n: 'alpha-x-box', c: 'FB04' },
  { n: 'alpha-x-box-outline', c: 'FC0C' },
  { n: 'alpha-x-circle', c: 'FC0D' },
  { n: 'alpha-x-circle-outline', c: 'FC0E' },
  { n: 'alpha-y', c: '0059' },
  { n: 'alpha-y-box', c: 'FB05' },
  { n: 'alpha-y-box-outline', c: 'FC0F' },
  { n: 'alpha-y-circle', c: 'FC10' },
  { n: 'alpha-y-circle-outline', c: 'FC11' },
  { n: 'alpha-z', c: '005A' },
  { n: 'alpha-z-box', c: 'FB06' },
  { n: 'alpha-z-box-outline', c: 'FC12' },
  { n: 'alpha-z-circle', c: 'FC13' },
  { n: 'alpha-z-circle-outline', c: 'FC14' },
  { n: 'alphabetical', c: 'F02C' },
  { n: 'altimeter', c: 'F5D7' },
  { n: 'amazon', c: 'F02D' },
  { n: 'amazon-alexa', c: 'F8C5' },
  { n: 'amazon-drive', c: 'F02E' },
  { n: 'ambulance', c: 'F02F' },
  { n: 'ammunition', c: 'FCC4' },
  { n: 'ampersand', c: 'FA8C' },
  { n: 'amplifier', c: 'F030' },
  { n: 'anchor', c: 'F031' },
  { n: 'android', c: 'F032' },
  { n: 'android-auto', c: 'FA8D' },
  { n: 'android-debug-bridge', c: 'F033' },
  { n: 'android-head', c: 'F78F' },
  { n: 'android-messages', c: 'FD21' },
  { n: 'android-studio', c: 'F034' },
  { n: 'angle-acute', c: 'F936' },
  { n: 'angle-obtuse', c: 'F937' },
  { n: 'angle-right', c: 'F938' },
  { n: 'angular', c: 'F6B1' },
  { n: 'angularjs', c: 'F6BE' },
  { n: 'animation', c: 'F5D8' },
  { n: 'animation-outline', c: 'FA8E' },
  { n: 'animation-play', c: 'F939' },
  { n: 'animation-play-outline', c: 'FA8F' },
  { n: 'anvil', c: 'F89A' },
  { n: 'apple', c: 'F035' },
  { n: 'apple-finder', c: 'F036' },
  { n: 'apple-icloud', c: 'F038' },
  { n: 'apple-ios', c: 'F037' },
  { n: 'apple-keyboard-caps', c: 'F632' },
  { n: 'apple-keyboard-command', c: 'F633' },
  { n: 'apple-keyboard-control', c: 'F634' },
  { n: 'apple-keyboard-option', c: 'F635' },
  { n: 'apple-keyboard-shift', c: 'F636' },
  { n: 'apple-safari', c: 'F039' },
  { n: 'application', c: 'F614' },
  { n: 'application-export', c: 'FD89' },
  { n: 'application-import', c: 'FD8A' },
  { n: 'apps', c: 'F03B' },
  { n: 'apps-box', c: 'FD22' },
  { n: 'arch', c: 'F8C6' },
  { n: 'archive', c: 'F03C' },
  { n: 'arrange-bring-forward', c: 'F03D' },
  { n: 'arrange-bring-to-front', c: 'F03E' },
  { n: 'arrange-send-backward', c: 'F03F' },
  { n: 'arrange-send-to-back', c: 'F040' },
  { n: 'arrow-all', c: 'F041' },
  { n: 'arrow-bottom-left', c: 'F042' },
  { n: 'arrow-bottom-left-bold-outline', c: 'F9B6' },
  { n: 'arrow-bottom-left-thick', c: 'F9B7' },
  { n: 'arrow-bottom-right', c: 'F043' },
  { n: 'arrow-bottom-right-bold-outline', c: 'F9B8' },
  { n: 'arrow-bottom-right-thick', c: 'F9B9' },
  { n: 'arrow-collapse', c: 'F615' },
  { n: 'arrow-collapse-all', c: 'F044' },
  { n: 'arrow-collapse-down', c: 'F791' },
  { n: 'arrow-collapse-horizontal', c: 'F84B' },
  { n: 'arrow-collapse-left', c: 'F792' },
  { n: 'arrow-collapse-right', c: 'F793' },
  { n: 'arrow-collapse-up', c: 'F794' },
  { n: 'arrow-collapse-vertical', c: 'F84C' },
  { n: 'arrow-decision', c: 'F9BA' },
  { n: 'arrow-decision-auto', c: 'F9BB' },
  { n: 'arrow-decision-auto-outline', c: 'F9BC' },
  { n: 'arrow-decision-outline', c: 'F9BD' },
  { n: 'arrow-down', c: 'F045' },
  { n: 'arrow-down-bold', c: 'F72D' },
  { n: 'arrow-down-bold-box', c: 'F72E' },
  { n: 'arrow-down-bold-box-outline', c: 'F72F' },
  { n: 'arrow-down-bold-circle', c: 'F047' },
  { n: 'arrow-down-bold-circle-outline', c: 'F048' },
  { n: 'arrow-down-bold-hexagon-outline', c: 'F049' },
  { n: 'arrow-down-bold-outline', c: 'F9BE' },
  { n: 'arrow-down-box', c: 'F6BF' },
  { n: 'arrow-down-circle', c: 'FCB7' },
  { n: 'arrow-down-circle-outline', c: 'FCB8' },
  { n: 'arrow-down-drop-circle', c: 'F04A' },
  { n: 'arrow-down-drop-circle-outline', c: 'F04B' },
  { n: 'arrow-down-thick', c: 'F046' },
  { n: 'arrow-expand', c: 'F616' },
  { n: 'arrow-expand-all', c: 'F04C' },
  { n: 'arrow-expand-down', c: 'F795' },
  { n: 'arrow-expand-horizontal', c: 'F84D' },
  { n: 'arrow-expand-left', c: 'F796' },
  { n: 'arrow-expand-right', c: 'F797' },
  { n: 'arrow-expand-up', c: 'F798' },
  { n: 'arrow-expand-vertical', c: 'F84E' },
  { n: 'arrow-left', c: 'F04D' },
  { n: 'arrow-left-bold', c: 'F730' },
  { n: 'arrow-left-bold-box', c: 'F731' },
  { n: 'arrow-left-bold-box-outline', c: 'F732' },
  { n: 'arrow-left-bold-circle', c: 'F04F' },
  { n: 'arrow-left-bold-circle-outline', c: 'F050' },
  { n: 'arrow-left-bold-hexagon-outline', c: 'F051' },
  { n: 'arrow-left-bold-outline', c: 'F9BF' },
  { n: 'arrow-left-box', c: 'F6C0' },
  { n: 'arrow-left-circle', c: 'FCB9' },
  { n: 'arrow-left-circle-outline', c: 'FCBA' },
  { n: 'arrow-left-drop-circle', c: 'F052' },
  { n: 'arrow-left-drop-circle-outline', c: 'F053' },
  { n: 'arrow-left-right-bold-outline', c: 'F9C0' },
  { n: 'arrow-left-thick', c: 'F04E' },
  { n: 'arrow-right', c: 'F054' },
  { n: 'arrow-right-bold', c: 'F733' },
  { n: 'arrow-right-bold-box', c: 'F734' },
  { n: 'arrow-right-bold-box-outline', c: 'F735' },
  { n: 'arrow-right-bold-circle', c: 'F056' },
  { n: 'arrow-right-bold-circle-outline', c: 'F057' },
  { n: 'arrow-right-bold-hexagon-outline', c: 'F058' },
  { n: 'arrow-right-bold-outline', c: 'F9C1' },
  { n: 'arrow-right-box', c: 'F6C1' },
  { n: 'arrow-right-circle', c: 'FCBB' },
  { n: 'arrow-right-circle-outline', c: 'FCBC' },
  { n: 'arrow-right-drop-circle', c: 'F059' },
  { n: 'arrow-right-drop-circle-outline', c: 'F05A' },
  { n: 'arrow-right-thick', c: 'F055' },
  { n: 'arrow-split-horizontal', c: 'F93A' },
  { n: 'arrow-split-vertical', c: 'F93B' },
  { n: 'arrow-top-left', c: 'F05B' },
  { n: 'arrow-top-left-bold-outline', c: 'F9C2' },
  { n: 'arrow-top-left-thick', c: 'F9C3' },
  { n: 'arrow-top-right', c: 'F05C' },
  { n: 'arrow-top-right-bold-outline', c: 'F9C4' },
  { n: 'arrow-top-right-thick', c: 'F9C5' },
  { n: 'arrow-up', c: 'F05D' },
  { n: 'arrow-up-bold', c: 'F736' },
  { n: 'arrow-up-bold-box', c: 'F737' },
  { n: 'arrow-up-bold-box-outline', c: 'F738' },
  { n: 'arrow-up-bold-circle', c: 'F05F' },
  { n: 'arrow-up-bold-circle-outline', c: 'F060' },
  { n: 'arrow-up-bold-hexagon-outline', c: 'F061' },
  { n: 'arrow-up-bold-outline', c: 'F9C6' },
  { n: 'arrow-up-box', c: 'F6C2' },
  { n: 'arrow-up-circle', c: 'FCBD' },
  { n: 'arrow-up-circle-outline', c: 'FCBE' },
  { n: 'arrow-up-down-bold-outline', c: 'F9C7' },
  { n: 'arrow-up-drop-circle', c: 'F062' },
  { n: 'arrow-up-drop-circle-outline', c: 'F063' },
  { n: 'arrow-up-thick', c: 'F05E' },
  { n: 'artist', c: 'F802' },
  { n: 'artist-outline', c: 'FCC5' },
  { n: 'artstation', c: 'FB37' },
  { n: 'aspect-ratio', c: 'FA23' },
  { n: 'assistant', c: 'F064' },
  { n: 'asterisk', c: 'F6C3' },
  { n: 'at', c: 'F065' },
  { n: 'atlassian', c: 'F803' },
  { n: 'atm', c: 'FD23' },
  { n: 'atom', c: 'F767' },
  { n: 'attachment', c: 'F066' },
  { n: 'audio-video', c: 'F93C' },
  { n: 'audiobook', c: 'F067' },
  { n: 'augmented-reality', c: 'F84F' },
  { n: 'auto-fix', c: 'F068' },
  { n: 'auto-upload', c: 'F069' },
  { n: 'autorenew', c: 'F06A' },
  { n: 'av-timer', c: 'F06B' },
  { n: 'axe', c: 'F8C7' },
  { n: 'axis', c: 'FD24' },
  { n: 'axis-arrow', c: 'FD25' },
  { n: 'axis-arrow-lock', c: 'FD26' },
  { n: 'axis-lock', c: 'FD27' },
  { n: 'axis-x-arrow', c: 'FD28' },
  { n: 'axis-x-arrow-lock', c: 'FD29' },
  { n: 'axis-x-rotate-clockwise', c: 'FD2A' },
  { n: 'axis-x-rotate-counterclockwise', c: 'FD2B' },
  { n: 'axis-x-y-arrow-lock', c: 'FD2C' },
  { n: 'axis-y-arrow', c: 'FD2D' },
  { n: 'axis-y-arrow-lock', c: 'FD2E' },
  { n: 'axis-y-rotate-clockwise', c: 'FD2F' },
  { n: 'axis-y-rotate-counterclockwise', c: 'FD30' },
  { n: 'axis-z-arrow', c: 'FD31' },
  { n: 'axis-z-arrow-lock', c: 'FD32' },
  { n: 'axis-z-rotate-clockwise', c: 'FD33' },
  { n: 'axis-z-rotate-counterclockwise', c: 'FD34' },
  { n: 'azure', c: 'F804' },
  { n: 'babel', c: 'FA24' },
  { n: 'baby', c: 'F06C' },
  { n: 'baby-buggy', c: 'F68E' },
  { n: 'backburger', c: 'F06D' },
  { n: 'backspace', c: 'F06E' },
  { n: 'backspace-outline', c: 'FB38' },
  { n: 'backup-restore', c: 'F06F' },
  { n: 'badminton', c: 'F850' },
  { n: 'balloon', c: 'FA25' },
  { n: 'ballot', c: 'F9C8' },
  { n: 'ballot-outline', c: 'F9C9' },
  { n: 'ballot-recount', c: 'FC15' },
  { n: 'ballot-recount-outline', c: 'FC16' },
  { n: 'bandage', c: 'FD8B' },
  { n: 'bandcamp', c: 'F674' },
  { n: 'bank', c: 'F070' },
  { n: 'bank-minus', c: 'FD8C' },
  { n: 'bank-plus', c: 'FD8D' },
  { n: 'bank-remove', c: 'FD8E' },
  { n: 'bank-transfer', c: 'FA26' },
  { n: 'bank-transfer-in', c: 'FA27' },
  { n: 'bank-transfer-out', c: 'FA28' },
  { n: 'barcode', c: 'F071' },
  { n: 'barcode-scan', c: 'F072' },
  { n: 'barley', c: 'F073' },
  { n: 'barley-off', c: 'FB39' },
  { n: 'barn', c: 'FB3A' },
  { n: 'barrel', c: 'F074' },
  { n: 'baseball', c: 'F851' },
  { n: 'baseball-bat', c: 'F852' },
  { n: 'basecamp', c: 'F075' },
  { n: 'basket', c: 'F076' },
  { n: 'basket-fill', c: 'F077' },
  { n: 'basket-unfill', c: 'F078' },
  { n: 'basketball', c: 'F805' },
  { n: 'basketball-hoop', c: 'FC17' },
  { n: 'basketball-hoop-outline', c: 'FC18' },
  { n: 'bat', c: 'FB3B' },
  { n: 'battery', c: 'F079' },
  { n: 'battery-10', c: 'F07A' },
  { n: 'battery-10-bluetooth', c: 'F93D' },
  { n: 'battery-20', c: 'F07B' },
  { n: 'battery-20-bluetooth', c: 'F93E' },
  { n: 'battery-30', c: 'F07C' },
  { n: 'battery-30-bluetooth', c: 'F93F' },
  { n: 'battery-40', c: 'F07D' },
  { n: 'battery-40-bluetooth', c: 'F940' },
  { n: 'battery-50', c: 'F07E' },
  { n: 'battery-50-bluetooth', c: 'F941' },
  { n: 'battery-60', c: 'F07F' },
  { n: 'battery-60-bluetooth', c: 'F942' },
  { n: 'battery-70', c: 'F080' },
  { n: 'battery-70-bluetooth', c: 'F943' },
  { n: 'battery-80', c: 'F081' },
  { n: 'battery-80-bluetooth', c: 'F944' },
  { n: 'battery-90', c: 'F082' },
  { n: 'battery-90-bluetooth', c: 'F945' },
  { n: 'battery-alert', c: 'F083' },
  { n: 'battery-alert-bluetooth', c: 'F946' },
  { n: 'battery-bluetooth', c: 'F947' },
  { n: 'battery-bluetooth-variant', c: 'F948' },
  { n: 'battery-charging', c: 'F084' },
  { n: 'battery-charging-10', c: 'F89B' },
  { n: 'battery-charging-100', c: 'F085' },
  { n: 'battery-charging-20', c: 'F086' },
  { n: 'battery-charging-30', c: 'F087' },
  { n: 'battery-charging-40', c: 'F088' },
  { n: 'battery-charging-50', c: 'F89C' },
  { n: 'battery-charging-60', c: 'F089' },
  { n: 'battery-charging-70', c: 'F89D' },
  { n: 'battery-charging-80', c: 'F08A' },
  { n: 'battery-charging-90', c: 'F08B' },
  { n: 'battery-charging-outline', c: 'F89E' },
  { n: 'battery-charging-wireless', c: 'F806' },
  { n: 'battery-charging-wireless-10', c: 'F807' },
  { n: 'battery-charging-wireless-20', c: 'F808' },
  { n: 'battery-charging-wireless-30', c: 'F809' },
  { n: 'battery-charging-wireless-40', c: 'F80A' },
  { n: 'battery-charging-wireless-50', c: 'F80B' },
  { n: 'battery-charging-wireless-60', c: 'F80C' },
  { n: 'battery-charging-wireless-70', c: 'F80D' },
  { n: 'battery-charging-wireless-80', c: 'F80E' },
  { n: 'battery-charging-wireless-90', c: 'F80F' },
  { n: 'battery-charging-wireless-alert', c: 'F810' },
  { n: 'battery-charging-wireless-outline', c: 'F811' },
  { n: 'battery-minus', c: 'F08C' },
  { n: 'battery-negative', c: 'F08D' },
  { n: 'battery-outline', c: 'F08E' },
  { n: 'battery-plus', c: 'F08F' },
  { n: 'battery-positive', c: 'F090' },
  { n: 'battery-unknown', c: 'F091' },
  { n: 'battery-unknown-bluetooth', c: 'F949' },
  { n: 'battlenet', c: 'FB3C' },
  { n: 'beach', c: 'F092' },
  { n: 'beaker', c: 'FCC6' },
  { n: 'beaker-outline', c: 'F68F' },
  { n: 'beats', c: 'F097' },
  { n: 'bed-empty', c: 'F89F' },
  { n: 'beer', c: 'F098' },
  { n: 'behance', c: 'F099' },
  { n: 'bell', c: 'F09A' },
  { n: 'bell-alert', c: 'FD35' },
  { n: 'bell-circle', c: 'FD36' },
  { n: 'bell-circle-outline', c: 'FD37' },
  { n: 'bell-off', c: 'F09B' },
  { n: 'bell-off-outline', c: 'FA90' },
  { n: 'bell-outline', c: 'F09C' },
  { n: 'bell-plus', c: 'F09D' },
  { n: 'bell-plus-outline', c: 'FA91' },
  { n: 'bell-ring', c: 'F09E' },
  { n: 'bell-ring-outline', c: 'F09F' },
  { n: 'bell-sleep', c: 'F0A0' },
  { n: 'bell-sleep-outline', c: 'FA92' },
  { n: 'beta', c: 'F0A1' },
  { n: 'betamax', c: 'F9CA' },
  { n: 'bible', c: 'F0A2' },
  { n: 'bike', c: 'F0A3' },
  { n: 'billiards', c: 'FB3D' },
  { n: 'billiards-rack', c: 'FB3E' },
  { n: 'bing', c: 'F0A4' },
  { n: 'binoculars', c: 'F0A5' },
  { n: 'bio', c: 'F0A6' },
  { n: 'biohazard', c: 'F0A7' },
  { n: 'bitbucket', c: 'F0A8' },
  { n: 'bitcoin', c: 'F812' },
  { n: 'black-mesa', c: 'F0A9' },
  { n: 'blackberry', c: 'F0AA' },
  { n: 'blender', c: 'FCC7' },
  { n: 'blender-software', c: 'F0AB' },
  { n: 'blinds', c: 'F0AC' },
  { n: 'block-helper', c: 'F0AD' },
  { n: 'blogger', c: 'F0AE' },
  { n: 'blood-bag', c: 'FCC8' },
  { n: 'bluetooth', c: 'F0AF' },
  { n: 'bluetooth-audio', c: 'F0B0' },
  { n: 'bluetooth-connect', c: 'F0B1' },
  { n: 'bluetooth-off', c: 'F0B2' },
  { n: 'bluetooth-settings', c: 'F0B3' },
  { n: 'bluetooth-transfer', c: 'F0B4' },
  { n: 'blur', c: 'F0B5' },
  { n: 'blur-linear', c: 'F0B6' },
  { n: 'blur-off', c: 'F0B7' },
  { n: 'blur-radial', c: 'F0B8' },
  { n: 'bolnisi-cross', c: 'FCC9' },
  { n: 'bolt', c: 'FD8F' },
  { n: 'bomb', c: 'F690' },
  { n: 'bomb-off', c: 'F6C4' },
  { n: 'bone', c: 'F0B9' },
  { n: 'book', c: 'F0BA' },
  { n: 'book-lock', c: 'F799' },
  { n: 'book-lock-open', c: 'F79A' },
  { n: 'book-minus', c: 'F5D9' },
  { n: 'book-multiple', c: 'F0BB' },
  { n: 'book-multiple-minus', c: 'FA93' },
  { n: 'book-multiple-plus', c: 'FA94' },
  { n: 'book-multiple-remove', c: 'FA95' },
  { n: 'book-multiple-variant', c: 'F0BC' },
  { n: 'book-open', c: 'F0BD' },
  { n: 'book-open-outline', c: 'FB3F' },
  { n: 'book-open-page-variant', c: 'F5DA' },
  { n: 'book-open-variant', c: 'F0BE' },
  { n: 'book-outline', c: 'FB40' },
  { n: 'book-plus', c: 'F5DB' },
  { n: 'book-remove', c: 'FA96' },
  { n: 'book-variant', c: 'F0BF' },
  { n: 'bookmark', c: 'F0C0' },
  { n: 'bookmark-check', c: 'F0C1' },
  { n: 'bookmark-minus', c: 'F9CB' },
  { n: 'bookmark-minus-outline', c: 'F9CC' },
  { n: 'bookmark-music', c: 'F0C2' },
  { n: 'bookmark-off', c: 'F9CD' },
  { n: 'bookmark-off-outline', c: 'F9CE' },
  { n: 'bookmark-outline', c: 'F0C3' },
  { n: 'bookmark-plus', c: 'F0C5' },
  { n: 'bookmark-plus-outline', c: 'F0C4' },
  { n: 'bookmark-remove', c: 'F0C6' },
  { n: 'boombox', c: 'F5DC' },
  { n: 'bootstrap', c: 'F6C5' },
  { n: 'border-all', c: 'F0C7' },
  { n: 'border-all-variant', c: 'F8A0' },
  { n: 'border-bottom', c: 'F0C8' },
  { n: 'border-bottom-variant', c: 'F8A1' },
  { n: 'border-color', c: 'F0C9' },
  { n: 'border-horizontal', c: 'F0CA' },
  { n: 'border-inside', c: 'F0CB' },
  { n: 'border-left', c: 'F0CC' },
  { n: 'border-left-variant', c: 'F8A2' },
  { n: 'border-none', c: 'F0CD' },
  { n: 'border-none-variant', c: 'F8A3' },
  { n: 'border-outside', c: 'F0CE' },
  { n: 'border-right', c: 'F0CF' },
  { n: 'border-right-variant', c: 'F8A4' },
  { n: 'border-style', c: 'F0D0' },
  { n: 'border-top', c: 'F0D1' },
  { n: 'border-top-variant', c: 'F8A5' },
  { n: 'border-vertical', c: 'F0D2' },
  { n: 'bottle-wine', c: 'F853' },
  { n: 'bow-tie', c: 'F677' },
  { n: 'bowl', c: 'F617' },
  { n: 'bowling', c: 'F0D3' },
  { n: 'box', c: 'F0D4' },
  { n: 'box-cutter', c: 'F0D5' },
  { n: 'box-shadow', c: 'F637' },
  { n: 'boxing-glove', c: 'FB41' },
  { n: 'braille', c: 'F9CF' },
  { n: 'brain', c: 'F9D0' },
  { n: 'bread-slice', c: 'FCCA' },
  { n: 'bread-slice-outline', c: 'FCCB' },
  { n: 'bridge', c: 'F618' },
  { n: 'briefcase', c: 'F0D6' },
  { n: 'briefcase-account', c: 'FCCC' },
  { n: 'briefcase-account-outline', c: 'FCCD' },
  { n: 'briefcase-check', c: 'F0D7' },
  { n: 'briefcase-download', c: 'F0D8' },
  { n: 'briefcase-download-outline', c: 'FC19' },
  { n: 'briefcase-edit', c: 'FA97' },
  { n: 'briefcase-edit-outline', c: 'FC1A' },
  { n: 'briefcase-minus', c: 'FA29' },
  { n: 'briefcase-minus-outline', c: 'FC1B' },
  { n: 'briefcase-outline', c: 'F813' },
  { n: 'briefcase-plus', c: 'FA2A' },
  { n: 'briefcase-plus-outline', c: 'FC1C' },
  { n: 'briefcase-remove', c: 'FA2B' },
  { n: 'briefcase-remove-outline', c: 'FC1D' },
  { n: 'briefcase-search', c: 'FA2C' },
  { n: 'briefcase-search-outline', c: 'FC1E' },
  { n: 'briefcase-upload', c: 'F0D9' },
  { n: 'briefcase-upload-outline', c: 'FC1F' },
  { n: 'brightness-1', c: 'F0DA' },
  { n: 'brightness-2', c: 'F0DB' },
  { n: 'brightness-3', c: 'F0DC' },
  { n: 'brightness-4', c: 'F0DD' },
  { n: 'brightness-5', c: 'F0DE' },
  { n: 'brightness-6', c: 'F0DF' },
  { n: 'brightness-7', c: 'F0E0' },
  { n: 'brightness-auto', c: 'F0E1' },
  { n: 'brightness-percent', c: 'FCCE' },
  { n: 'broom', c: 'F0E2' },
  { n: 'brush', c: 'F0E3' },
  { n: 'buddhism', c: 'F94A' },
  { n: 'buffer', c: 'F619' },
  { n: 'bug', c: 'F0E4' },
  { n: 'bug-check', c: 'FA2D' },
  { n: 'bug-check-outline', c: 'FA2E' },
  { n: 'bug-outline', c: 'FA2F' },
  { n: 'bugle', c: 'FD90' },
  { n: 'bulldozer', c: 'FB07' },
  { n: 'bullet', c: 'FCCF' },
  { n: 'bulletin-board', c: 'F0E5' },
  { n: 'bullhorn', c: 'F0E6' },
  { n: 'bullhorn-outline', c: 'FB08' },
  { n: 'bullseye', c: 'F5DD' },
  { n: 'bullseye-arrow', c: 'F8C8' },
  { n: 'bus', c: 'F0E7' },
  { n: 'bus-alert', c: 'FA98' },
  { n: 'bus-articulated-end', c: 'F79B' },
  { n: 'bus-articulated-front', c: 'F79C' },
  { n: 'bus-clock', c: 'F8C9' },
  { n: 'bus-double-decker', c: 'F79D' },
  { n: 'bus-school', c: 'F79E' },
  { n: 'bus-side', c: 'F79F' },
  { n: 'cached', c: 'F0E8' },
  { n: 'cactus', c: 'FD91' },
  { n: 'cake', c: 'F0E9' },
  { n: 'cake-layered', c: 'F0EA' },
  { n: 'cake-variant', c: 'F0EB' },
  { n: 'calculator', c: 'F0EC' },
  { n: 'calculator-variant', c: 'FA99' },
  { n: 'calendar', c: 'F0ED' },
  { n: 'calendar-alert', c: 'FA30' },
  { n: 'calendar-blank', c: 'F0EE' },
  { n: 'calendar-blank-outline', c: 'FB42' },
  { n: 'calendar-check', c: 'F0EF' },
  { n: 'calendar-check-outline', c: 'FC20' },
  { n: 'calendar-clock', c: 'F0F0' },
  { n: 'calendar-edit', c: 'F8A6' },
  { n: 'calendar-export', c: 'FB09' },
  { n: 'calendar-heart', c: 'F9D1' },
  { n: 'calendar-import', c: 'FB0A' },
  { n: 'calendar-minus', c: 'FD38' },
  { n: 'calendar-multiple', c: 'F0F1' },
  { n: 'calendar-multiple-check', c: 'F0F2' },
  { n: 'calendar-multiselect', c: 'FA31' },
  { n: 'calendar-outline', c: 'FB43' },
  { n: 'calendar-plus', c: 'F0F3' },
  { n: 'calendar-question', c: 'F691' },
  { n: 'calendar-range', c: 'F678' },
  { n: 'calendar-range-outline', c: 'FB44' },
  { n: 'calendar-remove', c: 'F0F4' },
  { n: 'calendar-remove-outline', c: 'FC21' },
  { n: 'calendar-search', c: 'F94B' },
  { n: 'calendar-star', c: 'F9D2' },
  { n: 'calendar-text', c: 'F0F5' },
  { n: 'calendar-text-outline', c: 'FC22' },
  { n: 'calendar-today', c: 'F0F6' },
  { n: 'calendar-week', c: 'FA32' },
  { n: 'calendar-week-begin', c: 'FA33' },
  { n: 'call-made', c: 'F0F7' },
  { n: 'call-merge', c: 'F0F8' },
  { n: 'call-missed', c: 'F0F9' },
  { n: 'call-received', c: 'F0FA' },
  { n: 'call-split', c: 'F0FB' },
  { n: 'camcorder', c: 'F0FC' },
  { n: 'camcorder-box', c: 'F0FD' },
  { n: 'camcorder-box-off', c: 'F0FE' },
  { n: 'camcorder-off', c: 'F0FF' },
  { n: 'camera', c: 'F100' },
  { n: 'camera-account', c: 'F8CA' },
  { n: 'camera-burst', c: 'F692' },
  { n: 'camera-control', c: 'FB45' },
  { n: 'camera-enhance', c: 'F101' },
  { n: 'camera-enhance-outline', c: 'FB46' },
  { n: 'camera-front', c: 'F102' },
  { n: 'camera-front-variant', c: 'F103' },
  { n: 'camera-gopro', c: 'F7A0' },
  { n: 'camera-image', c: 'F8CB' },
  { n: 'camera-iris', c: 'F104' },
  { n: 'camera-metering-center', c: 'F7A1' },
  { n: 'camera-metering-matrix', c: 'F7A2' },
  { n: 'camera-metering-partial', c: 'F7A3' },
  { n: 'camera-metering-spot', c: 'F7A4' },
  { n: 'camera-off', c: 'F5DF' },
  { n: 'camera-outline', c: 'FD39' },
  { n: 'camera-party-mode', c: 'F105' },
  { n: 'camera-rear', c: 'F106' },
  { n: 'camera-rear-variant', c: 'F107' },
  { n: 'camera-switch', c: 'F108' },
  { n: 'camera-timer', c: 'F109' },
  { n: 'camera-wireless', c: 'FD92' },
  { n: 'camera-wireless-outline', c: 'FD93' },
  { n: 'cancel', c: 'F739' },
  { n: 'candle', c: 'F5E2' },
  { n: 'candycane', c: 'F10A' },
  { n: 'cannabis', c: 'F7A5' },
  { n: 'caps-lock', c: 'FA9A' },
  { n: 'car', c: 'F10B' },
  { n: 'car-battery', c: 'F10C' },
  { n: 'car-brake-abs', c: 'FC23' },
  { n: 'car-brake-alert', c: 'FC24' },
  { n: 'car-brake-hold', c: 'FD3A' },
  { n: 'car-brake-parking', c: 'FD3B' },
  { n: 'car-connected', c: 'F10D' },
  { n: 'car-convertible', c: 'F7A6' },
  { n: 'car-cruise-control', c: 'FD3C' },
  { n: 'car-defrost-front', c: 'FD3D' },
  { n: 'car-defrost-rear', c: 'FD3E' },
  { n: 'car-door', c: 'FB47' },
  { n: 'car-electric', c: 'FB48' },
  { n: 'car-esp', c: 'FC25' },
  { n: 'car-estate', c: 'F7A7' },
  { n: 'car-hatchback', c: 'F7A8' },
  { n: 'car-key', c: 'FB49' },
  { n: 'car-light-dimmed', c: 'FC26' },
  { n: 'car-light-fog', c: 'FC27' },
  { n: 'car-light-high', c: 'FC28' },
  { n: 'car-limousine', c: 'F8CC' },
  { n: 'car-multiple', c: 'FB4A' },
  { n: 'car-parking-lights', c: 'FD3F' },
  { n: 'car-pickup', c: 'F7A9' },
  { n: 'car-side', c: 'F7AA' },
  { n: 'car-sports', c: 'F7AB' },
  { n: 'car-tire-alert', c: 'FC29' },
  { n: 'car-traction-control', c: 'FD40' },
  { n: 'car-wash', c: 'F10E' },
  { n: 'caravan', c: 'F7AC' },
  { n: 'card', c: 'FB4B' },
  { n: 'card-bulleted', c: 'FB4C' },
  { n: 'card-bulleted-off', c: 'FB4D' },
  { n: 'card-bulleted-off-outline', c: 'FB4E' },
  { n: 'card-bulleted-outline', c: 'FB4F' },
  { n: 'card-bulleted-settings', c: 'FB50' },
  { n: 'card-bulleted-settings-outline', c: 'FB51' },
  { n: 'card-outline', c: 'FB52' },
  { n: 'card-text', c: 'FB53' },
  { n: 'card-text-outline', c: 'FB54' },
  { n: 'cards', c: 'F638' },
  { n: 'cards-club', c: 'F8CD' },
  { n: 'cards-diamond', c: 'F8CE' },
  { n: 'cards-heart', c: 'F8CF' },
  { n: 'cards-outline', c: 'F639' },
  { n: 'cards-playing-outline', c: 'F63A' },
  { n: 'cards-spade', c: 'F8D0' },
  { n: 'cards-variant', c: 'F6C6' },
  { n: 'carrot', c: 'F10F' },
  { n: 'carry-on-bag-check', c: 'FD41' },
  { n: 'cart', c: 'F110' },
  { n: 'cart-arrow-down', c: 'FD42' },
  { n: 'cart-arrow-right', c: 'FC2A' },
  { n: 'cart-arrow-up', c: 'FD43' },
  { n: 'cart-minus', c: 'FD44' },
  { n: 'cart-off', c: 'F66B' },
  { n: 'cart-outline', c: 'F111' },
  { n: 'cart-plus', c: 'F112' },
  { n: 'cart-remove', c: 'FD45' },
  { n: 'case-sensitive-alt', c: 'F113' },
  { n: 'cash', c: 'F114' },
  { n: 'cash-100', c: 'F115' },
  { n: 'cash-marker', c: 'FD94' },
  { n: 'cash-multiple', c: 'F116' },
  { n: 'cash-refund', c: 'FA9B' },
  { n: 'cash-register', c: 'FCD0' },
  { n: 'cash-usd', c: 'F117' },
  { n: 'cassette', c: 'F9D3' },
  { n: 'cast', c: 'F118' },
  { n: 'cast-connected', c: 'F119' },
  { n: 'cast-off', c: 'F789' },
  { n: 'castle', c: 'F11A' },
  { n: 'cat', c: 'F11B' },
  { n: 'cctv', c: 'F7AD' },
  { n: 'ceiling-light', c: 'F768' },
  { n: 'cellphone', c: 'F11C' },
  { n: 'cellphone-android', c: 'F11D' },
  { n: 'cellphone-arrow-down', c: 'F9D4' },
  { n: 'cellphone-basic', c: 'F11E' },
  { n: 'cellphone-dock', c: 'F11F' },
  { n: 'cellphone-erase', c: 'F94C' },
  { n: 'cellphone-iphone', c: 'F120' },
  { n: 'cellphone-key', c: 'F94D' },
  { n: 'cellphone-link', c: 'F121' },
  { n: 'cellphone-link-off', c: 'F122' },
  { n: 'cellphone-lock', c: 'F94E' },
  { n: 'cellphone-message', c: 'F8D2' },
  { n: 'cellphone-off', c: 'F94F' },
  { n: 'cellphone-screenshot', c: 'FA34' },
  { n: 'cellphone-settings', c: 'F123' },
  { n: 'cellphone-settings-variant', c: 'F950' },
  { n: 'cellphone-sound', c: 'F951' },
  { n: 'cellphone-text', c: 'F8D1' },
  { n: 'cellphone-wireless', c: 'F814' },
  { n: 'celtic-cross', c: 'FCD1' },
  { n: 'certificate', c: 'F124' },
  { n: 'chair-school', c: 'F125' },
  { n: 'charity', c: 'FC2B' },
  { n: 'chart-arc', c: 'F126' },
  { n: 'chart-areaspline', c: 'F127' },
  { n: 'chart-bar', c: 'F128' },
  { n: 'chart-bar-stacked', c: 'F769' },
  { n: 'chart-bell-curve', c: 'FC2C' },
  { n: 'chart-bubble', c: 'F5E3' },
  { n: 'chart-donut', c: 'F7AE' },
  { n: 'chart-donut-variant', c: 'F7AF' },
  { n: 'chart-gantt', c: 'F66C' },
  { n: 'chart-histogram', c: 'F129' },
  { n: 'chart-line', c: 'F12A' },
  { n: 'chart-line-stacked', c: 'F76A' },
  { n: 'chart-line-variant', c: 'F7B0' },
  { n: 'chart-multiline', c: 'F8D3' },
  { n: 'chart-pie', c: 'F12B' },
  { n: 'chart-scatterplot-hexbin', c: 'F66D' },
  { n: 'chart-timeline', c: 'F66E' },
  { n: 'chat', c: 'FB55' },
  { n: 'chat-alert', c: 'FB56' },
  { n: 'chat-processing', c: 'FB57' },
  { n: 'check', c: 'F12C' },
  { n: 'check-all', c: 'F12D' },
  { n: 'check-box-multiple-outline', c: 'FC2D' },
  { n: 'check-box-outline', c: 'FC2E' },
  { n: 'check-circle', c: 'F5E0' },
  { n: 'check-circle-outline', c: 'F5E1' },
  { n: 'check-decagram', c: 'F790' },
  { n: 'check-network', c: 'FC2F' },
  { n: 'check-network-outline', c: 'FC30' },
  { n: 'check-outline', c: 'F854' },
  { n: 'checkbook', c: 'FA9C' },
  { n: 'checkbox-blank', c: 'F12E' },
  { n: 'checkbox-blank-circle', c: 'F12F' },
  { n: 'checkbox-blank-circle-outline', c: 'F130' },
  { n: 'checkbox-blank-outline', c: 'F131' },
  { n: 'checkbox-intermediate', c: 'F855' },
  { n: 'checkbox-marked', c: 'F132' },
  { n: 'checkbox-marked-circle', c: 'F133' },
  { n: 'checkbox-marked-circle-outline', c: 'F134' },
  { n: 'checkbox-marked-outline', c: 'F135' },
  { n: 'checkbox-multiple-blank', c: 'F136' },
  { n: 'checkbox-multiple-blank-circle', c: 'F63B' },
  { n: 'checkbox-multiple-blank-circle-outline', c: 'F63C' },
  { n: 'checkbox-multiple-blank-outline', c: 'F137' },
  { n: 'checkbox-multiple-marked', c: 'F138' },
  { n: 'checkbox-multiple-marked-circle', c: 'F63D' },
  { n: 'checkbox-multiple-marked-circle-outline', c: 'F63E' },
  { n: 'checkbox-multiple-marked-outline', c: 'F139' },
  { n: 'checkerboard', c: 'F13A' },
  { n: 'chef-hat', c: 'FB58' },
  { n: 'chemical-weapon', c: 'F13B' },
  { n: 'chess-bishop', c: 'F85B' },
  { n: 'chess-king', c: 'F856' },
  { n: 'chess-knight', c: 'F857' },
  { n: 'chess-pawn', c: 'F858' },
  { n: 'chess-queen', c: 'F859' },
  { n: 'chess-rook', c: 'F85A' },
  { n: 'chevron-double-down', c: 'F13C' },
  { n: 'chevron-double-left', c: 'F13D' },
  { n: 'chevron-double-right', c: 'F13E' },
  { n: 'chevron-double-up', c: 'F13F' },
  { n: 'chevron-down', c: 'F140' },
  { n: 'chevron-down-box', c: 'F9D5' },
  { n: 'chevron-down-box-outline', c: 'F9D6' },
  { n: 'chevron-down-circle', c: 'FB0B' },
  { n: 'chevron-down-circle-outline', c: 'FB0C' },
  { n: 'chevron-left', c: 'F141' },
  { n: 'chevron-left-box', c: 'F9D7' },
  { n: 'chevron-left-box-outline', c: 'F9D8' },
  { n: 'chevron-left-circle', c: 'FB0D' },
  { n: 'chevron-left-circle-outline', c: 'FB0E' },
  { n: 'chevron-right', c: 'F142' },
  { n: 'chevron-right-box', c: 'F9D9' },
  { n: 'chevron-right-box-outline', c: 'F9DA' },
  { n: 'chevron-right-circle', c: 'FB0F' },
  { n: 'chevron-right-circle-outline', c: 'FB10' },
  { n: 'chevron-triple-down', c: 'FD95' },
  { n: 'chevron-triple-left', c: 'FD96' },
  { n: 'chevron-triple-right', c: 'FD97' },
  { n: 'chevron-triple-up', c: 'FD98' },
  { n: 'chevron-up', c: 'F143' },
  { n: 'chevron-up-box', c: 'F9DB' },
  { n: 'chevron-up-box-outline', c: 'F9DC' },
  { n: 'chevron-up-circle', c: 'FB11' },
  { n: 'chevron-up-circle-outline', c: 'FB12' },
  { n: 'chili-hot', c: 'F7B1' },
  { n: 'chili-medium', c: 'F7B2' },
  { n: 'chili-mild', c: 'F7B3' },
  { n: 'chip', c: 'F61A' },
  { n: 'christianity', c: 'F952' },
  { n: 'christianity-outline', c: 'FCD2' },
  { n: 'church', c: 'F144' },
  { n: 'circle', c: 'F764' },
  { n: 'circle-edit-outline', c: 'F8D4' },
  { n: 'circle-medium', c: 'F9DD' },
  { n: 'circle-outline', c: 'F765' },
  { n: 'circle-slice-1', c: 'FA9D' },
  { n: 'circle-slice-2', c: 'FA9E' },
  { n: 'circle-slice-3', c: 'FA9F' },
  { n: 'circle-slice-4', c: 'FAA0' },
  { n: 'circle-slice-5', c: 'FAA1' },
  { n: 'circle-slice-6', c: 'FAA2' },
  { n: 'circle-slice-7', c: 'FAA3' },
  { n: 'circle-slice-8', c: 'FAA4' },
  { n: 'circle-small', c: 'F9DE' },
  { n: 'cisco-webex', c: 'F145' },
  { n: 'city', c: 'F146' },
  { n: 'city-variant', c: 'FA35' },
  { n: 'city-variant-outline', c: 'FA36' },
  { n: 'clipboard', c: 'F147' },
  { n: 'clipboard-account', c: 'F148' },
  { n: 'clipboard-account-outline', c: 'FC31' },
  { n: 'clipboard-alert', c: 'F149' },
  { n: 'clipboard-alert-outline', c: 'FCD3' },
  { n: 'clipboard-arrow-down', c: 'F14A' },
  { n: 'clipboard-arrow-down-outline', c: 'FC32' },
  { n: 'clipboard-arrow-left', c: 'F14B' },
  { n: 'clipboard-arrow-left-outline', c: 'FCD4' },
  { n: 'clipboard-arrow-right', c: 'FCD5' },
  { n: 'clipboard-arrow-right-outline', c: 'FCD6' },
  { n: 'clipboard-arrow-up', c: 'FC33' },
  { n: 'clipboard-arrow-up-outline', c: 'FC34' },
  { n: 'clipboard-check', c: 'F14C' },
  { n: 'clipboard-check-outline', c: 'F8A7' },
  { n: 'clipboard-flow', c: 'F6C7' },
  { n: 'clipboard-outline', c: 'F14D' },
  { n: 'clipboard-play', c: 'FC35' },
  { n: 'clipboard-play-outline', c: 'FC36' },
  { n: 'clipboard-plus', c: 'F750' },
  { n: 'clipboard-pulse', c: 'F85C' },
  { n: 'clipboard-pulse-outline', c: 'F85D' },
  { n: 'clipboard-text', c: 'F14E' },
  { n: 'clipboard-text-outline', c: 'FA37' },
  { n: 'clipboard-text-play', c: 'FC37' },
  { n: 'clipboard-text-play-outline', c: 'FC38' },
  { n: 'clippy', c: 'F14F' },
  { n: 'clock', c: 'F953' },
  { n: 'clock-alert', c: 'F954' },
  { n: 'clock-alert-outline', c: 'F5CE' },
  { n: 'clock-end', c: 'F151' },
  { n: 'clock-fast', c: 'F152' },
  { n: 'clock-in', c: 'F153' },
  { n: 'clock-out', c: 'F154' },
  { n: 'clock-outline', c: 'F150' },
  { n: 'clock-start', c: 'F155' },
  { n: 'close', c: 'F156' },
  { n: 'close-box', c: 'F157' },
  { n: 'close-box-multiple', c: 'FC39' },
  { n: 'close-box-multiple-outline', c: 'FC3A' },
  { n: 'close-box-outline', c: 'F158' },
  { n: 'close-circle', c: 'F159' },
  { n: 'close-circle-outline', c: 'F15A' },
  { n: 'close-network', c: 'F15B' },
  { n: 'close-network-outline', c: 'FC3B' },
  { n: 'close-octagon', c: 'F15C' },
  { n: 'close-octagon-outline', c: 'F15D' },
  { n: 'close-outline', c: 'F6C8' },
  { n: 'closed-caption', c: 'F15E' },
  { n: 'closed-caption-outline', c: 'FD99' },
  { n: 'cloud', c: 'F15F' },
  { n: 'cloud-alert', c: 'F9DF' },
  { n: 'cloud-braces', c: 'F7B4' },
  { n: 'cloud-check', c: 'F160' },
  { n: 'cloud-circle', c: 'F161' },
  { n: 'cloud-download', c: 'F162' },
  { n: 'cloud-download-outline', c: 'FB59' },
  { n: 'cloud-off-outline', c: 'F164' },
  { n: 'cloud-outline', c: 'F163' },
  { n: 'cloud-print', c: 'F165' },
  { n: 'cloud-print-outline', c: 'F166' },
  { n: 'cloud-question', c: 'FA38' },
  { n: 'cloud-search', c: 'F955' },
  { n: 'cloud-search-outline', c: 'F956' },
  { n: 'cloud-sync', c: 'F63F' },
  { n: 'cloud-tags', c: 'F7B5' },
  { n: 'cloud-upload', c: 'F167' },
  { n: 'cloud-upload-outline', c: 'FB5A' },
  { n: 'clover', c: 'F815' },
  { n: 'code-array', c: 'F168' },
  { n: 'code-braces', c: 'F169' },
  { n: 'code-brackets', c: 'F16A' },
  { n: 'code-equal', c: 'F16B' },
  { n: 'code-greater-than', c: 'F16C' },
  { n: 'code-greater-than-or-equal', c: 'F16D' },
  { n: 'code-less-than', c: 'F16E' },
  { n: 'code-less-than-or-equal', c: 'F16F' },
  { n: 'code-not-equal', c: 'F170' },
  { n: 'code-not-equal-variant', c: 'F171' },
  { n: 'code-parentheses', c: 'F172' },
  { n: 'code-string', c: 'F173' },
  { n: 'code-tags', c: 'F174' },
  { n: 'code-tags-check', c: 'F693' },
  { n: 'codepen', c: 'F175' },
  { n: 'coffee', c: 'F176' },
  { n: 'coffee-outline', c: 'F6C9' },
  { n: 'coffee-to-go', c: 'F177' },
  { n: 'coffin', c: 'FB5B' },
  { n: 'cogs', c: 'F8D5' },
  { n: 'coin', c: 'F178' },
  { n: 'coins', c: 'F694' },
  { n: 'collage', c: 'F640' },
  { n: 'collapse-all', c: 'FAA5' },
  { n: 'collapse-all-outline', c: 'FAA6' },
  { n: 'color-helper', c: 'F179' },
  { n: 'comment', c: 'F17A' },
  { n: 'comment-account', c: 'F17B' },
  { n: 'comment-account-outline', c: 'F17C' },
  { n: 'comment-alert', c: 'F17D' },
  { n: 'comment-alert-outline', c: 'F17E' },
  { n: 'comment-arrow-left', c: 'F9E0' },
  { n: 'comment-arrow-left-outline', c: 'F9E1' },
  { n: 'comment-arrow-right', c: 'F9E2' },
  { n: 'comment-arrow-right-outline', c: 'F9E3' },
  { n: 'comment-check', c: 'F17F' },
  { n: 'comment-check-outline', c: 'F180' },
  { n: 'comment-eye', c: 'FA39' },
  { n: 'comment-eye-outline', c: 'FA3A' },
  { n: 'comment-multiple', c: 'F85E' },
  { n: 'comment-multiple-outline', c: 'F181' },
  { n: 'comment-outline', c: 'F182' },
  { n: 'comment-plus', c: 'F9E4' },
  { n: 'comment-plus-outline', c: 'F183' },
  { n: 'comment-processing', c: 'F184' },
  { n: 'comment-processing-outline', c: 'F185' },
  { n: 'comment-question', c: 'F816' },
  { n: 'comment-question-outline', c: 'F186' },
  { n: 'comment-remove', c: 'F5DE' },
  { n: 'comment-remove-outline', c: 'F187' },
  { n: 'comment-search', c: 'FA3B' },
  { n: 'comment-search-outline', c: 'FA3C' },
  { n: 'comment-text', c: 'F188' },
  { n: 'comment-text-multiple', c: 'F85F' },
  { n: 'comment-text-multiple-outline', c: 'F860' },
  { n: 'comment-text-outline', c: 'F189' },
  { n: 'compare', c: 'F18A' },
  { n: 'compass', c: 'F18B' },
  { n: 'compass-off', c: 'FB5C' },
  { n: 'compass-off-outline', c: 'FB5D' },
  { n: 'compass-outline', c: 'F18C' },
  { n: 'console', c: 'F18D' },
  { n: 'console-line', c: 'F7B6' },
  { n: 'console-network', c: 'F8A8' },
  { n: 'console-network-outline', c: 'FC3C' },
  { n: 'contact-mail', c: 'F18E' },
  { n: 'contactless-payment', c: 'FD46' },
  { n: 'contacts', c: 'F6CA' },
  { n: 'contain', c: 'FA3D' },
  { n: 'contain-end', c: 'FA3E' },
  { n: 'contain-start', c: 'FA3F' },
  { n: 'content-copy', c: 'F18F' },
  { n: 'content-cut', c: 'F190' },
  { n: 'content-duplicate', c: 'F191' },
  { n: 'content-paste', c: 'F192' },
  { n: 'content-save', c: 'F193' },
  { n: 'content-save-all', c: 'F194' },
  { n: 'content-save-edit', c: 'FCD7' },
  { n: 'content-save-edit-outline', c: 'FCD8' },
  { n: 'content-save-outline', c: 'F817' },
  { n: 'content-save-settings', c: 'F61B' },
  { n: 'content-save-settings-outline', c: 'FB13' },
  { n: 'contrast', c: 'F195' },
  { n: 'contrast-box', c: 'F196' },
  { n: 'contrast-circle', c: 'F197' },
  { n: 'controller-classic', c: 'FB5E' },
  { n: 'controller-classic-outline', c: 'FB5F' },
  { n: 'cookie', c: 'F198' },
  { n: 'copyright', c: 'F5E6' },
  { n: 'cordova', c: 'F957' },
  { n: 'corn', c: 'F7B7' },
  { n: 'counter', c: 'F199' },
  { n: 'cow', c: 'F19A' },
  { n: 'crane', c: 'F861' },
  { n: 'creation', c: 'F1C9' },
  { n: 'creative-commons', c: 'FD47' },
  { n: 'credit-card', c: 'F19B' },
  { n: 'credit-card-marker', c: 'FD9A' },
  { n: 'credit-card-multiple', c: 'F19C' },
  { n: 'credit-card-off', c: 'F5E4' },
  { n: 'credit-card-plus', c: 'F675' },
  { n: 'credit-card-refund', c: 'FAA7' },
  { n: 'credit-card-scan', c: 'F19D' },
  { n: 'credit-card-settings', c: 'F8D6' },
  { n: 'credit-card-wireless', c: 'FD48' },
  { n: 'cricket', c: 'FD49' },
  { n: 'crop', c: 'F19E' },
  { n: 'crop-free', c: 'F19F' },
  { n: 'crop-landscape', c: 'F1A0' },
  { n: 'crop-portrait', c: 'F1A1' },
  { n: 'crop-rotate', c: 'F695' },
  { n: 'crop-square', c: 'F1A2' },
  { n: 'crosshairs', c: 'F1A3' },
  { n: 'crosshairs-gps', c: 'F1A4' },
  { n: 'crown', c: 'F1A5' },
  { n: 'cryengine', c: 'F958' },
  { n: 'crystal-ball', c: 'FB14' },
  { n: 'cube', c: 'F1A6' },
  { n: 'cube-outline', c: 'F1A7' },
  { n: 'cube-scan', c: 'FB60' },
  { n: 'cube-send', c: 'F1A8' },
  { n: 'cube-unfolded', c: 'F1A9' },
  { n: 'cup', c: 'F1AA' },
  { n: 'cup-off', c: 'F5E5' },
  { n: 'cup-water', c: 'F1AB' },
  { n: 'cupcake', c: 'F959' },
  { n: 'curling', c: 'F862' },
  { n: 'currency-bdt', c: 'F863' },
  { n: 'currency-brl', c: 'FB61' },
  { n: 'currency-btc', c: 'F1AC' },
  { n: 'currency-chf', c: 'F7B8' },
  { n: 'currency-cny', c: 'F7B9' },
  { n: 'currency-eth', c: 'F7BA' },
  { n: 'currency-eur', c: 'F1AD' },
  { n: 'currency-gbp', c: 'F1AE' },
  { n: 'currency-ils', c: 'FC3D' },
  { n: 'currency-inr', c: 'F1AF' },
  { n: 'currency-jpy', c: 'F7BB' },
  { n: 'currency-krw', c: 'F7BC' },
  { n: 'currency-kzt', c: 'F864' },
  { n: 'currency-ngn', c: 'F1B0' },
  { n: 'currency-php', c: 'F9E5' },
  { n: 'currency-rub', c: 'F1B1' },
  { n: 'currency-sign', c: 'F7BD' },
  { n: 'currency-try', c: 'F1B2' },
  { n: 'currency-twd', c: 'F7BE' },
  { n: 'currency-usd', c: 'F1B3' },
  { n: 'currency-usd-off', c: 'F679' },
  { n: 'current-ac', c: 'F95A' },
  { n: 'current-dc', c: 'F95B' },
  { n: 'cursor-default', c: 'F1B4' },
  { n: 'cursor-default-click', c: 'FCD9' },
  { n: 'cursor-default-click-outline', c: 'FCDA' },
  { n: 'cursor-default-outline', c: 'F1B5' },
  { n: 'cursor-move', c: 'F1B6' },
  { n: 'cursor-pointer', c: 'F1B7' },
  { n: 'cursor-text', c: 'F5E7' },
  { n: 'database', c: 'F1B8' },
  { n: 'database-check', c: 'FAA8' },
  { n: 'database-edit', c: 'FB62' },
  { n: 'database-export', c: 'F95D' },
  { n: 'database-import', c: 'F95C' },
  { n: 'database-lock', c: 'FAA9' },
  { n: 'database-minus', c: 'F1B9' },
  { n: 'database-plus', c: 'F1BA' },
  { n: 'database-refresh', c: 'FCDB' },
  { n: 'database-remove', c: 'FCDC' },
  { n: 'database-search', c: 'F865' },
  { n: 'database-settings', c: 'FCDD' },
  { n: 'death-star', c: 'F8D7' },
  { n: 'death-star-variant', c: 'F8D8' },
  { n: 'deathly-hallows', c: 'FB63' },
  { n: 'debian', c: 'F8D9' },
  { n: 'debug-step-into', c: 'F1BB' },
  { n: 'debug-step-out', c: 'F1BC' },
  { n: 'debug-step-over', c: 'F1BD' },
  { n: 'decagram', c: 'F76B' },
  { n: 'decagram-outline', c: 'F76C' },
  { n: 'decimal-decrease', c: 'F1BE' },
  { n: 'decimal-increase', c: 'F1BF' },
  { n: 'delete', c: 'F1C0' },
  { n: 'delete-circle', c: 'F682' },
  { n: 'delete-circle-outline', c: 'FB64' },
  { n: 'delete-empty', c: 'F6CB' },
  { n: 'delete-forever', c: 'F5E8' },
  { n: 'delete-forever-outline', c: 'FB65' },
  { n: 'delete-outline', c: 'F9E6' },
  { n: 'delete-restore', c: 'F818' },
  { n: 'delete-sweep', c: 'F5E9' },
  { n: 'delete-sweep-outline', c: 'FC3E' },
  { n: 'delete-variant', c: 'F1C1' },
  { n: 'delta', c: 'F1C2' },
  { n: 'desk-lamp', c: 'F95E' },
  { n: 'deskphone', c: 'F1C3' },
  { n: 'desktop-classic', c: 'F7BF' },
  { n: 'desktop-mac', c: 'F1C4' },
  { n: 'desktop-mac-dashboard', c: 'F9E7' },
  { n: 'desktop-tower', c: 'F1C5' },
  { n: 'desktop-tower-monitor', c: 'FAAA' },
  { n: 'details', c: 'F1C6' },
  { n: 'dev-to', c: 'FD4A' },
  { n: 'developer-board', c: 'F696' },
  { n: 'deviantart', c: 'F1C7' },
  { n: 'dialpad', c: 'F61C' },
  { n: 'diameter', c: 'FC3F' },
  { n: 'diameter-outline', c: 'FC40' },
  { n: 'diameter-variant', c: 'FC41' },
  { n: 'diamond', c: 'FB66' },
  { n: 'diamond-outline', c: 'FB67' },
  { n: 'diamond-stone', c: 'F1C8' },
  { n: 'dice-1', c: 'F1CA' },
  { n: 'dice-2', c: 'F1CB' },
  { n: 'dice-3', c: 'F1CC' },
  { n: 'dice-4', c: 'F1CD' },
  { n: 'dice-5', c: 'F1CE' },
  { n: 'dice-6', c: 'F1CF' },
  { n: 'dice-d10', c: 'F76E' },
  { n: 'dice-d12', c: 'F866' },
  { n: 'dice-d20', c: 'F5EA' },
  { n: 'dice-d4', c: 'F5EB' },
  { n: 'dice-d6', c: 'F5EC' },
  { n: 'dice-d8', c: 'F5ED' },
  { n: 'dice-multiple', c: 'F76D' },
  { n: 'dictionary', c: 'F61D' },
  { n: 'dip-switch', c: 'F7C0' },
  { n: 'directions', c: 'F1D0' },
  { n: 'directions-fork', c: 'F641' },
  { n: 'disc', c: 'F5EE' },
  { n: 'disc-alert', c: 'F1D1' },
  { n: 'disc-player', c: 'F95F' },
  { n: 'discord', c: 'F66F' },
  { n: 'dishwasher', c: 'FAAB' },
  { n: 'disqus', c: 'F1D2' },
  { n: 'disqus-outline', c: 'F1D3' },
  { n: 'diving-flippers', c: 'FD9B' },
  { n: 'diving-helmet', c: 'FD9C' },
  { n: 'diving-scuba', c: 'FD9D' },
  { n: 'diving-scuba-flag', c: 'FD9E' },
  { n: 'diving-scuba-tank', c: 'FD9F' },
  { n: 'diving-scuba-tank-multiple', c: 'FDA0' },
  { n: 'diving-snorkel', c: 'FDA1' },
  { n: 'division', c: 'F1D4' },
  { n: 'division-box', c: 'F1D5' },
  { n: 'dlna', c: 'FA40' },
  { n: 'dna', c: 'F683' },
  { n: 'dns', c: 'F1D6' },
  { n: 'dns-outline', c: 'FB68' },
  { n: 'do-not-disturb', c: 'F697' },
  { n: 'do-not-disturb-off', c: 'F698' },
  { n: 'docker', c: 'F867' },
  { n: 'doctor', c: 'FA41' },
  { n: 'dog', c: 'FA42' },
  { n: 'dog-service', c: 'FAAC' },
  { n: 'dog-side', c: 'FA43' },
  { n: 'dolby', c: 'F6B2' },
  { n: 'domain', c: 'F1D7' },
  { n: 'domain-off', c: 'FD4B' },
  { n: 'donkey', c: 'F7C1' },
  { n: 'door', c: 'F819' },
  { n: 'door-closed', c: 'F81A' },
  { n: 'door-open', c: 'F81B' },
  { n: 'doorbell-video', c: 'F868' },
  { n: 'dot-net', c: 'FAAD' },
  { n: 'dots-horizontal', c: 'F1D8' },
  { n: 'dots-horizontal-circle', c: 'F7C2' },
  { n: 'dots-horizontal-circle-outline', c: 'FB69' },
  { n: 'dots-vertical', c: 'F1D9' },
  { n: 'dots-vertical-circle', c: 'F7C3' },
  { n: 'dots-vertical-circle-outline', c: 'FB6A' },
  { n: 'douban', c: 'F699' },
  { n: 'download', c: 'F1DA' },
  { n: 'download-multiple', c: 'F9E8' },
  { n: 'download-network', c: 'F6F3' },
  { n: 'download-network-outline', c: 'FC42' },
  { n: 'download-outline', c: 'FB6B' },
  { n: 'drag', c: 'F1DB' },
  { n: 'drag-horizontal', c: 'F1DC' },
  { n: 'drag-variant', c: 'FB6C' },
  { n: 'drag-vertical', c: 'F1DD' },
  { n: 'drama-masks', c: 'FCDE' },
  { n: 'drawing', c: 'F1DE' },
  { n: 'drawing-box', c: 'F1DF' },
  { n: 'dribbble', c: 'F1E0' },
  { n: 'dribbble-box', c: 'F1E1' },
  { n: 'drone', c: 'F1E2' },
  { n: 'dropbox', c: 'F1E3' },
  { n: 'drupal', c: 'F1E4' },
  { n: 'duck', c: 'F1E5' },
  { n: 'dumbbell', c: 'F1E6' },
  { n: 'dump-truck', c: 'FC43' },
  { n: 'ear-hearing', c: 'F7C4' },
  { n: 'ear-hearing-off', c: 'FA44' },
  { n: 'earth', c: 'F1E7' },
  { n: 'earth-box', c: 'F6CC' },
  { n: 'earth-box-off', c: 'F6CD' },
  { n: 'earth-off', c: 'F1E8' },
  { n: 'edge', c: 'F1E9' },
  { n: 'egg', c: 'FAAE' },
  { n: 'egg-easter', c: 'FAAF' },
  { n: 'eight-track', c: 'F9E9' },
  { n: 'eject', c: 'F1EA' },
  { n: 'eject-outline', c: 'FB6D' },
  { n: 'elephant', c: 'F7C5' },
  { n: 'elevation-decline', c: 'F1EB' },
  { n: 'elevation-rise', c: 'F1EC' },
  { n: 'elevator', c: 'F1ED' },
  { n: 'email', c: 'F1EE' },
  { n: 'email-alert', c: 'F6CE' },
  { n: 'email-box', c: 'FCDF' },
  { n: 'email-check', c: 'FAB0' },
  { n: 'email-check-outline', c: 'FAB1' },
  { n: 'email-lock', c: 'F1F1' },
  { n: 'email-mark-as-unread', c: 'FB6E' },
  { n: 'email-open', c: 'F1EF' },
  { n: 'email-open-outline', c: 'F5EF' },
  { n: 'email-outline', c: 'F1F0' },
  { n: 'email-plus', c: 'F9EA' },
  { n: 'email-plus-outline', c: 'F9EB' },
  { n: 'email-search', c: 'F960' },
  { n: 'email-search-outline', c: 'F961' },
  { n: 'email-variant', c: 'F5F0' },
  { n: 'ember', c: 'FB15' },
  { n: 'emby', c: 'F6B3' },
  { n: 'emoticon', c: 'FC44' },
  { n: 'emoticon-angry', c: 'FC45' },
  { n: 'emoticon-angry-outline', c: 'FC46' },
  { n: 'emoticon-cool', c: 'FC47' },
  { n: 'emoticon-cool-outline', c: 'F1F3' },
  { n: 'emoticon-cry', c: 'FC48' },
  { n: 'emoticon-cry-outline', c: 'FC49' },
  { n: 'emoticon-dead', c: 'FC4A' },
  { n: 'emoticon-dead-outline', c: 'F69A' },
  { n: 'emoticon-devil', c: 'FC4B' },
  { n: 'emoticon-devil-outline', c: 'F1F4' },
  { n: 'emoticon-excited', c: 'FC4C' },
  { n: 'emoticon-excited-outline', c: 'F69B' },
  { n: 'emoticon-happy', c: 'FC4D' },
  { n: 'emoticon-happy-outline', c: 'F1F5' },
  { n: 'emoticon-kiss', c: 'FC4E' },
  { n: 'emoticon-kiss-outline', c: 'FC4F' },
  { n: 'emoticon-neutral', c: 'FC50' },
  { n: 'emoticon-neutral-outline', c: 'F1F6' },
  { n: 'emoticon-outline', c: 'F1F2' },
  { n: 'emoticon-poop', c: 'F1F7' },
  { n: 'emoticon-poop-outline', c: 'FC51' },
  { n: 'emoticon-sad', c: 'FC52' },
  { n: 'emoticon-sad-outline', c: 'F1F8' },
  { n: 'emoticon-tongue', c: 'F1F9' },
  { n: 'emoticon-tongue-outline', c: 'FC53' },
  { n: 'emoticon-wink', c: 'FC54' },
  { n: 'emoticon-wink-outline', c: 'FC55' },
  { n: 'engine', c: 'F1FA' },
  { n: 'engine-off', c: 'FA45' },
  { n: 'engine-off-outline', c: 'FA46' },
  { n: 'engine-outline', c: 'F1FB' },
  { n: 'equal', c: 'F1FC' },
  { n: 'equal-box', c: 'F1FD' },
  { n: 'eraser', c: 'F1FE' },
  { n: 'eraser-variant', c: 'F642' },
  { n: 'escalator', c: 'F1FF' },
  { n: 'eslint', c: 'FC56' },
  { n: 'et', c: 'FAB2' },
  { n: 'ethereum', c: 'F869' },
  { n: 'ethernet', c: 'F200' },
  { n: 'ethernet-cable', c: 'F201' },
  { n: 'ethernet-cable-off', c: 'F202' },
  { n: 'etsy', c: 'F203' },
  { n: 'ev-station', c: 'F5F1' },
  { n: 'eventbrite', c: 'F7C6' },
  { n: 'evernote', c: 'F204' },
  { n: 'exclamation', c: 'F205' },
  { n: 'exit-run', c: 'FA47' },
  { n: 'exit-to-app', c: 'F206' },
  { n: 'expand-all', c: 'FAB3' },
  { n: 'expand-all-outline', c: 'FAB4' },
  { n: 'exponent', c: 'F962' },
  { n: 'exponent-box', c: 'F963' },
  { n: 'export', c: 'F207' },
  { n: 'export-variant', c: 'FB6F' },
  { n: 'eye', c: 'F208' },
  { n: 'eye-check', c: 'FCE0' },
  { n: 'eye-check-outline', c: 'FCE1' },
  { n: 'eye-circle', c: 'FB70' },
  { n: 'eye-circle-outline', c: 'FB71' },
  { n: 'eye-off', c: 'F209' },
  { n: 'eye-off-outline', c: 'F6D0' },
  { n: 'eye-outline', c: 'F6CF' },
  { n: 'eye-plus', c: 'F86A' },
  { n: 'eye-plus-outline', c: 'F86B' },
  { n: 'eye-settings', c: 'F86C' },
  { n: 'eye-settings-outline', c: 'F86D' },
  { n: 'eyedropper', c: 'F20A' },
  { n: 'eyedropper-variant', c: 'F20B' },
  { n: 'face', c: 'F643' },
  { n: 'face-agent', c: 'FD4C' },
  { n: 'face-outline', c: 'FB72' },
  { n: 'face-profile', c: 'F644' },
  { n: 'face-recognition', c: 'FC57' },
  { n: 'facebook', c: 'F20C' },
  { n: 'facebook-box', c: 'F20D' },
  { n: 'facebook-messenger', c: 'F20E' },
  { n: 'facebook-workplace', c: 'FB16' },
  { n: 'factory', c: 'F20F' },
  { n: 'fan', c: 'F210' },
  { n: 'fan-off', c: 'F81C' },
  { n: 'fast-forward', c: 'F211' },
  { n: 'fast-forward-10', c: 'FD4D' },
  { n: 'fast-forward-30', c: 'FCE2' },
  { n: 'fast-forward-outline', c: 'F6D1' },
  { n: 'fax', c: 'F212' },
  { n: 'feather', c: 'F6D2' },
  { n: 'feature-search', c: 'FA48' },
  { n: 'feature-search-outline', c: 'FA49' },
  { n: 'fedora', c: 'F8DA' },
  { n: 'ferry', c: 'F213' },
  { n: 'file', c: 'F214' },
  { n: 'file-account', c: 'F73A' },
  { n: 'file-alert', c: 'FA4A' },
  { n: 'file-alert-outline', c: 'FA4B' },
  { n: 'file-cabinet', c: 'FAB5' },
  { n: 'file-cancel', c: 'FDA2' },
  { n: 'file-cancel-outline', c: 'FDA3' },
  { n: 'file-chart', c: 'F215' },
  { n: 'file-check', c: 'F216' },
  { n: 'file-cloud', c: 'F217' },
  { n: 'file-compare', c: 'F8A9' },
  { n: 'file-delimited', c: 'F218' },
  { n: 'file-document', c: 'F219' },
  { n: 'file-document-box', c: 'F21A' },
  { n: 'file-document-box-multiple', c: 'FAB6' },
  { n: 'file-document-box-multiple-outline', c: 'FAB7' },
  { n: 'file-document-box-outline', c: 'F9EC' },
  { n: 'file-document-edit', c: 'FDA4' },
  { n: 'file-document-edit-outline', c: 'FDA5' },
  { n: 'file-document-outline', c: 'F9ED' },
  { n: 'file-download', c: 'F964' },
  { n: 'file-download-outline', c: 'F965' },
  { n: 'file-excel', c: 'F21B' },
  { n: 'file-excel-box', c: 'F21C' },
  { n: 'file-export', c: 'F21D' },
  { n: 'file-eye', c: 'FDA6' },
  { n: 'file-eye-outline', c: 'FDA7' },
  { n: 'file-find', c: 'F21E' },
  { n: 'file-find-outline', c: 'FB73' },
  { n: 'file-hidden', c: 'F613' },
  { n: 'file-image', c: 'F21F' },
  { n: 'file-import', c: 'F220' },
  { n: 'file-lock', c: 'F221' },
  { n: 'file-move', c: 'FAB8' },
  { n: 'file-multiple', c: 'F222' },
  { n: 'file-music', c: 'F223' },
  { n: 'file-outline', c: 'F224' },
  { n: 'file-pdf', c: 'F225' },
  { n: 'file-pdf-box', c: 'F226' },
  { n: 'file-percent', c: 'F81D' },
  { n: 'file-plus', c: 'F751' },
  { n: 'file-powerpoint', c: 'F227' },
  { n: 'file-powerpoint-box', c: 'F228' },
  { n: 'file-presentation-box', c: 'F229' },
  { n: 'file-question', c: 'F86E' },
  { n: 'file-remove', c: 'FB74' },
  { n: 'file-replace', c: 'FB17' },
  { n: 'file-replace-outline', c: 'FB18' },
  { n: 'file-restore', c: 'F670' },
  { n: 'file-search', c: 'FC58' },
  { n: 'file-search-outline', c: 'FC59' },
  { n: 'file-send', c: 'F22A' },
  { n: 'file-table', c: 'FC5A' },
  { n: 'file-table-outline', c: 'FC5B' },
  { n: 'file-tree', c: 'F645' },
  { n: 'file-undo', c: 'F8DB' },
  { n: 'file-upload', c: 'FA4C' },
  { n: 'file-upload-outline', c: 'FA4D' },
  { n: 'file-video', c: 'F22B' },
  { n: 'file-word', c: 'F22C' },
  { n: 'file-word-box', c: 'F22D' },
  { n: 'file-xml', c: 'F22E' },
  { n: 'film', c: 'F22F' },
  { n: 'filmstrip', c: 'F230' },
  { n: 'filmstrip-off', c: 'F231' },
  { n: 'filter', c: 'F232' },
  { n: 'filter-outline', c: 'F233' },
  { n: 'filter-remove', c: 'F234' },
  { n: 'filter-remove-outline', c: 'F235' },
  { n: 'filter-variant', c: 'F236' },
  { n: 'finance', c: 'F81E' },
  { n: 'find-replace', c: 'F6D3' },
  { n: 'fingerprint', c: 'F237' },
  { n: 'fire', c: 'F238' },
  { n: 'fire-truck', c: 'F8AA' },
  { n: 'firebase', c: 'F966' },
  { n: 'firefox', c: 'F239' },
  { n: 'fish', c: 'F23A' },
  { n: 'flag', c: 'F23B' },
  { n: 'flag-checkered', c: 'F23C' },
  { n: 'flag-minus', c: 'FB75' },
  { n: 'flag-outline', c: 'F23D' },
  { n: 'flag-plus', c: 'FB76' },
  { n: 'flag-remove', c: 'FB77' },
  { n: 'flag-triangle', c: 'F23F' },
  { n: 'flag-variant', c: 'F240' },
  { n: 'flag-variant-outline', c: 'F23E' },
  { n: 'flare', c: 'FD4E' },
  { n: 'flash', c: 'F241' },
  { n: 'flash-auto', c: 'F242' },
  { n: 'flash-circle', c: 'F81F' },
  { n: 'flash-off', c: 'F243' },
  { n: 'flash-outline', c: 'F6D4' },
  { n: 'flash-red-eye', c: 'F67A' },
  { n: 'flashlight', c: 'F244' },
  { n: 'flashlight-off', c: 'F245' },
  { n: 'flask', c: 'F093' },
  { n: 'flask-empty', c: 'F094' },
  { n: 'flask-empty-outline', c: 'F095' },
  { n: 'flask-outline', c: 'F096' },
  { n: 'flattr', c: 'F246' },
  { n: 'flickr', c: 'FCE3' },
  { n: 'flip-to-back', c: 'F247' },
  { n: 'flip-to-front', c: 'F248' },
  { n: 'floor-lamp', c: 'F8DC' },
  { n: 'floor-plan', c: 'F820' },
  { n: 'floppy', c: 'F249' },
  { n: 'floppy-variant', c: 'F9EE' },
  { n: 'flower', c: 'F24A' },
  { n: 'flower-outline', c: 'F9EF' },
  { n: 'flower-poppy', c: 'FCE4' },
  { n: 'flower-tulip', c: 'F9F0' },
  { n: 'flower-tulip-outline', c: 'F9F1' },
  { n: 'folder', c: 'F24B' },
  { n: 'folder-account', c: 'F24C' },
  { n: 'folder-account-outline', c: 'FB78' },
  { n: 'folder-alert', c: 'FDA8' },
  { n: 'folder-alert-outline', c: 'FDA9' },
  { n: 'folder-clock', c: 'FAB9' },
  { n: 'folder-clock-outline', c: 'FABA' },
  { n: 'folder-download', c: 'F24D' },
  { n: 'folder-edit', c: 'F8DD' },
  { n: 'folder-edit-outline', c: 'FDAA' },
  { n: 'folder-google-drive', c: 'F24E' },
  { n: 'folder-image', c: 'F24F' },
  { n: 'folder-key', c: 'F8AB' },
  { n: 'folder-key-network', c: 'F8AC' },
  { n: 'folder-key-network-outline', c: 'FC5C' },
  { n: 'folder-lock', c: 'F250' },
  { n: 'folder-lock-open', c: 'F251' },
  { n: 'folder-move', c: 'F252' },
  { n: 'folder-multiple', c: 'F253' },
  { n: 'folder-multiple-image', c: 'F254' },
  { n: 'folder-multiple-outline', c: 'F255' },
  { n: 'folder-network', c: 'F86F' },
  { n: 'folder-network-outline', c: 'FC5D' },
  { n: 'folder-open', c: 'F76F' },
  { n: 'folder-open-outline', c: 'FDAB' },
  { n: 'folder-outline', c: 'F256' },
  { n: 'folder-plus', c: 'F257' },
  { n: 'folder-plus-outline', c: 'FB79' },
  { n: 'folder-pound', c: 'FCE5' },
  { n: 'folder-pound-outline', c: 'FCE6' },
  { n: 'folder-remove', c: 'F258' },
  { n: 'folder-remove-outline', c: 'FB7A' },
  { n: 'folder-search', c: 'F967' },
  { n: 'folder-search-outline', c: 'F968' },
  { n: 'folder-star', c: 'F69C' },
  { n: 'folder-star-outline', c: 'FB7B' },
  { n: 'folder-sync', c: 'FCE7' },
  { n: 'folder-sync-outline', c: 'FCE8' },
  { n: 'folder-text', c: 'FC5E' },
  { n: 'folder-text-outline', c: 'FC5F' },
  { n: 'folder-upload', c: 'F259' },
  { n: 'font-awesome', c: 'F03A' },
  { n: 'food', c: 'F25A' },
  { n: 'food-apple', c: 'F25B' },
  { n: 'food-apple-outline', c: 'FC60' },
  { n: 'food-croissant', c: 'F7C7' },
  { n: 'food-fork-drink', c: 'F5F2' },
  { n: 'food-off', c: 'F5F3' },
  { n: 'food-variant', c: 'F25C' },
  { n: 'football', c: 'F25D' },
  { n: 'football-australian', c: 'F25E' },
  { n: 'football-helmet', c: 'F25F' },
  { n: 'forklift', c: 'F7C8' },
  { n: 'format-align-bottom', c: 'F752' },
  { n: 'format-align-center', c: 'F260' },
  { n: 'format-align-justify', c: 'F261' },
  { n: 'format-align-left', c: 'F262' },
  { n: 'format-align-middle', c: 'F753' },
  { n: 'format-align-right', c: 'F263' },
  { n: 'format-align-top', c: 'F754' },
  { n: 'format-annotation-minus', c: 'FABB' },
  { n: 'format-annotation-plus', c: 'F646' },
  { n: 'format-bold', c: 'F264' },
  { n: 'format-clear', c: 'F265' },
  { n: 'format-color-fill', c: 'F266' },
  { n: 'format-color-text', c: 'F69D' },
  { n: 'format-columns', c: 'F8DE' },
  { n: 'format-float-center', c: 'F267' },
  { n: 'format-float-left', c: 'F268' },
  { n: 'format-float-none', c: 'F269' },
  { n: 'format-float-right', c: 'F26A' },
  { n: 'format-font', c: 'F6D5' },
  { n: 'format-font-size-decrease', c: 'F9F2' },
  { n: 'format-font-size-increase', c: 'F9F3' },
  { n: 'format-header-1', c: 'F26B' },
  { n: 'format-header-2', c: 'F26C' },
  { n: 'format-header-3', c: 'F26D' },
  { n: 'format-header-4', c: 'F26E' },
  { n: 'format-header-5', c: 'F26F' },
  { n: 'format-header-6', c: 'F270' },
  { n: 'format-header-decrease', c: 'F271' },
  { n: 'format-header-equal', c: 'F272' },
  { n: 'format-header-increase', c: 'F273' },
  { n: 'format-header-pound', c: 'F274' },
  { n: 'format-horizontal-align-center', c: 'F61E' },
  { n: 'format-horizontal-align-left', c: 'F61F' },
  { n: 'format-horizontal-align-right', c: 'F620' },
  { n: 'format-indent-decrease', c: 'F275' },
  { n: 'format-indent-increase', c: 'F276' },
  { n: 'format-italic', c: 'F277' },
  { n: 'format-letter-case', c: 'FB19' },
  { n: 'format-letter-case-lower', c: 'FB1A' },
  { n: 'format-letter-case-upper', c: 'FB1B' },
  { n: 'format-line-spacing', c: 'F278' },
  { n: 'format-line-style', c: 'F5C8' },
  { n: 'format-line-weight', c: 'F5C9' },
  { n: 'format-list-bulleted', c: 'F279' },
  { n: 'format-list-bulleted-square', c: 'FDAC' },
  { n: 'format-list-bulleted-type', c: 'F27A' },
  { n: 'format-list-checkbox', c: 'F969' },
  { n: 'format-list-checks', c: 'F755' },
  { n: 'format-list-numbered', c: 'F27B' },
  { n: 'format-list-numbered-rtl', c: 'FCE9' },
  { n: 'format-page-break', c: 'F6D6' },
  { n: 'format-paint', c: 'F27C' },
  { n: 'format-paragraph', c: 'F27D' },
  { n: 'format-pilcrow', c: 'F6D7' },
  { n: 'format-quote-close', c: 'F27E' },
  { n: 'format-quote-open', c: 'F756' },
  { n: 'format-rotate-90', c: 'F6A9' },
  { n: 'format-section', c: 'F69E' },
  { n: 'format-size', c: 'F27F' },
  { n: 'format-strikethrough', c: 'F280' },
  { n: 'format-strikethrough-variant', c: 'F281' },
  { n: 'format-subscript', c: 'F282' },
  { n: 'format-superscript', c: 'F283' },
  { n: 'format-text', c: 'F284' },
  { n: 'format-text-rotation-down', c: 'FD4F' },
  { n: 'format-text-rotation-none', c: 'FD50' },
  { n: 'format-text-wrapping-clip', c: 'FCEA' },
  { n: 'format-text-wrapping-overflow', c: 'FCEB' },
  { n: 'format-text-wrapping-wrap', c: 'FCEC' },
  { n: 'format-textbox', c: 'FCED' },
  { n: 'format-textdirection-l-to-r', c: 'F285' },
  { n: 'format-textdirection-r-to-l', c: 'F286' },
  { n: 'format-title', c: 'F5F4' },
  { n: 'format-underline', c: 'F287' },
  { n: 'format-vertical-align-bottom', c: 'F621' },
  { n: 'format-vertical-align-center', c: 'F622' },
  { n: 'format-vertical-align-top', c: 'F623' },
  { n: 'format-wrap-inline', c: 'F288' },
  { n: 'format-wrap-square', c: 'F289' },
  { n: 'format-wrap-tight', c: 'F28A' },
  { n: 'format-wrap-top-bottom', c: 'F28B' },
  { n: 'forum', c: 'F28C' },
  { n: 'forum-outline', c: 'F821' },
  { n: 'forward', c: 'F28D' },
  { n: 'forwardburger', c: 'FD51' },
  { n: 'fountain', c: 'F96A' },
  { n: 'fountain-pen', c: 'FCEE' },
  { n: 'fountain-pen-tip', c: 'FCEF' },
  { n: 'foursquare', c: 'F28E' },
  { n: 'freebsd', c: 'F8DF' },
  { n: 'fridge', c: 'F290' },
  { n: 'fridge-bottom', c: 'F292' },
  { n: 'fridge-outline', c: 'F28F' },
  { n: 'fridge-top', c: 'F291' },
  { n: 'fuel', c: 'F7C9' },
  { n: 'fullscreen', c: 'F293' },
  { n: 'fullscreen-exit', c: 'F294' },
  { n: 'function', c: 'F295' },
  { n: 'function-variant', c: 'F870' },
  { n: 'fuse', c: 'FC61' },
  { n: 'fuse-blade', c: 'FC62' },
  { n: 'gamepad', c: 'F296' },
  { n: 'gamepad-variant', c: 'F297' },
  { n: 'gantry-crane', c: 'FDAD' },
  { n: 'garage', c: 'F6D8' },
  { n: 'garage-alert', c: 'F871' },
  { n: 'garage-open', c: 'F6D9' },
  { n: 'gas-cylinder', c: 'F647' },
  { n: 'gas-station', c: 'F298' },
  { n: 'gate', c: 'F299' },
  { n: 'gate-and', c: 'F8E0' },
  { n: 'gate-nand', c: 'F8E1' },
  { n: 'gate-nor', c: 'F8E2' },
  { n: 'gate-not', c: 'F8E3' },
  { n: 'gate-or', c: 'F8E4' },
  { n: 'gate-xnor', c: 'F8E5' },
  { n: 'gate-xor', c: 'F8E6' },
  { n: 'gauge', c: 'F29A' },
  { n: 'gauge-empty', c: 'F872' },
  { n: 'gauge-full', c: 'F873' },
  { n: 'gauge-low', c: 'F874' },
  { n: 'gavel', c: 'F29B' },
  { n: 'gender-female', c: 'F29C' },
  { n: 'gender-male', c: 'F29D' },
  { n: 'gender-male-female', c: 'F29E' },
  { n: 'gender-transgender', c: 'F29F' },
  { n: 'gentoo', c: 'F8E7' },
  { n: 'gesture', c: 'F7CA' },
  { n: 'gesture-double-tap', c: 'F73B' },
  { n: 'gesture-pinch', c: 'FABC' },
  { n: 'gesture-spread', c: 'FABD' },
  { n: 'gesture-swipe', c: 'FD52' },
  { n: 'gesture-swipe-down', c: 'F73C' },
  { n: 'gesture-swipe-horizontal', c: 'FABE' },
  { n: 'gesture-swipe-left', c: 'F73D' },
  { n: 'gesture-swipe-right', c: 'F73E' },
  { n: 'gesture-swipe-up', c: 'F73F' },
  { n: 'gesture-swipe-vertical', c: 'FABF' },
  { n: 'gesture-tap', c: 'F740' },
  { n: 'gesture-tap-hold', c: 'FD53' },
  { n: 'gesture-two-double-tap', c: 'F741' },
  { n: 'gesture-two-tap', c: 'F742' },
  { n: 'ghost', c: 'F2A0' },
  { n: 'ghost-off', c: 'F9F4' },
  { n: 'gif', c: 'FD54' },
  { n: 'gift', c: 'F2A1' },
  { n: 'git', c: 'F2A2' },
  { n: 'github-box', c: 'F2A3' },
  { n: 'github-circle', c: 'F2A4' },
  { n: 'github-face', c: 'F6DA' },
  { n: 'gitlab', c: 'FB7C' },
  { n: 'glass-cocktail', c: 'F356' },
  { n: 'glass-flute', c: 'F2A5' },
  { n: 'glass-mug', c: 'F2A6' },
  { n: 'glass-stange', c: 'F2A7' },
  { n: 'glass-tulip', c: 'F2A8' },
  { n: 'glass-wine', c: 'F875' },
  { n: 'glassdoor', c: 'F2A9' },
  { n: 'glasses', c: 'F2AA' },
  { n: 'globe-model', c: 'F8E8' },
  { n: 'gmail', c: 'F2AB' },
  { n: 'gnome', c: 'F2AC' },
  { n: 'go-kart', c: 'FD55' },
  { n: 'go-kart-track', c: 'FD56' },
  { n: 'gog', c: 'FB7D' },
  { n: 'golf', c: 'F822' },
  { n: 'gondola', c: 'F685' },
  { n: 'goodreads', c: 'FD57' },
  { n: 'google', c: 'F2AD' },
  { n: 'google-adwords', c: 'FC63' },
  { n: 'google-allo', c: 'F801' },
  { n: 'google-analytics', c: 'F7CB' },
  { n: 'google-assistant', c: 'F7CC' },
  { n: 'google-cardboard', c: 'F2AE' },
  { n: 'google-chrome', c: 'F2AF' },
  { n: 'google-circles', c: 'F2B0' },
  { n: 'google-circles-communities', c: 'F2B1' },
  { n: 'google-circles-extended', c: 'F2B2' },
  { n: 'google-circles-group', c: 'F2B3' },
  { n: 'google-classroom', c: 'F2C0' },
  { n: 'google-controller', c: 'F2B4' },
  { n: 'google-controller-off', c: 'F2B5' },
  { n: 'google-drive', c: 'F2B6' },
  { n: 'google-earth', c: 'F2B7' },
  { n: 'google-fit', c: 'F96B' },
  { n: 'google-glass', c: 'F2B8' },
  { n: 'google-hangouts', c: 'F2C9' },
  { n: 'google-home', c: 'F823' },
  { n: 'google-keep', c: 'F6DB' },
  { n: 'google-lens', c: 'F9F5' },
  { n: 'google-maps', c: 'F5F5' },
  { n: 'google-nearby', c: 'F2B9' },
  { n: 'google-pages', c: 'F2BA' },
  { n: 'google-photos', c: 'F6DC' },
  { n: 'google-physical-web', c: 'F2BB' },
  { n: 'google-play', c: 'F2BC' },
  { n: 'google-plus', c: 'F2BD' },
  { n: 'google-plus-box', c: 'F2BE' },
  { n: 'google-spreadsheet', c: 'F9F6' },
  { n: 'google-street-view', c: 'FC64' },
  { n: 'google-translate', c: 'F2BF' },
  { n: 'gpu', c: 'F8AD' },
  { n: 'gradient', c: 'F69F' },
  { n: 'grain', c: 'FD58' },
  { n: 'graphql', c: 'F876' },
  { n: 'grave-stone', c: 'FB7E' },
  { n: 'grease-pencil', c: 'F648' },
  { n: 'greater-than', c: 'F96C' },
  { n: 'greater-than-or-equal', c: 'F96D' },
  { n: 'grid', c: 'F2C1' },
  { n: 'grid-large', c: 'F757' },
  { n: 'grid-off', c: 'F2C2' },
  { n: 'group', c: 'F2C3' },
  { n: 'guitar-acoustic', c: 'F770' },
  { n: 'guitar-electric', c: 'F2C4' },
  { n: 'guitar-pick', c: 'F2C5' },
  { n: 'guitar-pick-outline', c: 'F2C6' },
  { n: 'guy-fawkes-mask', c: 'F824' },
  { n: 'hackernews', c: 'F624' },
  { n: 'hail', c: 'FAC0' },
  { n: 'halloween', c: 'FB7F' },
  { n: 'hamburger', c: 'F684' },
  { n: 'hammer', c: 'F8E9' },
  { n: 'hand', c: 'FA4E' },
  { n: 'hand-okay', c: 'FA4F' },
  { n: 'hand-peace', c: 'FA50' },
  { n: 'hand-peace-variant', c: 'FA51' },
  { n: 'hand-pointing-down', c: 'FA52' },
  { n: 'hand-pointing-left', c: 'FA53' },
  { n: 'hand-pointing-right', c: 'F2C7' },
  { n: 'hand-pointing-up', c: 'FA54' },
  { n: 'hanger', c: 'F2C8' },
  { n: 'hard-hat', c: 'F96E' },
  { n: 'harddisk', c: 'F2CA' },
  { n: 'hat-fedora', c: 'FB80' },
  { n: 'hazard-lights', c: 'FC65' },
  { n: 'hdr', c: 'FD59' },
  { n: 'hdr-off', c: 'FD5A' },
  { n: 'headphones', c: 'F2CB' },
  { n: 'headphones-bluetooth', c: 'F96F' },
  { n: 'headphones-box', c: 'F2CC' },
  { n: 'headphones-off', c: 'F7CD' },
  { n: 'headphones-settings', c: 'F2CD' },
  { n: 'headset', c: 'F2CE' },
  { n: 'headset-dock', c: 'F2CF' },
  { n: 'headset-off', c: 'F2D0' },
  { n: 'heart', c: 'F2D1' },
  { n: 'heart-box', c: 'F2D2' },
  { n: 'heart-box-outline', c: 'F2D3' },
  { n: 'heart-broken', c: 'F2D4' },
  { n: 'heart-broken-outline', c: 'FCF0' },
  { n: 'heart-circle', c: 'F970' },
  { n: 'heart-circle-outline', c: 'F971' },
  { n: 'heart-half', c: 'F6DE' },
  { n: 'heart-half-full', c: 'F6DD' },
  { n: 'heart-half-outline', c: 'F6DF' },
  { n: 'heart-multiple', c: 'FA55' },
  { n: 'heart-multiple-outline', c: 'FA56' },
  { n: 'heart-off', c: 'F758' },
  { n: 'heart-outline', c: 'F2D5' },
  { n: 'heart-pulse', c: 'F5F6' },
  { n: 'helicopter', c: 'FAC1' },
  { n: 'help', c: 'F2D6' },
  { n: 'help-box', c: 'F78A' },
  { n: 'help-circle', c: 'F2D7' },
  { n: 'help-circle-outline', c: 'F625' },
  { n: 'help-network', c: 'F6F4' },
  { n: 'help-network-outline', c: 'FC66' },
  { n: 'help-rhombus', c: 'FB81' },
  { n: 'help-rhombus-outline', c: 'FB82' },
  { n: 'hexagon', c: 'F2D8' },
  { n: 'hexagon-multiple', c: 'F6E0' },
  { n: 'hexagon-outline', c: 'F2D9' },
  { n: 'hexagon-slice-1', c: 'FAC2' },
  { n: 'hexagon-slice-2', c: 'FAC3' },
  { n: 'hexagon-slice-3', c: 'FAC4' },
  { n: 'hexagon-slice-4', c: 'FAC5' },
  { n: 'hexagon-slice-5', c: 'FAC6' },
  { n: 'hexagon-slice-6', c: 'FAC7' },
  { n: 'hexagram', c: 'FAC8' },
  { n: 'hexagram-outline', c: 'FAC9' },
  { n: 'high-definition', c: 'F7CE' },
  { n: 'high-definition-box', c: 'F877' },
  { n: 'highway', c: 'F5F7' },
  { n: 'hiking', c: 'FD5B' },
  { n: 'hinduism', c: 'F972' },
  { n: 'history', c: 'F2DA' },
  { n: 'hockey-puck', c: 'F878' },
  { n: 'hockey-sticks', c: 'F879' },
  { n: 'hololens', c: 'F2DB' },
  { n: 'home', c: 'F2DC' },
  { n: 'home-account', c: 'F825' },
  { n: 'home-alert', c: 'F87A' },
  { n: 'home-assistant', c: 'F7CF' },
  { n: 'home-automation', c: 'F7D0' },
  { n: 'home-circle', c: 'F7D1' },
  { n: 'home-city', c: 'FCF1' },
  { n: 'home-city-outline', c: 'FCF2' },
  { n: 'home-currency-usd', c: 'F8AE' },
  { n: 'home-floor-0', c: 'FDAE' },
  { n: 'home-floor-1', c: 'FD5C' },
  { n: 'home-floor-2', c: 'FD5D' },
  { n: 'home-floor-3', c: 'FD5E' },
  { n: 'home-floor-a', c: 'FD5F' },
  { n: 'home-floor-b', c: 'FD60' },
  { n: 'home-floor-g', c: 'FD61' },
  { n: 'home-floor-l', c: 'FD62' },
  { n: 'home-floor-negative-1', c: 'FDAF' },
  { n: 'home-group', c: 'FDB0' },
  { n: 'home-heart', c: 'F826' },
  { n: 'home-lock', c: 'F8EA' },
  { n: 'home-lock-open', c: 'F8EB' },
  { n: 'home-map-marker', c: 'F5F8' },
  { n: 'home-minus', c: 'F973' },
  { n: 'home-modern', c: 'F2DD' },
  { n: 'home-outline', c: 'F6A0' },
  { n: 'home-plus', c: 'F974' },
  { n: 'home-variant', c: 'F2DE' },
  { n: 'home-variant-outline', c: 'FB83' },
  { n: 'hook', c: 'F6E1' },
  { n: 'hook-off', c: 'F6E2' },
  { n: 'hops', c: 'F2DF' },
  { n: 'horseshoe', c: 'FA57' },
  { n: 'hospital', c: 'F2E0' },
  { n: 'hospital-building', c: 'F2E1' },
  { n: 'hospital-marker', c: 'F2E2' },
  { n: 'hot-tub', c: 'F827' },
  { n: 'hotel', c: 'F2E3' },
  { n: 'houzz', c: 'F2E4' },
  { n: 'houzz-box', c: 'F2E5' },
  { n: 'hubspot', c: 'FCF3' },
  { n: 'hulu', c: 'F828' },
  { n: 'human', c: 'F2E6' },
  { n: 'human-child', c: 'F2E7' },
  { n: 'human-female', c: 'F649' },
  { n: 'human-female-boy', c: 'FA58' },
  { n: 'human-female-female', c: 'FA59' },
  { n: 'human-female-girl', c: 'FA5A' },
  { n: 'human-greeting', c: 'F64A' },
  { n: 'human-handsdown', c: 'F64B' },
  { n: 'human-handsup', c: 'F64C' },
  { n: 'human-male', c: 'F64D' },
  { n: 'human-male-boy', c: 'FA5B' },
  { n: 'human-male-female', c: 'F2E8' },
  { n: 'human-male-girl', c: 'FA5C' },
  { n: 'human-male-male', c: 'FA5D' },
  { n: 'human-pregnant', c: 'F5CF' },
  { n: 'humble-bundle', c: 'F743' },
  { n: 'ice-cream', c: 'F829' },
  { n: 'iframe', c: 'FC67' },
  { n: 'iframe-outline', c: 'FC68' },
  { n: 'image', c: 'F2E9' },
  { n: 'image-album', c: 'F2EA' },
  { n: 'image-area', c: 'F2EB' },
  { n: 'image-area-close', c: 'F2EC' },
  { n: 'image-broken', c: 'F2ED' },
  { n: 'image-broken-variant', c: 'F2EE' },
  { n: 'image-filter', c: 'F2EF' },
  { n: 'image-filter-black-white', c: 'F2F0' },
  { n: 'image-filter-center-focus', c: 'F2F1' },
  { n: 'image-filter-center-focus-weak', c: 'F2F2' },
  { n: 'image-filter-drama', c: 'F2F3' },
  { n: 'image-filter-frames', c: 'F2F4' },
  { n: 'image-filter-hdr', c: 'F2F5' },
  { n: 'image-filter-none', c: 'F2F6' },
  { n: 'image-filter-tilt-shift', c: 'F2F7' },
  { n: 'image-filter-vintage', c: 'F2F8' },
  { n: 'image-move', c: 'F9F7' },
  { n: 'image-multiple', c: 'F2F9' },
  { n: 'image-off', c: 'F82A' },
  { n: 'image-outline', c: 'F975' },
  { n: 'image-plus', c: 'F87B' },
  { n: 'image-search', c: 'F976' },
  { n: 'image-search-outline', c: 'F977' },
  { n: 'image-size-select-actual', c: 'FC69' },
  { n: 'image-size-select-large', c: 'FC6A' },
  { n: 'image-size-select-small', c: 'FC6B' },
  { n: 'import', c: 'F2FA' },
  { n: 'inbox', c: 'F686' },
  { n: 'inbox-arrow-down', c: 'F2FB' },
  { n: 'inbox-arrow-up', c: 'F3D1' },
  { n: 'inbox-multiple', c: 'F8AF' },
  { n: 'inbox-multiple-outline', c: 'FB84' },
  { n: 'incognito', c: 'F5F9' },
  { n: 'infinity', c: 'F6E3' },
  { n: 'information', c: 'F2FC' },
  { n: 'information-outline', c: 'F2FD' },
  { n: 'information-variant', c: 'F64E' },
  { n: 'instagram', c: 'F2FE' },
  { n: 'instapaper', c: 'F2FF' },
  { n: 'internet-explorer', c: 'F300' },
  { n: 'invert-colors', c: 'F301' },
  { n: 'ip', c: 'FA5E' },
  { n: 'ip-network', c: 'FA5F' },
  { n: 'ip-network-outline', c: 'FC6C' },
  { n: 'ipod', c: 'FC6D' },
  { n: 'islam', c: 'F978' },
  { n: 'itunes', c: 'F676' },
  { n: 'jabber', c: 'FDB1' },
  { n: 'jeepney', c: 'F302' },
  { n: 'jira', c: 'F303' },
  { n: 'jquery', c: 'F87C' },
  { n: 'jsfiddle', c: 'F304' },
  { n: 'json', c: 'F626' },
  { n: 'judaism', c: 'F979' },
  { n: 'kabaddi', c: 'FD63' },
  { n: 'karate', c: 'F82B' },
  { n: 'keg', c: 'F305' },
  { n: 'kettle', c: 'F5FA' },
  { n: 'key', c: 'F306' },
  { n: 'key-change', c: 'F307' },
  { n: 'key-minus', c: 'F308' },
  { n: 'key-outline', c: 'FDB2' },
  { n: 'key-plus', c: 'F309' },
  { n: 'key-remove', c: 'F30A' },
  { n: 'key-variant', c: 'F30B' },
  { n: 'keyboard', c: 'F30C' },
  { n: 'keyboard-backspace', c: 'F30D' },
  { n: 'keyboard-caps', c: 'F30E' },
  { n: 'keyboard-close', c: 'F30F' },
  { n: 'keyboard-off', c: 'F310' },
  { n: 'keyboard-outline', c: 'F97A' },
  { n: 'keyboard-return', c: 'F311' },
  { n: 'keyboard-settings', c: 'F9F8' },
  { n: 'keyboard-settings-outline', c: 'F9F9' },
  { n: 'keyboard-tab', c: 'F312' },
  { n: 'keyboard-variant', c: 'F313' },
  { n: 'kickstarter', c: 'F744' },
  { n: 'knife', c: 'F9FA' },
  { n: 'knife-military', c: 'F9FB' },
  { n: 'kodi', c: 'F314' },
  { n: 'label', c: 'F315' },
  { n: 'label-off', c: 'FACA' },
  { n: 'label-off-outline', c: 'FACB' },
  { n: 'label-outline', c: 'F316' },
  { n: 'label-variant', c: 'FACC' },
  { n: 'label-variant-outline', c: 'FACD' },
  { n: 'ladybug', c: 'F82C' },
  { n: 'lambda', c: 'F627' },
  { n: 'lamp', c: 'F6B4' },
  { n: 'lan', c: 'F317' },
  { n: 'lan-connect', c: 'F318' },
  { n: 'lan-disconnect', c: 'F319' },
  { n: 'lan-pending', c: 'F31A' },
  { n: 'language-c', c: 'F671' },
  { n: 'language-cpp', c: 'F672' },
  { n: 'language-csharp', c: 'F31B' },
  { n: 'language-css3', c: 'F31C' },
  { n: 'language-go', c: 'F7D2' },
  { n: 'language-haskell', c: 'FC6E' },
  { n: 'language-html5', c: 'F31D' },
  { n: 'language-java', c: 'FB1C' },
  { n: 'language-javascript', c: 'F31E' },
  { n: 'language-lua', c: 'F8B0' },
  { n: 'language-php', c: 'F31F' },
  { n: 'language-python', c: 'F320' },
  { n: 'language-python-text', c: 'F321' },
  { n: 'language-r', c: 'F7D3' },
  { n: 'language-ruby-on-rails', c: 'FACE' },
  { n: 'language-swift', c: 'F6E4' },
  { n: 'language-typescript', c: 'F6E5' },
  { n: 'laptop', c: 'F322' },
  { n: 'laptop-chromebook', c: 'F323' },
  { n: 'laptop-mac', c: 'F324' },
  { n: 'laptop-off', c: 'F6E6' },
  { n: 'laptop-windows', c: 'F325' },
  { n: 'laravel', c: 'FACF' },
  { n: 'lastfm', c: 'F326' },
  { n: 'lastpass', c: 'F446' },
  { n: 'launch', c: 'F327' },
  { n: 'lava-lamp', c: 'F7D4' },
  { n: 'layers', c: 'F328' },
  { n: 'layers-off', c: 'F329' },
  { n: 'layers-off-outline', c: 'F9FC' },
  { n: 'layers-outline', c: 'F9FD' },
  { n: 'lead-pencil', c: 'F64F' },
  { n: 'leaf', c: 'F32A' },
  { n: 'leaf-maple', c: 'FC6F' },
  { n: 'leak', c: 'FDB3' },
  { n: 'leak-off', c: 'FDB4' },
  { n: 'led-off', c: 'F32B' },
  { n: 'led-on', c: 'F32C' },
  { n: 'led-outline', c: 'F32D' },
  { n: 'led-strip', c: 'F7D5' },
  { n: 'led-variant-off', c: 'F32E' },
  { n: 'led-variant-on', c: 'F32F' },
  { n: 'led-variant-outline', c: 'F330' },
  { n: 'less-than', c: 'F97B' },
  { n: 'less-than-or-equal', c: 'F97C' },
  { n: 'library', c: 'F331' },
  { n: 'library-books', c: 'F332' },
  { n: 'library-movie', c: 'FCF4' },
  { n: 'library-music', c: 'F333' },
  { n: 'library-plus', c: 'F334' },
  { n: 'library-shelves', c: 'FB85' },
  { n: 'library-video', c: 'FCF5' },
  { n: 'lifebuoy', c: 'F87D' },
  { n: 'light-switch', c: 'F97D' },
  { n: 'lightbulb', c: 'F335' },
  { n: 'lightbulb-on', c: 'F6E7' },
  { n: 'lightbulb-on-outline', c: 'F6E8' },
  { n: 'lightbulb-outline', c: 'F336' },
  { n: 'lighthouse', c: 'F9FE' },
  { n: 'lighthouse-on', c: 'F9FF' },
  { n: 'link', c: 'F337' },
  { n: 'link-box', c: 'FCF6' },
  { n: 'link-box-outline', c: 'FCF7' },
  { n: 'link-box-variant', c: 'FCF8' },
  { n: 'link-box-variant-outline', c: 'FCF9' },
  { n: 'link-off', c: 'F338' },
  { n: 'link-plus', c: 'FC70' },
  { n: 'link-variant', c: 'F339' },
  { n: 'link-variant-off', c: 'F33A' },
  { n: 'linkedin', c: 'F33B' },
  { n: 'linkedin-box', c: 'F33C' },
  { n: 'linux', c: 'F33D' },
  { n: 'linux-mint', c: 'F8EC' },
  { n: 'litecoin', c: 'FA60' },
  { n: 'loading', c: 'F771' },
  { n: 'lock', c: 'F33E' },
  { n: 'lock-alert', c: 'F8ED' },
  { n: 'lock-clock', c: 'F97E' },
  { n: 'lock-open', c: 'F33F' },
  { n: 'lock-open-outline', c: 'F340' },
  { n: 'lock-outline', c: 'F341' },
  { n: 'lock-pattern', c: 'F6E9' },
  { n: 'lock-plus', c: 'F5FB' },
  { n: 'lock-question', c: 'F8EE' },
  { n: 'lock-reset', c: 'F772' },
  { n: 'lock-smart', c: 'F8B1' },
  { n: 'locker', c: 'F7D6' },
  { n: 'locker-multiple', c: 'F7D7' },
  { n: 'login', c: 'F342' },
  { n: 'login-variant', c: 'F5FC' },
  { n: 'logout', c: 'F343' },
  { n: 'logout-variant', c: 'F5FD' },
  { n: 'looks', c: 'F344' },
  { n: 'loop', c: 'F6EA' },
  { n: 'loupe', c: 'F345' },
  { n: 'lumx', c: 'F346' },
  { n: 'lyft', c: 'FB1D' },
  { n: 'magnet', c: 'F347' },
  { n: 'magnet-on', c: 'F348' },
  { n: 'magnify', c: 'F349' },
  { n: 'magnify-close', c: 'F97F' },
  { n: 'magnify-minus', c: 'F34A' },
  { n: 'magnify-minus-cursor', c: 'FA61' },
  { n: 'magnify-minus-outline', c: 'F6EB' },
  { n: 'magnify-plus', c: 'F34B' },
  { n: 'magnify-plus-cursor', c: 'FA62' },
  { n: 'magnify-plus-outline', c: 'F6EC' },
  { n: 'mail-ru', c: 'F34C' },
  { n: 'mailbox', c: 'F6ED' },
  { n: 'mailbox-open', c: 'FD64' },
  { n: 'mailbox-open-outline', c: 'FD65' },
  { n: 'mailbox-open-up', c: 'FD66' },
  { n: 'mailbox-open-up-outline', c: 'FD67' },
  { n: 'mailbox-outline', c: 'FD68' },
  { n: 'mailbox-up', c: 'FD69' },
  { n: 'mailbox-up-outline', c: 'FD6A' },
  { n: 'map', c: 'F34D' },
  { n: 'map-clock', c: 'FCFA' },
  { n: 'map-clock-outline', c: 'FCFB' },
  { n: 'map-legend', c: 'FA00' },
  { n: 'map-marker', c: 'F34E' },
  { n: 'map-marker-check', c: 'FC71' },
  { n: 'map-marker-circle', c: 'F34F' },
  { n: 'map-marker-distance', c: 'F8EF' },
  { n: 'map-marker-minus', c: 'F650' },
  { n: 'map-marker-multiple', c: 'F350' },
  { n: 'map-marker-off', c: 'F351' },
  { n: 'map-marker-outline', c: 'F7D8' },
  { n: 'map-marker-path', c: 'FCFC' },
  { n: 'map-marker-plus', c: 'F651' },
  { n: 'map-marker-radius', c: 'F352' },
  { n: 'map-minus', c: 'F980' },
  { n: 'map-outline', c: 'F981' },
  { n: 'map-plus', c: 'F982' },
  { n: 'map-search', c: 'F983' },
  { n: 'map-search-outline', c: 'F984' },
  { n: 'mapbox', c: 'FB86' },
  { n: 'margin', c: 'F353' },
  { n: 'markdown', c: 'F354' },
  { n: 'marker', c: 'F652' },
  { n: 'marker-cancel', c: 'FDB5' },
  { n: 'marker-check', c: 'F355' },
  { n: 'mastodon', c: 'FAD0' },
  { n: 'mastodon-variant', c: 'FAD1' },
  { n: 'material-design', c: 'F985' },
  { n: 'material-ui', c: 'F357' },
  { n: 'math-compass', c: 'F358' },
  { n: 'math-cos', c: 'FC72' },
  { n: 'math-sin', c: 'FC73' },
  { n: 'math-tan', c: 'FC74' },
  { n: 'matrix', c: 'F628' },
  { n: 'maxcdn', c: 'F359' },
  { n: 'medal', c: 'F986' },
  { n: 'medical-bag', c: 'F6EE' },
  { n: 'medium', c: 'F35A' },
  { n: 'meetup', c: 'FAD2' },
  { n: 'memory', c: 'F35B' },
  { n: 'menu', c: 'F35C' },
  { n: 'menu-down', c: 'F35D' },
  { n: 'menu-down-outline', c: 'F6B5' },
  { n: 'menu-left', c: 'F35E' },
  { n: 'menu-left-outline', c: 'FA01' },
  { n: 'menu-open', c: 'FB87' },
  { n: 'menu-right', c: 'F35F' },
  { n: 'menu-right-outline', c: 'FA02' },
  { n: 'menu-swap', c: 'FA63' },
  { n: 'menu-swap-outline', c: 'FA64' },
  { n: 'menu-up', c: 'F360' },
  { n: 'menu-up-outline', c: 'F6B6' },
  { n: 'message', c: 'F361' },
  { n: 'message-alert', c: 'F362' },
  { n: 'message-alert-outline', c: 'FA03' },
  { n: 'message-bulleted', c: 'F6A1' },
  { n: 'message-bulleted-off', c: 'F6A2' },
  { n: 'message-draw', c: 'F363' },
  { n: 'message-image', c: 'F364' },
  { n: 'message-outline', c: 'F365' },
  { n: 'message-plus', c: 'F653' },
  { n: 'message-processing', c: 'F366' },
  { n: 'message-reply', c: 'F367' },
  { n: 'message-reply-text', c: 'F368' },
  { n: 'message-settings', c: 'F6EF' },
  { n: 'message-settings-variant', c: 'F6F0' },
  { n: 'message-text', c: 'F369' },
  { n: 'message-text-outline', c: 'F36A' },
  { n: 'message-video', c: 'F36B' },
  { n: 'meteor', c: 'F629' },
  { n: 'metronome', c: 'F7D9' },
  { n: 'metronome-tick', c: 'F7DA' },
  { n: 'micro-sd', c: 'F7DB' },
  { n: 'microphone', c: 'F36C' },
  { n: 'microphone-minus', c: 'F8B2' },
  { n: 'microphone-off', c: 'F36D' },
  { n: 'microphone-outline', c: 'F36E' },
  { n: 'microphone-plus', c: 'F8B3' },
  { n: 'microphone-settings', c: 'F36F' },
  { n: 'microphone-variant', c: 'F370' },
  { n: 'microphone-variant-off', c: 'F371' },
  { n: 'microscope', c: 'F654' },
  { n: 'microsoft', c: 'F372' },
  { n: 'microsoft-dynamics', c: 'F987' },
  { n: 'microwave', c: 'FC75' },
  { n: 'midi', c: 'F8F0' },
  { n: 'midi-port', c: 'F8F1' },
  { n: 'mine', c: 'FDB6' },
  { n: 'minecraft', c: 'F373' },
  { n: 'mini-sd', c: 'FA04' },
  { n: 'minidisc', c: 'FA05' },
  { n: 'minus', c: 'F374' },
  { n: 'minus-box', c: 'F375' },
  { n: 'minus-box-outline', c: 'F6F1' },
  { n: 'minus-circle', c: 'F376' },
  { n: 'minus-circle-outline', c: 'F377' },
  { n: 'minus-network', c: 'F378' },
  { n: 'minus-network-outline', c: 'FC76' },
  { n: 'mixcloud', c: 'F62A' },
  { n: 'mixed-martial-arts', c: 'FD6B' },
  { n: 'mixed-reality', c: 'F87E' },
  { n: 'mixer', c: 'F7DC' },
  { n: 'molecule', c: 'FB88' },
  { n: 'monitor', c: 'F379' },
  { n: 'monitor-cellphone', c: 'F988' },
  { n: 'monitor-cellphone-star', c: 'F989' },
  { n: 'monitor-dashboard', c: 'FA06' },
  { n: 'monitor-lock', c: 'FDB7' },
  { n: 'monitor-multiple', c: 'F37A' },
  { n: 'monitor-off', c: 'FD6C' },
  { n: 'monitor-star', c: 'FDB8' },
  { n: 'more', c: 'F37B' },
  { n: 'mother-nurse', c: 'FCFD' },
  { n: 'motion-sensor', c: 'FD6D' },
  { n: 'motorbike', c: 'F37C' },
  { n: 'mouse', c: 'F37D' },
  { n: 'mouse-bluetooth', c: 'F98A' },
  { n: 'mouse-off', c: 'F37E' },
  { n: 'mouse-variant', c: 'F37F' },
  { n: 'mouse-variant-off', c: 'F380' },
  { n: 'move-resize', c: 'F655' },
  { n: 'move-resize-variant', c: 'F656' },
  { n: 'movie', c: 'F381' },
  { n: 'movie-outline', c: 'FDB9' },
  { n: 'movie-roll', c: 'F7DD' },
  { n: 'muffin', c: 'F98B' },
  { n: 'multiplication', c: 'F382' },
  { n: 'multiplication-box', c: 'F383' },
  { n: 'mushroom', c: 'F7DE' },
  { n: 'mushroom-outline', c: 'F7DF' },
  { n: 'music', c: 'F759' },
  { n: 'music-box', c: 'F384' },
  { n: 'music-box-outline', c: 'F385' },
  { n: 'music-circle', c: 'F386' },
  { n: 'music-circle-outline', c: 'FAD3' },
  { n: 'music-note', c: 'F387' },
  { n: 'music-note-bluetooth', c: 'F5FE' },
  { n: 'music-note-bluetooth-off', c: 'F5FF' },
  { n: 'music-note-eighth', c: 'F388' },
  { n: 'music-note-half', c: 'F389' },
  { n: 'music-note-off', c: 'F38A' },
  { n: 'music-note-plus', c: 'FDBA' },
  { n: 'music-note-quarter', c: 'F38B' },
  { n: 'music-note-sixteenth', c: 'F38C' },
  { n: 'music-note-whole', c: 'F38D' },
  { n: 'music-off', c: 'F75A' },
  { n: 'nail', c: 'FDBB' },
  { n: 'nas', c: 'F8F2' },
  { n: 'nativescript', c: 'F87F' },
  { n: 'nature', c: 'F38E' },
  { n: 'nature-people', c: 'F38F' },
  { n: 'navigation', c: 'F390' },
  { n: 'near-me', c: 'F5CD' },
  { n: 'needle', c: 'F391' },
  { n: 'netflix', c: 'F745' },
  { n: 'network', c: 'F6F2' },
  { n: 'network-off', c: 'FC77' },
  { n: 'network-off-outline', c: 'FC78' },
  { n: 'network-outline', c: 'FC79' },
  { n: 'network-strength-1', c: 'F8F3' },
  { n: 'network-strength-1-alert', c: 'F8F4' },
  { n: 'network-strength-2', c: 'F8F5' },
  { n: 'network-strength-2-alert', c: 'F8F6' },
  { n: 'network-strength-3', c: 'F8F7' },
  { n: 'network-strength-3-alert', c: 'F8F8' },
  { n: 'network-strength-4', c: 'F8F9' },
  { n: 'network-strength-4-alert', c: 'F8FA' },
  { n: 'network-strength-off', c: 'F8FB' },
  { n: 'network-strength-off-outline', c: 'F8FC' },
  { n: 'network-strength-outline', c: 'F8FD' },
  { n: 'new-box', c: 'F394' },
  { n: 'newspaper', c: 'F395' },
  { n: 'nfc', c: 'F396' },
  { n: 'nfc-tap', c: 'F397' },
  { n: 'nfc-variant', c: 'F398' },
  { n: 'ninja', c: 'F773' },
  { n: 'nintendo-switch', c: 'F7E0' },
  { n: 'nodejs', c: 'F399' },
  { n: 'not-equal', c: 'F98C' },
  { n: 'not-equal-variant', c: 'F98D' },
  { n: 'note', c: 'F39A' },
  { n: 'note-multiple', c: 'F6B7' },
  { n: 'note-multiple-outline', c: 'F6B8' },
  { n: 'note-outline', c: 'F39B' },
  { n: 'note-plus', c: 'F39C' },
  { n: 'note-plus-outline', c: 'F39D' },
  { n: 'note-text', c: 'F39E' },
  { n: 'notebook', c: 'F82D' },
  { n: 'notification-clear-all', c: 'F39F' },
  { n: 'npm', c: 'F6F6' },
  { n: 'npm-variant', c: 'F98E' },
  { n: 'npm-variant-outline', c: 'F98F' },
  { n: 'nuke', c: 'F6A3' },
  { n: 'null', c: 'F7E1' },
  { n: 'numeric', c: 'F3A0' },
  { n: 'numeric-0', c: '0030' },
  { n: 'numeric-0-box', c: 'F3A1' },
  { n: 'numeric-0-box-multiple-outline', c: 'F3A2' },
  { n: 'numeric-0-box-outline', c: 'F3A3' },
  { n: 'numeric-0-circle', c: 'FC7A' },
  { n: 'numeric-0-circle-outline', c: 'FC7B' },
  { n: 'numeric-1', c: '0031' },
  { n: 'numeric-1-box', c: 'F3A4' },
  { n: 'numeric-1-box-multiple-outline', c: 'F3A5' },
  { n: 'numeric-1-box-outline', c: 'F3A6' },
  { n: 'numeric-1-circle', c: 'FC7C' },
  { n: 'numeric-1-circle-outline', c: 'FC7D' },
  { n: 'numeric-2', c: '0032' },
  { n: 'numeric-2-box', c: 'F3A7' },
  { n: 'numeric-2-box-multiple-outline', c: 'F3A8' },
  { n: 'numeric-2-box-outline', c: 'F3A9' },
  { n: 'numeric-2-circle', c: 'FC7E' },
  { n: 'numeric-2-circle-outline', c: 'FC7F' },
  { n: 'numeric-3', c: '0033' },
  { n: 'numeric-3-box', c: 'F3AA' },
  { n: 'numeric-3-box-multiple-outline', c: 'F3AB' },
  { n: 'numeric-3-box-outline', c: 'F3AC' },
  { n: 'numeric-3-circle', c: 'FC80' },
  { n: 'numeric-3-circle-outline', c: 'FC81' },
  { n: 'numeric-4', c: '0034' },
  { n: 'numeric-4-box', c: 'F3AD' },
  { n: 'numeric-4-box-multiple-outline', c: 'F3AE' },
  { n: 'numeric-4-box-outline', c: 'F3AF' },
  { n: 'numeric-4-circle', c: 'FC82' },
  { n: 'numeric-4-circle-outline', c: 'FC83' },
  { n: 'numeric-5', c: '0035' },
  { n: 'numeric-5-box', c: 'F3B0' },
  { n: 'numeric-5-box-multiple-outline', c: 'F3B1' },
  { n: 'numeric-5-box-outline', c: 'F3B2' },
  { n: 'numeric-5-circle', c: 'FC84' },
  { n: 'numeric-5-circle-outline', c: 'FC85' },
  { n: 'numeric-6', c: '0036' },
  { n: 'numeric-6-box', c: 'F3B3' },
  { n: 'numeric-6-box-multiple-outline', c: 'F3B4' },
  { n: 'numeric-6-box-outline', c: 'F3B5' },
  { n: 'numeric-6-circle', c: 'FC86' },
  { n: 'numeric-6-circle-outline', c: 'FC87' },
  { n: 'numeric-7', c: '0037' },
  { n: 'numeric-7-box', c: 'F3B6' },
  { n: 'numeric-7-box-multiple-outline', c: 'F3B7' },
  { n: 'numeric-7-box-outline', c: 'F3B8' },
  { n: 'numeric-7-circle', c: 'FC88' },
  { n: 'numeric-7-circle-outline', c: 'FC89' },
  { n: 'numeric-8', c: '0038' },
  { n: 'numeric-8-box', c: 'F3B9' },
  { n: 'numeric-8-box-multiple-outline', c: 'F3BA' },
  { n: 'numeric-8-box-outline', c: 'F3BB' },
  { n: 'numeric-8-circle', c: 'FC8A' },
  { n: 'numeric-8-circle-outline', c: 'FC8B' },
  { n: 'numeric-9', c: '0039' },
  { n: 'numeric-9-box', c: 'F3BC' },
  { n: 'numeric-9-box-multiple-outline', c: 'F3BD' },
  { n: 'numeric-9-box-outline', c: 'F3BE' },
  { n: 'numeric-9-circle', c: 'FC8C' },
  { n: 'numeric-9-circle-outline', c: 'FC8D' },
  { n: 'numeric-9-plus-box', c: 'F3BF' },
  { n: 'numeric-9-plus-box-multiple-outline', c: 'F3C0' },
  { n: 'numeric-9-plus-box-outline', c: 'F3C1' },
  { n: 'numeric-9-plus-circle', c: 'FC8E' },
  { n: 'numeric-9-plus-circle-outline', c: 'FC8F' },
  { n: 'nut', c: 'F6F7' },
  { n: 'nutrition', c: 'F3C2' },
  { n: 'oar', c: 'F67B' },
  { n: 'ocarina', c: 'FDBC' },
  { n: 'octagon', c: 'F3C3' },
  { n: 'octagon-outline', c: 'F3C4' },
  { n: 'octagram', c: 'F6F8' },
  { n: 'octagram-outline', c: 'F774' },
  { n: 'odnoklassniki', c: 'F3C5' },
  { n: 'office', c: 'F3C6' },
  { n: 'office-building', c: 'F990' },
  { n: 'oil', c: 'F3C7' },
  { n: 'oil-temperature', c: 'F3C8' },
  { n: 'omega', c: 'F3C9' },
  { n: 'one-up', c: 'FB89' },
  { n: 'onedrive', c: 'F3CA' },
  { n: 'onenote', c: 'F746' },
  { n: 'onepassword', c: 'F880' },
  { n: 'opacity', c: 'F5CC' },
  { n: 'open-in-app', c: 'F3CB' },
  { n: 'open-in-new', c: 'F3CC' },
  { n: 'open-source-initiative', c: 'FB8A' },
  { n: 'openid', c: 'F3CD' },
  { n: 'opera', c: 'F3CE' },
  { n: 'orbit', c: 'F018' },
  { n: 'origin', c: 'FB2B' },
  { n: 'ornament', c: 'F3CF' },
  { n: 'ornament-variant', c: 'F3D0' },
  { n: 'outlook', c: 'FCFE' },
  { n: 'owl', c: 'F3D2' },
  { n: 'pac-man', c: 'FB8B' },
  { n: 'package', c: 'F3D3' },
  { n: 'package-down', c: 'F3D4' },
  { n: 'package-up', c: 'F3D5' },
  { n: 'package-variant', c: 'F3D6' },
  { n: 'package-variant-closed', c: 'F3D7' },
  { n: 'page-first', c: 'F600' },
  { n: 'page-last', c: 'F601' },
  { n: 'page-layout-body', c: 'F6F9' },
  { n: 'page-layout-footer', c: 'F6FA' },
  { n: 'page-layout-header', c: 'F6FB' },
  { n: 'page-layout-sidebar-left', c: 'F6FC' },
  { n: 'page-layout-sidebar-right', c: 'F6FD' },
  { n: 'page-next', c: 'FB8C' },
  { n: 'page-next-outline', c: 'FB8D' },
  { n: 'page-previous', c: 'FB8E' },
  { n: 'page-previous-outline', c: 'FB8F' },
  { n: 'palette', c: 'F3D8' },
  { n: 'palette-advanced', c: 'F3D9' },
  { n: 'palette-outline', c: 'FDE8' },
  { n: 'palette-swatch', c: 'F8B4' },
  { n: 'pan', c: 'FB90' },
  { n: 'pan-bottom-left', c: 'FB91' },
  { n: 'pan-bottom-right', c: 'FB92' },
  { n: 'pan-down', c: 'FB93' },
  { n: 'pan-horizontal', c: 'FB94' },
  { n: 'pan-left', c: 'FB95' },
  { n: 'pan-right', c: 'FB96' },
  { n: 'pan-top-left', c: 'FB97' },
  { n: 'pan-top-right', c: 'FB98' },
  { n: 'pan-up', c: 'FB99' },
  { n: 'pan-vertical', c: 'FB9A' },
  { n: 'panda', c: 'F3DA' },
  { n: 'pandora', c: 'F3DB' },
  { n: 'panorama', c: 'F3DC' },
  { n: 'panorama-fisheye', c: 'F3DD' },
  { n: 'panorama-horizontal', c: 'F3DE' },
  { n: 'panorama-vertical', c: 'F3DF' },
  { n: 'panorama-wide-angle', c: 'F3E0' },
  { n: 'paper-cut-vertical', c: 'F3E1' },
  { n: 'paperclip', c: 'F3E2' },
  { n: 'parachute', c: 'FC90' },
  { n: 'parachute-outline', c: 'FC91' },
  { n: 'parking', c: 'F3E3' },
  { n: 'passport', c: 'F7E2' },
  { n: 'passport-biometric', c: 'FDBD' },
  { n: 'patreon', c: 'F881' },
  { n: 'pause', c: 'F3E4' },
  { n: 'pause-circle', c: 'F3E5' },
  { n: 'pause-circle-outline', c: 'F3E6' },
  { n: 'pause-octagon', c: 'F3E7' },
  { n: 'pause-octagon-outline', c: 'F3E8' },
  { n: 'paw', c: 'F3E9' },
  { n: 'paw-off', c: 'F657' },
  { n: 'paypal', c: 'F882' },
  { n: 'peace', c: 'F883' },
  { n: 'pen', c: 'F3EA' },
  { n: 'pen-lock', c: 'FDBE' },
  { n: 'pen-minus', c: 'FDBF' },
  { n: 'pen-off', c: 'FDC0' },
  { n: 'pen-plus', c: 'FDC1' },
  { n: 'pen-remove', c: 'FDC2' },
  { n: 'pencil', c: 'F3EB' },
  { n: 'pencil-box', c: 'F3EC' },
  { n: 'pencil-box-outline', c: 'F3ED' },
  { n: 'pencil-circle', c: 'F6FE' },
  { n: 'pencil-circle-outline', c: 'F775' },
  { n: 'pencil-lock', c: 'F3EE' },
  { n: 'pencil-lock-outline', c: 'FDC3' },
  { n: 'pencil-minus', c: 'FDC4' },
  { n: 'pencil-minus-outline', c: 'FDC5' },
  { n: 'pencil-off', c: 'F3EF' },
  { n: 'pencil-off-outline', c: 'FDC6' },
  { n: 'pencil-outline', c: 'FC92' },
  { n: 'pencil-plus', c: 'FDC7' },
  { n: 'pencil-plus-outline', c: 'FDC8' },
  { n: 'pencil-remove', c: 'FDC9' },
  { n: 'pencil-remove-outline', c: 'FDCA' },
  { n: 'pentagon', c: 'F6FF' },
  { n: 'pentagon-outline', c: 'F700' },
  { n: 'percent', c: 'F3F0' },
  { n: 'periodic-table', c: 'F8B5' },
  { n: 'periodic-table-co2', c: 'F7E3' },
  { n: 'periscope', c: 'F747' },
  { n: 'perspective-less', c: 'FCFF' },
  { n: 'perspective-more', c: 'FD00' },
  { n: 'pharmacy', c: 'F3F1' },
  { n: 'phone', c: 'F3F2' },
  { n: 'phone-bluetooth', c: 'F3F3' },
  { n: 'phone-classic', c: 'F602' },
  { n: 'phone-forward', c: 'F3F4' },
  { n: 'phone-hangup', c: 'F3F5' },
  { n: 'phone-in-talk', c: 'F3F6' },
  { n: 'phone-incoming', c: 'F3F7' },
  { n: 'phone-lock', c: 'F3F8' },
  { n: 'phone-log', c: 'F3F9' },
  { n: 'phone-minus', c: 'F658' },
  { n: 'phone-missed', c: 'F3FA' },
  { n: 'phone-off', c: 'FDCB' },
  { n: 'phone-outgoing', c: 'F3FB' },
  { n: 'phone-outline', c: 'FDCC' },
  { n: 'phone-paused', c: 'F3FC' },
  { n: 'phone-plus', c: 'F659' },
  { n: 'phone-return', c: 'F82E' },
  { n: 'phone-rotate-landscape', c: 'F884' },
  { n: 'phone-rotate-portrait', c: 'F885' },
  { n: 'phone-settings', c: 'F3FD' },
  { n: 'phone-voip', c: 'F3FE' },
  { n: 'pi', c: 'F3FF' },
  { n: 'pi-box', c: 'F400' },
  { n: 'pi-hole', c: 'FDCD' },
  { n: 'piano', c: 'F67C' },
  { n: 'pickaxe', c: 'F8B6' },
  { n: 'pier', c: 'F886' },
  { n: 'pier-crane', c: 'F887' },
  { n: 'pig', c: 'F401' },
  { n: 'pill', c: 'F402' },
  { n: 'pillar', c: 'F701' },
  { n: 'pin', c: 'F403' },
  { n: 'pin-off', c: 'F404' },
  { n: 'pin-off-outline', c: 'F92F' },
  { n: 'pin-outline', c: 'F930' },
  { n: 'pine-tree', c: 'F405' },
  { n: 'pine-tree-box', c: 'F406' },
  { n: 'pinterest', c: 'F407' },
  { n: 'pinterest-box', c: 'F408' },
  { n: 'pinwheel', c: 'FAD4' },
  { n: 'pinwheel-outline', c: 'FAD5' },
  { n: 'pipe', c: 'F7E4' },
  { n: 'pipe-disconnected', c: 'F7E5' },
  { n: 'pipe-leak', c: 'F888' },
  { n: 'pirate', c: 'FA07' },
  { n: 'pistol', c: 'F702' },
  { n: 'piston', c: 'F889' },
  { n: 'pizza', c: 'F409' },
  { n: 'play', c: 'F40A' },
  { n: 'play-box-outline', c: 'F40B' },
  { n: 'play-circle', c: 'F40C' },
  { n: 'play-circle-outline', c: 'F40D' },
  { n: 'play-network', c: 'F88A' },
  { n: 'play-network-outline', c: 'FC93' },
  { n: 'play-pause', c: 'F40E' },
  { n: 'play-protected-content', c: 'F40F' },
  { n: 'play-speed', c: 'F8FE' },
  { n: 'playlist-check', c: 'F5C7' },
  { n: 'playlist-edit', c: 'F8FF' },
  { n: 'playlist-minus', c: 'F410' },
  { n: 'playlist-music', c: 'FC94' },
  { n: 'playlist-music-outline', c: 'FC95' },
  { n: 'playlist-play', c: 'F411' },
  { n: 'playlist-plus', c: 'F412' },
  { n: 'playlist-remove', c: 'F413' },
  { n: 'playlist-star', c: 'FDCE' },
  { n: 'playstation', c: 'F414' },
  { n: 'plex', c: 'F6B9' },
  { n: 'plus', c: 'F415' },
  { n: 'plus-box', c: 'F416' },
  { n: 'plus-box-outline', c: 'F703' },
  { n: 'plus-circle', c: 'F417' },
  { n: 'plus-circle-multiple-outline', c: 'F418' },
  { n: 'plus-circle-outline', c: 'F419' },
  { n: 'plus-minus', c: 'F991' },
  { n: 'plus-minus-box', c: 'F992' },
  { n: 'plus-network', c: 'F41A' },
  { n: 'plus-network-outline', c: 'FC96' },
  { n: 'plus-one', c: 'F41B' },
  { n: 'plus-outline', c: 'F704' },
  { n: 'pocket', c: 'F41C' },
  { n: 'podcast', c: 'F993' },
  { n: 'podium', c: 'FD01' },
  { n: 'podium-bronze', c: 'FD02' },
  { n: 'podium-gold', c: 'FD03' },
  { n: 'podium-silver', c: 'FD04' },
  { n: 'point-of-sale', c: 'FD6E' },
  { n: 'pokeball', c: 'F41D' },
  { n: 'pokemon-go', c: 'FA08' },
  { n: 'poker-chip', c: 'F82F' },
  { n: 'polaroid', c: 'F41E' },
  { n: 'poll', c: 'F41F' },
  { n: 'poll-box', c: 'F420' },
  { n: 'polymer', c: 'F421' },
  { n: 'pool', c: 'F606' },
  { n: 'popcorn', c: 'F422' },
  { n: 'postage-stamp', c: 'FC97' },
  { n: 'pot', c: 'F65A' },
  { n: 'pot-mix', c: 'F65B' },
  { n: 'pound', c: 'F423' },
  { n: 'pound-box', c: 'F424' },
  { n: 'power', c: 'F425' },
  { n: 'power-cycle', c: 'F900' },
  { n: 'power-off', c: 'F901' },
  { n: 'power-on', c: 'F902' },
  { n: 'power-plug', c: 'F6A4' },
  { n: 'power-plug-off', c: 'F6A5' },
  { n: 'power-settings', c: 'F426' },
  { n: 'power-sleep', c: 'F903' },
  { n: 'power-socket', c: 'F427' },
  { n: 'power-socket-au', c: 'F904' },
  { n: 'power-socket-eu', c: 'F7E6' },
  { n: 'power-socket-uk', c: 'F7E7' },
  { n: 'power-socket-us', c: 'F7E8' },
  { n: 'power-standby', c: 'F905' },
  { n: 'powershell', c: 'FA09' },
  { n: 'prescription', c: 'F705' },
  { n: 'presentation', c: 'F428' },
  { n: 'presentation-play', c: 'F429' },
  { n: 'printer', c: 'F42A' },
  { n: 'printer-3d', c: 'F42B' },
  { n: 'printer-alert', c: 'F42C' },
  { n: 'printer-settings', c: 'F706' },
  { n: 'printer-wireless', c: 'FA0A' },
  { n: 'priority-high', c: 'F603' },
  { n: 'priority-low', c: 'F604' },
  { n: 'professional-hexagon', c: 'F42D' },
  { n: 'progress-alert', c: 'FC98' },
  { n: 'progress-check', c: 'F994' },
  { n: 'progress-clock', c: 'F995' },
  { n: 'progress-download', c: 'F996' },
  { n: 'progress-upload', c: 'F997' },
  { n: 'progress-wrench', c: 'FC99' },
  { n: 'projector', c: 'F42E' },
  { n: 'projector-screen', c: 'F42F' },
  { n: 'publish', c: 'F6A6' },
  { n: 'pulse', c: 'F430' },
  { n: 'pumpkin', c: 'FB9B' },
  { n: 'puzzle', c: 'F431' },
  { n: 'puzzle-outline', c: 'FA65' },
  { n: 'qi', c: 'F998' },
  { n: 'qqchat', c: 'F605' },
  { n: 'qrcode', c: 'F432' },
  { n: 'qrcode-edit', c: 'F8B7' },
  { n: 'qrcode-scan', c: 'F433' },
  { n: 'quadcopter', c: 'F434' },
  { n: 'quality-high', c: 'F435' },
  { n: 'quality-low', c: 'FA0B' },
  { n: 'quality-medium', c: 'FA0C' },
  { n: 'quicktime', c: 'F436' },
  { n: 'quora', c: 'FD05' },
  { n: 'rabbit', c: 'F906' },
  { n: 'racing-helmet', c: 'FD6F' },
  { n: 'racquetball', c: 'FD70' },
  { n: 'radar', c: 'F437' },
  { n: 'radiator', c: 'F438' },
  { n: 'radiator-disabled', c: 'FAD6' },
  { n: 'radiator-off', c: 'FAD7' },
  { n: 'radio', c: 'F439' },
  { n: 'radio-am', c: 'FC9A' },
  { n: 'radio-fm', c: 'FC9B' },
  { n: 'radio-handheld', c: 'F43A' },
  { n: 'radio-tower', c: 'F43B' },
  { n: 'radioactive', c: 'F43C' },
  { n: 'radiobox-blank', c: 'F43D' },
  { n: 'radiobox-marked', c: 'F43E' },
  { n: 'radius', c: 'FC9C' },
  { n: 'radius-outline', c: 'FC9D' },
  { n: 'raspberry-pi', c: 'F43F' },
  { n: 'ray-end', c: 'F440' },
  { n: 'ray-end-arrow', c: 'F441' },
  { n: 'ray-start', c: 'F442' },
  { n: 'ray-start-arrow', c: 'F443' },
  { n: 'ray-start-end', c: 'F444' },
  { n: 'ray-vertex', c: 'F445' },
  { n: 'react', c: 'F707' },
  { n: 'read', c: 'F447' },
  { n: 'receipt', c: 'F449' },
  { n: 'record', c: 'F44A' },
  { n: 'record-player', c: 'F999' },
  { n: 'record-rec', c: 'F44B' },
  { n: 'recycle', c: 'F44C' },
  { n: 'reddit', c: 'F44D' },
  { n: 'redo', c: 'F44E' },
  { n: 'redo-variant', c: 'F44F' },
  { n: 'reflect-horizontal', c: 'FA0D' },
  { n: 'reflect-vertical', c: 'FA0E' },
  { n: 'refresh', c: 'F450' },
  { n: 'regex', c: 'F451' },
  { n: 'registered-trademark', c: 'FA66' },
  { n: 'relative-scale', c: 'F452' },
  { n: 'reload', c: 'F453' },
  { n: 'reminder', c: 'F88B' },
  { n: 'remote', c: 'F454' },
  { n: 'remote-desktop', c: 'F8B8' },
  { n: 'rename-box', c: 'F455' },
  { n: 'reorder-horizontal', c: 'F687' },
  { n: 'reorder-vertical', c: 'F688' },
  { n: 'repeat', c: 'F456' },
  { n: 'repeat-off', c: 'F457' },
  { n: 'repeat-once', c: 'F458' },
  { n: 'replay', c: 'F459' },
  { n: 'reply', c: 'F45A' },
  { n: 'reply-all', c: 'F45B' },
  { n: 'reproduction', c: 'F45C' },
  { n: 'resistor', c: 'FB1F' },
  { n: 'resistor-nodes', c: 'FB20' },
  { n: 'resize', c: 'FA67' },
  { n: 'resize-bottom-right', c: 'F45D' },
  { n: 'responsive', c: 'F45E' },
  { n: 'restart', c: 'F708' },
  { n: 'restart-off', c: 'FD71' },
  { n: 'restore', c: 'F99A' },
  { n: 'restore-clock', c: 'F6A7' },
  { n: 'rewind', c: 'F45F' },
  { n: 'rewind-10', c: 'FD06' },
  { n: 'rewind-30', c: 'FD72' },
  { n: 'rewind-outline', c: 'F709' },
  { n: 'rhombus', c: 'F70A' },
  { n: 'rhombus-medium', c: 'FA0F' },
  { n: 'rhombus-outline', c: 'F70B' },
  { n: 'rhombus-split', c: 'FA10' },
  { n: 'ribbon', c: 'F460' },
  { n: 'rice', c: 'F7E9' },
  { n: 'ring', c: 'F7EA' },
  { n: 'road', c: 'F461' },
  { n: 'road-variant', c: 'F462' },
  { n: 'robot', c: 'F6A8' },
  { n: 'robot-industrial', c: 'FB21' },
  { n: 'robot-vacuum', c: 'F70C' },
  { n: 'robot-vacuum-variant', c: 'F907' },
  { n: 'rocket', c: 'F463' },
  { n: 'roller-skate', c: 'FD07' },
  { n: 'rollerblade', c: 'FD08' },
  { n: 'rollupjs', c: 'FB9C' },
  { n: 'room-service', c: 'F88C' },
  { n: 'room-service-outline', c: 'FD73' },
  { n: 'rotate-3d', c: 'F464' },
  { n: 'rotate-left', c: 'F465' },
  { n: 'rotate-left-variant', c: 'F466' },
  { n: 'rotate-orbit', c: 'FD74' },
  { n: 'rotate-right', c: 'F467' },
  { n: 'rotate-right-variant', c: 'F468' },
  { n: 'rounded-corner', c: 'F607' },
  { n: 'router-wireless', c: 'F469' },
  { n: 'router-wireless-settings', c: 'FA68' },
  { n: 'routes', c: 'F46A' },
  { n: 'rowing', c: 'F608' },
  { n: 'rss', c: 'F46B' },
  { n: 'rss-box', c: 'F46C' },
  { n: 'ruby', c: 'FD09' },
  { n: 'rugby', c: 'FD75' },
  { n: 'ruler', c: 'F46D' },
  { n: 'ruler-square', c: 'FC9E' },
  { n: 'run', c: 'F70D' },
  { n: 'run-fast', c: 'F46E' },
  { n: 'sack', c: 'FD0A' },
  { n: 'sack-percent', c: 'FD0B' },
  { n: 'safe', c: 'FA69' },
  { n: 'safety-goggles', c: 'FD0C' },
  { n: 'sale', c: 'F46F' },
  { n: 'salesforce', c: 'F88D' },
  { n: 'sass', c: 'F7EB' },
  { n: 'satellite', c: 'F470' },
  { n: 'satellite-uplink', c: 'F908' },
  { n: 'satellite-variant', c: 'F471' },
  { n: 'sausage', c: 'F8B9' },
  { n: 'saxophone', c: 'F609' },
  { n: 'scale', c: 'F472' },
  { n: 'scale-balance', c: 'F5D1' },
  { n: 'scale-bathroom', c: 'F473' },
  { n: 'scanner', c: 'F6AA' },
  { n: 'scanner-off', c: 'F909' },
  { n: 'school', c: 'F474' },
  { n: 'scissors-cutting', c: 'FA6A' },
  { n: 'screen-rotation', c: 'F475' },
  { n: 'screen-rotation-lock', c: 'F476' },
  { n: 'screw-flat-top', c: 'FDCF' },
  { n: 'screw-lag', c: 'FDD0' },
  { n: 'screw-machine-flat-top', c: 'FDD1' },
  { n: 'screw-machine-round-top', c: 'FDD2' },
  { n: 'screw-round-top', c: 'FDD3' },
  { n: 'screwdriver', c: 'F477' },
  { n: 'script', c: 'FB9D' },
  { n: 'script-outline', c: 'F478' },
  { n: 'script-text', c: 'FB9E' },
  { n: 'script-text-outline', c: 'FB9F' },
  { n: 'sd', c: 'F479' },
  { n: 'seal', c: 'F47A' },
  { n: 'search-web', c: 'F70E' },
  { n: 'seat', c: 'FC9F' },
  { n: 'seat-flat', c: 'F47B' },
  { n: 'seat-flat-angled', c: 'F47C' },
  { n: 'seat-individual-suite', c: 'F47D' },
  { n: 'seat-legroom-extra', c: 'F47E' },
  { n: 'seat-legroom-normal', c: 'F47F' },
  { n: 'seat-legroom-reduced', c: 'F480' },
  { n: 'seat-outline', c: 'FCA0' },
  { n: 'seat-recline-extra', c: 'F481' },
  { n: 'seat-recline-normal', c: 'F482' },
  { n: 'seatbelt', c: 'FCA1' },
  { n: 'security', c: 'F483' },
  { n: 'security-network', c: 'F484' },
  { n: 'select', c: 'F485' },
  { n: 'select-all', c: 'F486' },
  { n: 'select-color', c: 'FD0D' },
  { n: 'select-compare', c: 'FAD8' },
  { n: 'select-drag', c: 'FA6B' },
  { n: 'select-inverse', c: 'F487' },
  { n: 'select-off', c: 'F488' },
  { n: 'selection', c: 'F489' },
  { n: 'selection-drag', c: 'FA6C' },
  { n: 'selection-ellipse', c: 'FD0E' },
  { n: 'selection-off', c: 'F776' },
  { n: 'send', c: 'F48A' },
  { n: 'send-circle', c: 'FDD4' },
  { n: 'send-circle-outline', c: 'FDD5' },
  { n: 'send-lock', c: 'F7EC' },
  { n: 'serial-port', c: 'F65C' },
  { n: 'server', c: 'F48B' },
  { n: 'server-minus', c: 'F48C' },
  { n: 'server-network', c: 'F48D' },
  { n: 'server-network-off', c: 'F48E' },
  { n: 'server-off', c: 'F48F' },
  { n: 'server-plus', c: 'F490' },
  { n: 'server-remove', c: 'F491' },
  { n: 'server-security', c: 'F492' },
  { n: 'set-all', c: 'F777' },
  { n: 'set-center', c: 'F778' },
  { n: 'set-center-right', c: 'F779' },
  { n: 'set-left', c: 'F77A' },
  { n: 'set-left-center', c: 'F77B' },
  { n: 'set-left-right', c: 'F77C' },
  { n: 'set-none', c: 'F77D' },
  { n: 'set-right', c: 'F77E' },
  { n: 'set-top-box', c: 'F99E' },
  { n: 'settings', c: 'F493' },
  { n: 'settings-box', c: 'F494' },
  { n: 'settings-helper', c: 'FA6D' },
  { n: 'settings-outline', c: 'F8BA' },
  { n: 'shape', c: 'F830' },
  { n: 'shape-circle-plus', c: 'F65D' },
  { n: 'shape-outline', c: 'F831' },
  { n: 'shape-plus', c: 'F495' },
  { n: 'shape-polygon-plus', c: 'F65E' },
  { n: 'shape-rectangle-plus', c: 'F65F' },
  { n: 'shape-square-plus', c: 'F660' },
  { n: 'share', c: 'F496' },
  { n: 'share-outline', c: 'F931' },
  { n: 'share-variant', c: 'F497' },
  { n: 'sheep', c: 'FCA2' },
  { n: 'shield', c: 'F498' },
  { n: 'shield-account', c: 'F88E' },
  { n: 'shield-account-outline', c: 'FA11' },
  { n: 'shield-airplane', c: 'F6BA' },
  { n: 'shield-airplane-outline', c: 'FCA3' },
  { n: 'shield-check', c: 'F565' },
  { n: 'shield-check-outline', c: 'FCA4' },
  { n: 'shield-cross', c: 'FCA5' },
  { n: 'shield-cross-outline', c: 'FCA6' },
  { n: 'shield-half-full', c: 'F77F' },
  { n: 'shield-home', c: 'F689' },
  { n: 'shield-home-outline', c: 'FCA7' },
  { n: 'shield-key', c: 'FBA0' },
  { n: 'shield-key-outline', c: 'FBA1' },
  { n: 'shield-link-variant', c: 'FD0F' },
  { n: 'shield-link-variant-outline', c: 'FD10' },
  { n: 'shield-lock', c: 'F99C' },
  { n: 'shield-lock-outline', c: 'FCA8' },
  { n: 'shield-off', c: 'F99D' },
  { n: 'shield-off-outline', c: 'F99B' },
  { n: 'shield-outline', c: 'F499' },
  { n: 'shield-plus', c: 'FAD9' },
  { n: 'shield-plus-outline', c: 'FADA' },
  { n: 'shield-remove', c: 'FADB' },
  { n: 'shield-remove-outline', c: 'FADC' },
  { n: 'shield-search', c: 'FD76' },
  { n: 'ship-wheel', c: 'F832' },
  { n: 'shoe-formal', c: 'FB22' },
  { n: 'shoe-heel', c: 'FB23' },
  { n: 'shoe-print', c: 'FDD6' },
  { n: 'shopify', c: 'FADD' },
  { n: 'shopping', c: 'F49A' },
  { n: 'shopping-music', c: 'F49B' },
  { n: 'shovel', c: 'F70F' },
  { n: 'shovel-off', c: 'F710' },
  { n: 'shower', c: 'F99F' },
  { n: 'shower-head', c: 'F9A0' },
  { n: 'shredder', c: 'F49C' },
  { n: 'shuffle', c: 'F49D' },
  { n: 'shuffle-disabled', c: 'F49E' },
  { n: 'shuffle-variant', c: 'F49F' },
  { n: 'sigma', c: 'F4A0' },
  { n: 'sigma-lower', c: 'F62B' },
  { n: 'sign-caution', c: 'F4A1' },
  { n: 'sign-direction', c: 'F780' },
  { n: 'sign-text', c: 'F781' },
  { n: 'signal', c: 'F4A2' },
  { n: 'signal-2g', c: 'F711' },
  { n: 'signal-3g', c: 'F712' },
  { n: 'signal-4g', c: 'F713' },
  { n: 'signal-5g', c: 'FA6E' },
  { n: 'signal-cellular-1', c: 'F8BB' },
  { n: 'signal-cellular-2', c: 'F8BC' },
  { n: 'signal-cellular-3', c: 'F8BD' },
  { n: 'signal-cellular-outline', c: 'F8BE' },
  { n: 'signal-hspa', c: 'F714' },
  { n: 'signal-hspa-plus', c: 'F715' },
  { n: 'signal-off', c: 'F782' },
  { n: 'signal-variant', c: 'F60A' },
  { n: 'signature', c: 'FDD7' },
  { n: 'signature-freehand', c: 'FDD8' },
  { n: 'signature-image', c: 'FDD9' },
  { n: 'signature-text', c: 'FDDA' },
  { n: 'silo', c: 'FB24' },
  { n: 'silverware', c: 'F4A3' },
  { n: 'silverware-fork', c: 'F4A4' },
  { n: 'silverware-fork-knife', c: 'FA6F' },
  { n: 'silverware-spoon', c: 'F4A5' },
  { n: 'silverware-variant', c: 'F4A6' },
  { n: 'sim', c: 'F4A7' },
  { n: 'sim-alert', c: 'F4A8' },
  { n: 'sim-off', c: 'F4A9' },
  { n: 'sina-weibo', c: 'FADE' },
  { n: 'sitemap', c: 'F4AA' },
  { n: 'skate', c: 'FD11' },
  { n: 'skew-less', c: 'FD12' },
  { n: 'skew-more', c: 'FD13' },
  { n: 'skip-backward', c: 'F4AB' },
  { n: 'skip-forward', c: 'F4AC' },
  { n: 'skip-next', c: 'F4AD' },
  { n: 'skip-next-circle', c: 'F661' },
  { n: 'skip-next-circle-outline', c: 'F662' },
  { n: 'skip-previous', c: 'F4AE' },
  { n: 'skip-previous-circle', c: 'F663' },
  { n: 'skip-previous-circle-outline', c: 'F664' },
  { n: 'skull', c: 'F68B' },
  { n: 'skull-crossbones', c: 'FBA2' },
  { n: 'skull-crossbones-outline', c: 'FBA3' },
  { n: 'skull-outline', c: 'FBA4' },
  { n: 'skype', c: 'F4AF' },
  { n: 'skype-business', c: 'F4B0' },
  { n: 'slack', c: 'F4B1' },
  { n: 'slackware', c: 'F90A' },
  { n: 'sleep', c: 'F4B2' },
  { n: 'sleep-off', c: 'F4B3' },
  { n: 'slope-downhill', c: 'FDDB' },
  { n: 'slope-uphill', c: 'FDDC' },
  { n: 'smog', c: 'FA70' },
  { n: 'smoke-detector', c: 'F392' },
  { n: 'smoking', c: 'F4B4' },
  { n: 'smoking-off', c: 'F4B5' },
  { n: 'snapchat', c: 'F4B6' },
  { n: 'snowflake', c: 'F716' },
  { n: 'snowman', c: 'F4B7' },
  { n: 'soccer', c: 'F4B8' },
  { n: 'soccer-field', c: 'F833' },
  { n: 'sofa', c: 'F4B9' },
  { n: 'solar-panel', c: 'FD77' },
  { n: 'solar-panel-large', c: 'FD78' },
  { n: 'solar-power', c: 'FA71' },
  { n: 'solid', c: 'F68C' },
  { n: 'sort', c: 'F4BA' },
  { n: 'sort-alphabetical', c: 'F4BB' },
  { n: 'sort-ascending', c: 'F4BC' },
  { n: 'sort-descending', c: 'F4BD' },
  { n: 'sort-numeric', c: 'F4BE' },
  { n: 'sort-variant', c: 'F4BF' },
  { n: 'sort-variant-lock', c: 'FCA9' },
  { n: 'sort-variant-lock-open', c: 'FCAA' },
  { n: 'soundcloud', c: 'F4C0' },
  { n: 'source-branch', c: 'F62C' },
  { n: 'source-commit', c: 'F717' },
  { n: 'source-commit-end', c: 'F718' },
  { n: 'source-commit-end-local', c: 'F719' },
  { n: 'source-commit-local', c: 'F71A' },
  { n: 'source-commit-next-local', c: 'F71B' },
  { n: 'source-commit-start', c: 'F71C' },
  { n: 'source-commit-start-next-local', c: 'F71D' },
  { n: 'source-fork', c: 'F4C1' },
  { n: 'source-merge', c: 'F62D' },
  { n: 'source-pull', c: 'F4C2' },
  { n: 'source-repository', c: 'FCAB' },
  { n: 'source-repository-multiple', c: 'FCAC' },
  { n: 'soy-sauce', c: 'F7ED' },
  { n: 'spa', c: 'FCAD' },
  { n: 'spa-outline', c: 'FCAE' },
  { n: 'space-invaders', c: 'FBA5' },
  { n: 'speaker', c: 'F4C3' },
  { n: 'speaker-bluetooth', c: 'F9A1' },
  { n: 'speaker-multiple', c: 'FD14' },
  { n: 'speaker-off', c: 'F4C4' },
  { n: 'speaker-wireless', c: 'F71E' },
  { n: 'speedometer', c: 'F4C5' },
  { n: 'spellcheck', c: 'F4C6' },
  { n: 'spider-web', c: 'FBA6' },
  { n: 'spotify', c: 'F4C7' },
  { n: 'spotlight', c: 'F4C8' },
  { n: 'spotlight-beam', c: 'F4C9' },
  { n: 'spray', c: 'F665' },
  { n: 'spray-bottle', c: 'FADF' },
  { n: 'square', c: 'F763' },
  { n: 'square-edit-outline', c: 'F90B' },
  { n: 'square-inc', c: 'F4CA' },
  { n: 'square-inc-cash', c: 'F4CB' },
  { n: 'square-medium', c: 'FA12' },
  { n: 'square-medium-outline', c: 'FA13' },
  { n: 'square-outline', c: 'F762' },
  { n: 'square-root', c: 'F783' },
  { n: 'square-root-box', c: 'F9A2' },
  { n: 'square-small', c: 'FA14' },
  { n: 'squeegee', c: 'FAE0' },
  { n: 'ssh', c: 'F8BF' },
  { n: 'stack-exchange', c: 'F60B' },
  { n: 'stack-overflow', c: 'F4CC' },
  { n: 'stadium', c: 'F71F' },
  { n: 'stairs', c: 'F4CD' },
  { n: 'stamper', c: 'FD15' },
  { n: 'standard-definition', c: 'F7EE' },
  { n: 'star', c: 'F4CE' },
  { n: 'star-box', c: 'FA72' },
  { n: 'star-box-outline', c: 'FA73' },
  { n: 'star-circle', c: 'F4CF' },
  { n: 'star-circle-outline', c: 'F9A3' },
  { n: 'star-face', c: 'F9A4' },
  { n: 'star-four-points', c: 'FAE1' },
  { n: 'star-four-points-outline', c: 'FAE2' },
  { n: 'star-half', c: 'F4D0' },
  { n: 'star-off', c: 'F4D1' },
  { n: 'star-outline', c: 'F4D2' },
  { n: 'star-three-points', c: 'FAE3' },
  { n: 'star-three-points-outline', c: 'FAE4' },
  { n: 'steam', c: 'F4D3' },
  { n: 'steam-box', c: 'F90C' },
  { n: 'steering', c: 'F4D4' },
  { n: 'steering-off', c: 'F90D' },
  { n: 'step-backward', c: 'F4D5' },
  { n: 'step-backward-2', c: 'F4D6' },
  { n: 'step-forward', c: 'F4D7' },
  { n: 'step-forward-2', c: 'F4D8' },
  { n: 'stethoscope', c: 'F4D9' },
  { n: 'sticker', c: 'F5D0' },
  { n: 'sticker-emoji', c: 'F784' },
  { n: 'stocking', c: 'F4DA' },
  { n: 'stop', c: 'F4DB' },
  { n: 'stop-circle', c: 'F666' },
  { n: 'stop-circle-outline', c: 'F667' },
  { n: 'store', c: 'F4DC' },
  { n: 'store-24-hour', c: 'F4DD' },
  { n: 'stove', c: 'F4DE' },
  { n: 'strava', c: 'FB25' },
  { n: 'subdirectory-arrow-left', c: 'F60C' },
  { n: 'subdirectory-arrow-right', c: 'F60D' },
  { n: 'subtitles', c: 'FA15' },
  { n: 'subtitles-outline', c: 'FA16' },
  { n: 'subway', c: 'F6AB' },
  { n: 'subway-alert-variant', c: 'FD79' },
  { n: 'subway-variant', c: 'F4DF' },
  { n: 'summit', c: 'F785' },
  { n: 'sunglasses', c: 'F4E0' },
  { n: 'surround-sound', c: 'F5C5' },
  { n: 'surround-sound-2-0', c: 'F7EF' },
  { n: 'surround-sound-3-1', c: 'F7F0' },
  { n: 'surround-sound-5-1', c: 'F7F1' },
  { n: 'surround-sound-7-1', c: 'F7F2' },
  { n: 'svg', c: 'F720' },
  { n: 'swap-horizontal', c: 'F4E1' },
  { n: 'swap-horizontal-bold', c: 'FBA9' },
  { n: 'swap-horizontal-variant', c: 'F8C0' },
  { n: 'swap-vertical', c: 'F4E2' },
  { n: 'swap-vertical-bold', c: 'FBAA' },
  { n: 'swap-vertical-variant', c: 'F8C1' },
  { n: 'swim', c: 'F4E3' },
  { n: 'switch', c: 'F4E4' },
  { n: 'sword', c: 'F4E5' },
  { n: 'sword-cross', c: 'F786' },
  { n: 'symfony', c: 'FAE5' },
  { n: 'sync', c: 'F4E6' },
  { n: 'sync-alert', c: 'F4E7' },
  { n: 'sync-off', c: 'F4E8' },
  { n: 'tab', c: 'F4E9' },
  { n: 'tab-minus', c: 'FB26' },
  { n: 'tab-plus', c: 'F75B' },
  { n: 'tab-remove', c: 'FB27' },
  { n: 'tab-unselected', c: 'F4EA' },
  { n: 'table', c: 'F4EB' },
  { n: 'table-border', c: 'FA17' },
  { n: 'table-column', c: 'F834' },
  { n: 'table-column-plus-after', c: 'F4EC' },
  { n: 'table-column-plus-before', c: 'F4ED' },
  { n: 'table-column-remove', c: 'F4EE' },
  { n: 'table-column-width', c: 'F4EF' },
  { n: 'table-edit', c: 'F4F0' },
  { n: 'table-large', c: 'F4F1' },
  { n: 'table-merge-cells', c: 'F9A5' },
  { n: 'table-of-contents', c: 'F835' },
  { n: 'table-plus', c: 'FA74' },
  { n: 'table-remove', c: 'FA75' },
  { n: 'table-row', c: 'F836' },
  { n: 'table-row-height', c: 'F4F2' },
  { n: 'table-row-plus-after', c: 'F4F3' },
  { n: 'table-row-plus-before', c: 'F4F4' },
  { n: 'table-row-remove', c: 'F4F5' },
  { n: 'table-search', c: 'F90E' },
  { n: 'table-settings', c: 'F837' },
  { n: 'tablet', c: 'F4F6' },
  { n: 'tablet-android', c: 'F4F7' },
  { n: 'tablet-cellphone', c: 'F9A6' },
  { n: 'tablet-ipad', c: 'F4F8' },
  { n: 'taco', c: 'F761' },
  { n: 'tag', c: 'F4F9' },
  { n: 'tag-faces', c: 'F4FA' },
  { n: 'tag-heart', c: 'F68A' },
  { n: 'tag-heart-outline', c: 'FBAB' },
  { n: 'tag-minus', c: 'F90F' },
  { n: 'tag-multiple', c: 'F4FB' },
  { n: 'tag-outline', c: 'F4FC' },
  { n: 'tag-plus', c: 'F721' },
  { n: 'tag-remove', c: 'F722' },
  { n: 'tag-text-outline', c: 'F4FD' },
  { n: 'tank', c: 'FD16' },
  { n: 'tape-measure', c: 'FB28' },
  { n: 'target', c: 'F4FE' },
  { n: 'target-account', c: 'FBAC' },
  { n: 'target-variant', c: 'FA76' },
  { n: 'taxi', c: 'F4FF' },
  { n: 'tea', c: 'FD7A' },
  { n: 'tea-outline', c: 'FD7B' },
  { n: 'teach', c: 'F88F' },
  { n: 'teamviewer', c: 'F500' },
  { n: 'telegram', c: 'F501' },
  { n: 'telescope', c: 'FB29' },
  { n: 'television', c: 'F502' },
  { n: 'television-box', c: 'F838' },
  { n: 'television-classic', c: 'F7F3' },
  { n: 'television-classic-off', c: 'F839' },
  { n: 'television-guide', c: 'F503' },
  { n: 'television-off', c: 'F83A' },
  { n: 'temperature-celsius', c: 'F504' },
  { n: 'temperature-fahrenheit', c: 'F505' },
  { n: 'temperature-kelvin', c: 'F506' },
  { n: 'tennis', c: 'FD7C' },
  { n: 'tennis-ball', c: 'F507' },
  { n: 'tent', c: 'F508' },
  { n: 'terrain', c: 'F509' },
  { n: 'test-tube', c: 'F668' },
  { n: 'test-tube-empty', c: 'F910' },
  { n: 'test-tube-off', c: 'F911' },
  { n: 'text', c: 'F9A7' },
  { n: 'text-shadow', c: 'F669' },
  { n: 'text-short', c: 'F9A8' },
  { n: 'text-subject', c: 'F9A9' },
  { n: 'text-to-speech', c: 'F50A' },
  { n: 'text-to-speech-off', c: 'F50B' },
  { n: 'textbox', c: 'F60E' },
  { n: 'textbox-password', c: 'F7F4' },
  { n: 'texture', c: 'F50C' },
  { n: 'theater', c: 'F50D' },
  { n: 'theme-light-dark', c: 'F50E' },
  { n: 'thermometer', c: 'F50F' },
  { n: 'thermometer-alert', c: 'FDDD' },
  { n: 'thermometer-chevron-down', c: 'FDDE' },
  { n: 'thermometer-chevron-up', c: 'FDDF' },
  { n: 'thermometer-lines', c: 'F510' },
  { n: 'thermometer-minus', c: 'FDE0' },
  { n: 'thermometer-plus', c: 'FDE1' },
  { n: 'thermostat', c: 'F393' },
  { n: 'thermostat-box', c: 'F890' },
  { n: 'thought-bubble', c: 'F7F5' },
  { n: 'thought-bubble-outline', c: 'F7F6' },
  { n: 'thumb-down', c: 'F511' },
  { n: 'thumb-down-outline', c: 'F512' },
  { n: 'thumb-up', c: 'F513' },
  { n: 'thumb-up-outline', c: 'F514' },
  { n: 'thumbs-up-down', c: 'F515' },
  { n: 'ticket', c: 'F516' },
  { n: 'ticket-account', c: 'F517' },
  { n: 'ticket-confirmation', c: 'F518' },
  { n: 'ticket-outline', c: 'F912' },
  { n: 'ticket-percent', c: 'F723' },
  { n: 'tie', c: 'F519' },
  { n: 'tilde', c: 'F724' },
  { n: 'timelapse', c: 'F51A' },
  { n: 'timeline', c: 'FBAD' },
  { n: 'timeline-outline', c: 'FBAE' },
  { n: 'timeline-text', c: 'FBAF' },
  { n: 'timeline-text-outline', c: 'FBB0' },
  { n: 'timer', c: 'F51B' },
  { n: 'timer-10', c: 'F51C' },
  { n: 'timer-3', c: 'F51D' },
  { n: 'timer-off', c: 'F51E' },
  { n: 'timer-sand', c: 'F51F' },
  { n: 'timer-sand-empty', c: 'F6AC' },
  { n: 'timer-sand-full', c: 'F78B' },
  { n: 'timetable', c: 'F520' },
  { n: 'toaster-oven', c: 'FCAF' },
  { n: 'toggle-switch', c: 'F521' },
  { n: 'toggle-switch-off', c: 'F522' },
  { n: 'toggle-switch-off-outline', c: 'FA18' },
  { n: 'toggle-switch-outline', c: 'FA19' },
  { n: 'toilet', c: 'F9AA' },
  { n: 'toolbox', c: 'F9AB' },
  { n: 'toolbox-outline', c: 'F9AC' },
  { n: 'tooltip', c: 'F523' },
  { n: 'tooltip-account', c: 'F00C' },
  { n: 'tooltip-edit', c: 'F524' },
  { n: 'tooltip-image', c: 'F525' },
  { n: 'tooltip-image-outline', c: 'FBB1' },
  { n: 'tooltip-outline', c: 'F526' },
  { n: 'tooltip-plus', c: 'FBB2' },
  { n: 'tooltip-plus-outline', c: 'F527' },
  { n: 'tooltip-text', c: 'F528' },
  { n: 'tooltip-text-outline', c: 'FBB3' },
  { n: 'tooth', c: 'F8C2' },
  { n: 'tooth-outline', c: 'F529' },
  { n: 'tor', c: 'F52A' },
  { n: 'tortoise', c: 'FD17' },
  { n: 'tournament', c: 'F9AD' },
  { n: 'tower-beach', c: 'F680' },
  { n: 'tower-fire', c: 'F681' },
  { n: 'towing', c: 'F83B' },
  { n: 'track-light', c: 'F913' },
  { n: 'trackpad', c: 'F7F7' },
  { n: 'trackpad-lock', c: 'F932' },
  { n: 'tractor', c: 'F891' },
  { n: 'trademark', c: 'FA77' },
  { n: 'traffic-light', c: 'F52B' },
  { n: 'train', c: 'F52C' },
  { n: 'train-car', c: 'FBB4' },
  { n: 'train-variant', c: 'F8C3' },
  { n: 'tram', c: 'F52D' },
  { n: 'transcribe', c: 'F52E' },
  { n: 'transcribe-close', c: 'F52F' },
  { n: 'transfer-down', c: 'FD7D' },
  { n: 'transfer-left', c: 'FD7E' },
  { n: 'transfer-right', c: 'F530' },
  { n: 'transfer-up', c: 'FD7F' },
  { n: 'transit-connection', c: 'FD18' },
  { n: 'transit-connection-variant', c: 'FD19' },
  { n: 'transit-transfer', c: 'F6AD' },
  { n: 'transition', c: 'F914' },
  { n: 'transition-masked', c: 'F915' },
  { n: 'translate', c: 'F5CA' },
  { n: 'translate-off', c: 'FDE2' },
  { n: 'transmission-tower', c: 'FD1A' },
  { n: 'trash-can', c: 'FA78' },
  { n: 'trash-can-outline', c: 'FA79' },
  { n: 'treasure-chest', c: 'F725' },
  { n: 'tree', c: 'F531' },
  { n: 'trello', c: 'F532' },
  { n: 'trending-down', c: 'F533' },
  { n: 'trending-neutral', c: 'F534' },
  { n: 'trending-up', c: 'F535' },
  { n: 'triangle', c: 'F536' },
  { n: 'triangle-outline', c: 'F537' },
  { n: 'triforce', c: 'FBB5' },
  { n: 'trophy', c: 'F538' },
  { n: 'trophy-award', c: 'F539' },
  { n: 'trophy-broken', c: 'FD80' },
  { n: 'trophy-outline', c: 'F53A' },
  { n: 'trophy-variant', c: 'F53B' },
  { n: 'trophy-variant-outline', c: 'F53C' },
  { n: 'truck', c: 'F53D' },
  { n: 'truck-check', c: 'FCB0' },
  { n: 'truck-delivery', c: 'F53E' },
  { n: 'truck-fast', c: 'F787' },
  { n: 'truck-trailer', c: 'F726' },
  { n: 'tshirt-crew', c: 'FA7A' },
  { n: 'tshirt-crew-outline', c: 'F53F' },
  { n: 'tshirt-v', c: 'FA7B' },
  { n: 'tshirt-v-outline', c: 'F540' },
  { n: 'tumble-dryer', c: 'F916' },
  { n: 'tumblr', c: 'F541' },
  { n: 'tumblr-box', c: 'F917' },
  { n: 'tumblr-reblog', c: 'F542' },
  { n: 'tune', c: 'F62E' },
  { n: 'tune-vertical', c: 'F66A' },
  { n: 'turnstile', c: 'FCB1' },
  { n: 'turnstile-outline', c: 'FCB2' },
  { n: 'turtle', c: 'FCB3' },
  { n: 'twitch', c: 'F543' },
  { n: 'twitter', c: 'F544' },
  { n: 'twitter-box', c: 'F545' },
  { n: 'twitter-circle', c: 'F546' },
  { n: 'twitter-retweet', c: 'F547' },
  { n: 'two-factor-authentication', c: 'F9AE' },
  { n: 'uber', c: 'F748' },
  { n: 'ubisoft', c: 'FBB6' },
  { n: 'ubuntu', c: 'F548' },
  { n: 'ultra-high-definition', c: 'F7F8' },
  { n: 'umbraco', c: 'F549' },
  { n: 'umbrella', c: 'F54A' },
  { n: 'umbrella-closed', c: 'F9AF' },
  { n: 'umbrella-outline', c: 'F54B' },
  { n: 'undo', c: 'F54C' },
  { n: 'undo-variant', c: 'F54D' },
  { n: 'unfold-less-horizontal', c: 'F54E' },
  { n: 'unfold-less-vertical', c: 'F75F' },
  { n: 'unfold-more-horizontal', c: 'F54F' },
  { n: 'unfold-more-vertical', c: 'F760' },
  { n: 'ungroup', c: 'F550' },
  { n: 'unity', c: 'F6AE' },
  { n: 'unreal', c: 'F9B0' },
  { n: 'untappd', c: 'F551' },
  { n: 'update', c: 'F6AF' },
  { n: 'upload', c: 'F552' },
  { n: 'upload-multiple', c: 'F83C' },
  { n: 'upload-network', c: 'F6F5' },
  { n: 'upload-network-outline', c: 'FCB4' },
  { n: 'upload-outline', c: 'FDE3' },
  { n: 'usb', c: 'F553' },
  { n: 'van-passenger', c: 'F7F9' },
  { n: 'van-utility', c: 'F7FA' },
  { n: 'vanish', c: 'F7FB' },
  { n: 'variable', c: 'FAE6' },
  { n: 'vector-arrange-above', c: 'F554' },
  { n: 'vector-arrange-below', c: 'F555' },
  { n: 'vector-bezier', c: 'FAE7' },
  { n: 'vector-circle', c: 'F556' },
  { n: 'vector-circle-variant', c: 'F557' },
  { n: 'vector-combine', c: 'F558' },
  { n: 'vector-curve', c: 'F559' },
  { n: 'vector-difference', c: 'F55A' },
  { n: 'vector-difference-ab', c: 'F55B' },
  { n: 'vector-difference-ba', c: 'F55C' },
  { n: 'vector-ellipse', c: 'F892' },
  { n: 'vector-intersection', c: 'F55D' },
  { n: 'vector-line', c: 'F55E' },
  { n: 'vector-point', c: 'F55F' },
  { n: 'vector-polygon', c: 'F560' },
  { n: 'vector-polyline', c: 'F561' },
  { n: 'vector-radius', c: 'F749' },
  { n: 'vector-rectangle', c: 'F5C6' },
  { n: 'vector-selection', c: 'F562' },
  { n: 'vector-square', c: 'F001' },
  { n: 'vector-triangle', c: 'F563' },
  { n: 'vector-union', c: 'F564' },
  { n: 'venmo', c: 'F578' },
  { n: 'vhs', c: 'FA1A' },
  { n: 'vibrate', c: 'F566' },
  { n: 'vibrate-off', c: 'FCB5' },
  { n: 'video', c: 'F567' },
  { n: 'video-3d', c: 'F7FC' },
  { n: 'video-4k-box', c: 'F83D' },
  { n: 'video-account', c: 'F918' },
  { n: 'video-image', c: 'F919' },
  { n: 'video-input-antenna', c: 'F83E' },
  { n: 'video-input-component', c: 'F83F' },
  { n: 'video-input-hdmi', c: 'F840' },
  { n: 'video-input-svideo', c: 'F841' },
  { n: 'video-minus', c: 'F9B1' },
  { n: 'video-off', c: 'F568' },
  { n: 'video-off-outline', c: 'FBB7' },
  { n: 'video-outline', c: 'FBB8' },
  { n: 'video-plus', c: 'F9B2' },
  { n: 'video-stabilization', c: 'F91A' },
  { n: 'video-switch', c: 'F569' },
  { n: 'video-vintage', c: 'FA1B' },
  { n: 'view-agenda', c: 'F56A' },
  { n: 'view-array', c: 'F56B' },
  { n: 'view-carousel', c: 'F56C' },
  { n: 'view-column', c: 'F56D' },
  { n: 'view-dashboard', c: 'F56E' },
  { n: 'view-dashboard-outline', c: 'FA1C' },
  { n: 'view-dashboard-variant', c: 'F842' },
  { n: 'view-day', c: 'F56F' },
  { n: 'view-grid', c: 'F570' },
  { n: 'view-headline', c: 'F571' },
  { n: 'view-list', c: 'F572' },
  { n: 'view-module', c: 'F573' },
  { n: 'view-parallel', c: 'F727' },
  { n: 'view-quilt', c: 'F574' },
  { n: 'view-sequential', c: 'F728' },
  { n: 'view-split-horizontal', c: 'FBA7' },
  { n: 'view-split-vertical', c: 'FBA8' },
  { n: 'view-stream', c: 'F575' },
  { n: 'view-week', c: 'F576' },
  { n: 'vimeo', c: 'F577' },
  { n: 'violin', c: 'F60F' },
  { n: 'virtual-reality', c: 'F893' },
  { n: 'visual-studio', c: 'F610' },
  { n: 'visual-studio-code', c: 'FA1D' },
  { n: 'vk', c: 'F579' },
  { n: 'vk-box', c: 'F57A' },
  { n: 'vk-circle', c: 'F57B' },
  { n: 'vlc', c: 'F57C' },
  { n: 'voice', c: 'F5CB' },
  { n: 'voicemail', c: 'F57D' },
  { n: 'volleyball', c: 'F9B3' },
  { n: 'volume-high', c: 'F57E' },
  { n: 'volume-low', c: 'F57F' },
  { n: 'volume-medium', c: 'F580' },
  { n: 'volume-minus', c: 'F75D' },
  { n: 'volume-mute', c: 'F75E' },
  { n: 'volume-off', c: 'F581' },
  { n: 'volume-plus', c: 'F75C' },
  { n: 'volume-variant-off', c: 'FDE4' },
  { n: 'vote', c: 'FA1E' },
  { n: 'vote-outline', c: 'FA1F' },
  { n: 'vpn', c: 'F582' },
  { n: 'vuejs', c: 'F843' },
  { n: 'walk', c: 'F583' },
  { n: 'wall', c: 'F7FD' },
  { n: 'wall-sconce', c: 'F91B' },
  { n: 'wall-sconce-flat', c: 'F91C' },
  { n: 'wall-sconce-variant', c: 'F91D' },
  { n: 'wallet', c: 'F584' },
  { n: 'wallet-giftcard', c: 'F585' },
  { n: 'wallet-membership', c: 'F586' },
  { n: 'wallet-outline', c: 'FBB9' },
  { n: 'wallet-travel', c: 'F587' },
  { n: 'wallpaper', c: 'FDE5' },
  { n: 'wan', c: 'F588' },
  { n: 'washing-machine', c: 'F729' },
  { n: 'watch', c: 'F589' },
  { n: 'watch-export', c: 'F58A' },
  { n: 'watch-export-variant', c: 'F894' },
  { n: 'watch-import', c: 'F58B' },
  { n: 'watch-import-variant', c: 'F895' },
  { n: 'watch-variant', c: 'F896' },
  { n: 'watch-vibrate', c: 'F6B0' },
  { n: 'watch-vibrate-off', c: 'FCB6' },
  { n: 'water', c: 'F58C' },
  { n: 'water-off', c: 'F58D' },
  { n: 'water-outline', c: 'FDE6' },
  { n: 'water-percent', c: 'F58E' },
  { n: 'water-pump', c: 'F58F' },
  { n: 'watermark', c: 'F612' },
  { n: 'waves', c: 'F78C' },
  { n: 'waze', c: 'FBBA' },
  { n: 'weather-cloudy', c: 'F590' },
  { n: 'weather-fog', c: 'F591' },
  { n: 'weather-hail', c: 'F592' },
  { n: 'weather-hurricane', c: 'F897' },
  { n: 'weather-lightning', c: 'F593' },
  { n: 'weather-lightning-rainy', c: 'F67D' },
  { n: 'weather-night', c: 'F594' },
  { n: 'weather-partlycloudy', c: 'F595' },
  { n: 'weather-pouring', c: 'F596' },
  { n: 'weather-rainy', c: 'F597' },
  { n: 'weather-snowy', c: 'F598' },
  { n: 'weather-snowy-rainy', c: 'F67E' },
  { n: 'weather-sunny', c: 'F599' },
  { n: 'weather-sunset', c: 'F59A' },
  { n: 'weather-sunset-down', c: 'F59B' },
  { n: 'weather-sunset-up', c: 'F59C' },
  { n: 'weather-windy', c: 'F59D' },
  { n: 'weather-windy-variant', c: 'F59E' },
  { n: 'web', c: 'F59F' },
  { n: 'webcam', c: 'F5A0' },
  { n: 'webhook', c: 'F62F' },
  { n: 'webpack', c: 'F72A' },
  { n: 'wechat', c: 'F611' },
  { n: 'weight', c: 'F5A1' },
  { n: 'weight-gram', c: 'FD1B' },
  { n: 'weight-kilogram', c: 'F5A2' },
  { n: 'weight-pound', c: 'F9B4' },
  { n: 'whatsapp', c: 'F5A3' },
  { n: 'wheelchair-accessibility', c: 'F5A4' },
  { n: 'whistle', c: 'F9B5' },
  { n: 'white-balance-auto', c: 'F5A5' },
  { n: 'white-balance-incandescent', c: 'F5A6' },
  { n: 'white-balance-iridescent', c: 'F5A7' },
  { n: 'white-balance-sunny', c: 'F5A8' },
  { n: 'widgets', c: 'F72B' },
  { n: 'wifi', c: 'F5A9' },
  { n: 'wifi-off', c: 'F5AA' },
  { n: 'wifi-star', c: 'FDE7' },
  { n: 'wifi-strength-1', c: 'F91E' },
  { n: 'wifi-strength-1-alert', c: 'F91F' },
  { n: 'wifi-strength-1-lock', c: 'F920' },
  { n: 'wifi-strength-2', c: 'F921' },
  { n: 'wifi-strength-2-alert', c: 'F922' },
  { n: 'wifi-strength-2-lock', c: 'F923' },
  { n: 'wifi-strength-3', c: 'F924' },
  { n: 'wifi-strength-3-alert', c: 'F925' },
  { n: 'wifi-strength-3-lock', c: 'F926' },
  { n: 'wifi-strength-4', c: 'F927' },
  { n: 'wifi-strength-4-alert', c: 'F928' },
  { n: 'wifi-strength-4-lock', c: 'F929' },
  { n: 'wifi-strength-alert-outline', c: 'F92A' },
  { n: 'wifi-strength-lock-outline', c: 'F92B' },
  { n: 'wifi-strength-off', c: 'F92C' },
  { n: 'wifi-strength-off-outline', c: 'F92D' },
  { n: 'wifi-strength-outline', c: 'F92E' },
  { n: 'wii', c: 'F5AB' },
  { n: 'wiiu', c: 'F72C' },
  { n: 'wikipedia', c: 'F5AC' },
  { n: 'wind-turbine', c: 'FD81' },
  { n: 'window-close', c: 'F5AD' },
  { n: 'window-closed', c: 'F5AE' },
  { n: 'window-maximize', c: 'F5AF' },
  { n: 'window-minimize', c: 'F5B0' },
  { n: 'window-open', c: 'F5B1' },
  { n: 'window-restore', c: 'F5B2' },
  { n: 'windows', c: 'F5B3' },
  { n: 'windows-classic', c: 'FA20' },
  { n: 'wiper', c: 'FAE8' },
  { n: 'wiper-wash', c: 'FD82' },
  { n: 'wordpress', c: 'F5B4' },
  { n: 'worker', c: 'F5B5' },
  { n: 'wrap', c: 'F5B6' },
  { n: 'wrap-disabled', c: 'FBBB' },
  { n: 'wrench', c: 'F5B7' },
  { n: 'wrench-outline', c: 'FBBC' },
  { n: 'wunderlist', c: 'F5B8' },
  { n: 'xamarin', c: 'F844' },
  { n: 'xamarin-outline', c: 'F845' },
  { n: 'xaml', c: 'F673' },
  { n: 'xbox', c: 'F5B9' },
  { n: 'xbox-controller', c: 'F5BA' },
  { n: 'xbox-controller-battery-alert', c: 'F74A' },
  { n: 'xbox-controller-battery-charging', c: 'FA21' },
  { n: 'xbox-controller-battery-empty', c: 'F74B' },
  { n: 'xbox-controller-battery-full', c: 'F74C' },
  { n: 'xbox-controller-battery-low', c: 'F74D' },
  { n: 'xbox-controller-battery-medium', c: 'F74E' },
  { n: 'xbox-controller-battery-unknown', c: 'F74F' },
  { n: 'xbox-controller-off', c: 'F5BB' },
  { n: 'xda', c: 'F5BC' },
  { n: 'xing', c: 'F5BD' },
  { n: 'xing-box', c: 'F5BE' },
  { n: 'xing-circle', c: 'F5BF' },
  { n: 'xml', c: 'F5C0' },
  { n: 'xmpp', c: 'F7FE' },
  { n: 'yahoo', c: 'FB2A' },
  { n: 'yammer', c: 'F788' },
  { n: 'yeast', c: 'F5C1' },
  { n: 'yelp', c: 'F5C2' },
  { n: 'yin-yang', c: 'F67F' },
  { n: 'youtube', c: 'F5C3' },
  { n: 'youtube-creator-studio', c: 'F846' },
  { n: 'youtube-gaming', c: 'F847' },
  { n: 'youtube-subscription', c: 'FD1C' },
  { n: 'youtube-tv', c: 'F448' },
  { n: 'z-wave', c: 'FAE9' },
  { n: 'zend', c: 'FAEA' },
  { n: 'zigbee', c: 'FD1D' },
  { n: 'zip-box', c: 'F5C4' },
  { n: 'zip-disk', c: 'FA22' },
  { n: 'zodiac-aquarius', c: 'FA7C' },
  { n: 'zodiac-aries', c: 'FA7D' },
  { n: 'zodiac-cancer', c: 'FA7E' },
  { n: 'zodiac-capricorn', c: 'FA7F' },
  { n: 'zodiac-gemini', c: 'FA80' },
  { n: 'zodiac-leo', c: 'FA81' },
  { n: 'zodiac-libra', c: 'FA82' },
  { n: 'zodiac-pisces', c: 'FA83' },
  { n: 'zodiac-sagittarius', c: 'FA84' },
  { n: 'zodiac-scorpio', c: 'FA85' },
  { n: 'zodiac-taurus', c: 'FA86' },
  { n: 'zodiac-virgo', c: 'FA87' }
];

// Icon codepoints from:
// https://github.com/google/material-design-icons/blob/94eb8d16ba2d931ac30b43b3fa37235fd261903f/iconfont/codepoints
const googleMaterialIcons = [
  { n: '360', c: 'e577' },
  { n: '3d_rotation', c: 'e84d' },
  { n: '4k', c: 'e072' },
  { n: 'ac_unit', c: 'eb3b' },
  { n: 'access_alarm', c: 'e190' },
  { n: 'access_alarms', c: 'e191' },
  { n: 'access_time', c: 'e192' },
  { n: 'accessibility', c: 'e84e' },
  { n: 'accessibility_new', c: 'e92c' },
  { n: 'accessible', c: 'e914' },
  { n: 'accessible_forward', c: 'e934' },
  { n: 'account_balance', c: 'e84f' },
  { n: 'account_balance_wallet', c: 'e850' },
  { n: 'account_box', c: 'e851' },
  { n: 'account_circle', c: 'e853' },
  { n: 'adb', c: 'e60e' },
  { n: 'add', c: 'e145' },
  { n: 'add_a_photo', c: 'e439' },
  { n: 'add_alarm', c: 'e193' },
  { n: 'add_alert', c: 'e003' },
  { n: 'add_box', c: 'e146' },
  { n: 'add_call', c: 'e0e8' },
  { n: 'add_circle', c: 'e147' },
  { n: 'add_circle_outline', c: 'e148' },
  { n: 'add_comment', c: 'e266' },
  { n: 'add_link', c: 'e178' },
  { n: 'add_location', c: 'e567' },
  { n: 'add_photo_alternate', c: 'e43e' },
  { n: 'add_shopping_cart', c: 'e854' },
  { n: 'add_to_home_screen', c: 'e1fe' },
  { n: 'add_to_photos', c: 'e39d' },
  { n: 'add_to_queue', c: 'e05c' },
  { n: 'adjust', c: 'e39e' },
  { n: 'airline_seat_flat', c: 'e630' },
  { n: 'airline_seat_flat_angled', c: 'e631' },
  { n: 'airline_seat_individual_suite', c: 'e632' },
  { n: 'airline_seat_legroom_extra', c: 'e633' },
  { n: 'airline_seat_legroom_normal', c: 'e634' },
  { n: 'airline_seat_legroom_reduced', c: 'e635' },
  { n: 'airline_seat_recline_extra', c: 'e636' },
  { n: 'airline_seat_recline_normal', c: 'e637' },
  { n: 'airplanemode_active', c: 'e195' },
  { n: 'airplanemode_inactive', c: 'e194' },
  { n: 'airplay', c: 'e055' },
  { n: 'airport_shuttle', c: 'eb3c' },
  { n: 'alarm', c: 'e855' },
  { n: 'alarm_add', c: 'e856' },
  { n: 'alarm_off', c: 'e857' },
  { n: 'alarm_on', c: 'e858' },
  { n: 'album', c: 'e019' },
  { n: 'all_inclusive', c: 'eb3d' },
  { n: 'all_out', c: 'e90b' },
  { n: 'alternate_email', c: 'e0e6' },
  { n: 'android', c: 'e859' },
  { n: 'announcement', c: 'e85a' },
  { n: 'apps', c: 'e5c3' },
  { n: 'archive', c: 'e149' },
  { n: 'arrow_back', c: 'e5c4' },
  { n: 'arrow_back_ios', c: 'e5e0' },
  { n: 'arrow_downward', c: 'e5db' },
  { n: 'arrow_drop_down', c: 'e5c5' },
  { n: 'arrow_drop_down_circle', c: 'e5c6' },
  { n: 'arrow_drop_up', c: 'e5c7' },
  { n: 'arrow_forward', c: 'e5c8' },
  { n: 'arrow_forward_ios', c: 'e5e1' },
  { n: 'arrow_left', c: 'e5de' },
  { n: 'arrow_right', c: 'e5df' },
  { n: 'arrow_right_alt', c: 'e941' },
  { n: 'arrow_upward', c: 'e5d8' },
  { n: 'art_track', c: 'e060' },
  { n: 'aspect_ratio', c: 'e85b' },
  { n: 'assessment', c: 'e85c' },
  { n: 'assignment', c: 'e85d' },
  { n: 'assignment_ind', c: 'e85e' },
  { n: 'assignment_late', c: 'e85f' },
  { n: 'assignment_return', c: 'e860' },
  { n: 'assignment_returned', c: 'e861' },
  { n: 'assignment_turned_in', c: 'e862' },
  { n: 'assistant', c: 'e39f' },
  { n: 'assistant_photo', c: 'e3a0' },
  { n: 'atm', c: 'e573' },
  { n: 'attach_file', c: 'e226' },
  { n: 'attach_money', c: 'e227' },
  { n: 'attachment', c: 'e2bc' },
  { n: 'audiotrack', c: 'e3a1' },
  { n: 'autorenew', c: 'e863' },
  { n: 'av_timer', c: 'e01b' },
  { n: 'backspace', c: 'e14a' },
  { n: 'backup', c: 'e864' },
  { n: 'ballot', c: 'e172' },
  { n: 'bar_chart', c: 'e26b' },
  { n: 'battery_alert', c: 'e19c' },
  { n: 'battery_charging_full', c: 'e1a3' },
  { n: 'battery_full', c: 'e1a4' },
  { n: 'battery_std', c: 'e1a5' },
  { n: 'battery_unknown', c: 'e1a6' },
  { n: 'beach_access', c: 'eb3e' },
  { n: 'beenhere', c: 'e52d' },
  { n: 'block', c: 'e14b' },
  { n: 'bluetooth', c: 'e1a7' },
  { n: 'bluetooth_audio', c: 'e60f' },
  { n: 'bluetooth_connected', c: 'e1a8' },
  { n: 'bluetooth_disabled', c: 'e1a9' },
  { n: 'bluetooth_searching', c: 'e1aa' },
  { n: 'blur_circular', c: 'e3a2' },
  { n: 'blur_linear', c: 'e3a3' },
  { n: 'blur_off', c: 'e3a4' },
  { n: 'blur_on', c: 'e3a5' },
  { n: 'book', c: 'e865' },
  { n: 'bookmark', c: 'e866' },
  { n: 'bookmark_border', c: 'e867' },
  { n: 'border_all', c: 'e228' },
  { n: 'border_bottom', c: 'e229' },
  { n: 'border_clear', c: 'e22a' },
  { n: 'border_color', c: 'e22b' },
  { n: 'border_horizontal', c: 'e22c' },
  { n: 'border_inner', c: 'e22d' },
  { n: 'border_left', c: 'e22e' },
  { n: 'border_outer', c: 'e22f' },
  { n: 'border_right', c: 'e230' },
  { n: 'border_style', c: 'e231' },
  { n: 'border_top', c: 'e232' },
  { n: 'border_vertical', c: 'e233' },
  { n: 'branding_watermark', c: 'e06b' },
  { n: 'brightness_1', c: 'e3a6' },
  { n: 'brightness_2', c: 'e3a7' },
  { n: 'brightness_3', c: 'e3a8' },
  { n: 'brightness_4', c: 'e3a9' },
  { n: 'brightness_5', c: 'e3aa' },
  { n: 'brightness_6', c: 'e3ab' },
  { n: 'brightness_7', c: 'e3ac' },
  { n: 'brightness_auto', c: 'e1ab' },
  { n: 'brightness_high', c: 'e1ac' },
  { n: 'brightness_low', c: 'e1ad' },
  { n: 'brightness_medium', c: 'e1ae' },
  { n: 'broken_image', c: 'e3ad' },
  { n: 'brush', c: 'e3ae' },
  { n: 'bubble_chart', c: 'e6dd' },
  { n: 'bug_report', c: 'e868' },
  { n: 'build', c: 'e869' },
  { n: 'burst_mode', c: 'e43c' },
  { n: 'business', c: 'e0af' },
  { n: 'business_center', c: 'eb3f' },
  { n: 'cached', c: 'e86a' },
  { n: 'cake', c: 'e7e9' },
  { n: 'calendar_today', c: 'e935' },
  { n: 'calendar_view_day', c: 'e936' },
  { n: 'call', c: 'e0b0' },
  { n: 'call_end', c: 'e0b1' },
  { n: 'call_made', c: 'e0b2' },
  { n: 'call_merge', c: 'e0b3' },
  { n: 'call_missed', c: 'e0b4' },
  { n: 'call_missed_outgoing', c: 'e0e4' },
  { n: 'call_received', c: 'e0b5' },
  { n: 'call_split', c: 'e0b6' },
  { n: 'call_to_action', c: 'e06c' },
  { n: 'camera', c: 'e3af' },
  { n: 'camera_alt', c: 'e3b0' },
  { n: 'camera_enhance', c: 'e8fc' },
  { n: 'camera_front', c: 'e3b1' },
  { n: 'camera_rear', c: 'e3b2' },
  { n: 'camera_roll', c: 'e3b3' },
  { n: 'cancel', c: 'e5c9' },
  { n: 'cancel_presentation', c: 'e0e9' },
  { n: 'card_giftcard', c: 'e8f6' },
  { n: 'card_membership', c: 'e8f7' },
  { n: 'card_travel', c: 'e8f8' },
  { n: 'casino', c: 'eb40' },
  { n: 'cast', c: 'e307' },
  { n: 'cast_connected', c: 'e308' },
  { n: 'category', c: 'e574' },
  { n: 'cell_wifi', c: 'e0ec' },
  { n: 'center_focus_strong', c: 'e3b4' },
  { n: 'center_focus_weak', c: 'e3b5' },
  { n: 'change_history', c: 'e86b' },
  { n: 'chat', c: 'e0b7' },
  { n: 'chat_bubble', c: 'e0ca' },
  { n: 'chat_bubble_outline', c: 'e0cb' },
  { n: 'check', c: 'e5ca' },
  { n: 'check_box', c: 'e834' },
  { n: 'check_box_outline_blank', c: 'e835' },
  { n: 'check_circle', c: 'e86c' },
  { n: 'check_circle_outline', c: 'e92d' },
  { n: 'chevron_left', c: 'e5cb' },
  { n: 'chevron_right', c: 'e5cc' },
  { n: 'child_care', c: 'eb41' },
  { n: 'child_friendly', c: 'eb42' },
  { n: 'chrome_reader_mode', c: 'e86d' },
  { n: 'class', c: 'e86e' },
  { n: 'clear', c: 'e14c' },
  { n: 'clear_all', c: 'e0b8' },
  { n: 'close', c: 'e5cd' },
  { n: 'closed_caption', c: 'e01c' },
  { n: 'cloud', c: 'e2bd' },
  { n: 'cloud_circle', c: 'e2be' },
  { n: 'cloud_done', c: 'e2bf' },
  { n: 'cloud_download', c: 'e2c0' },
  { n: 'cloud_off', c: 'e2c1' },
  { n: 'cloud_queue', c: 'e2c2' },
  { n: 'cloud_upload', c: 'e2c3' },
  { n: 'code', c: 'e86f' },
  { n: 'collections', c: 'e3b6' },
  { n: 'collections_bookmark', c: 'e431' },
  { n: 'color_lens', c: 'e3b7' },
  { n: 'colorize', c: 'e3b8' },
  { n: 'comment', c: 'e0b9' },
  { n: 'commute', c: 'e940' },
  { n: 'compare', c: 'e3b9' },
  { n: 'compare_arrows', c: 'e915' },
  { n: 'compass_calibration', c: 'e57c' },
  { n: 'computer', c: 'e30a' },
  { n: 'confirmation_number', c: 'e638' },
  { n: 'contact_mail', c: 'e0d0' },
  { n: 'contact_phone', c: 'e0cf' },
  { n: 'contact_support', c: 'e94c' },
  { n: 'contacts', c: 'e0ba' },
  { n: 'content_copy', c: 'e14d' },
  { n: 'content_cut', c: 'e14e' },
  { n: 'content_paste', c: 'e14f' },
  { n: 'control_camera', c: 'e074' },
  { n: 'control_point', c: 'e3ba' },
  { n: 'control_point_duplicate', c: 'e3bb' },
  { n: 'copyright', c: 'e90c' },
  { n: 'create', c: 'e150' },
  { n: 'create_new_folder', c: 'e2cc' },
  { n: 'credit_card', c: 'e870' },
  { n: 'crop', c: 'e3be' },
  { n: 'crop_16_9', c: 'e3bc' },
  { n: 'crop_3_2', c: 'e3bd' },
  { n: 'crop_5_4', c: 'e3bf' },
  { n: 'crop_7_5', c: 'e3c0' },
  { n: 'crop_din', c: 'e3c1' },
  { n: 'crop_free', c: 'e3c2' },
  { n: 'crop_landscape', c: 'e3c3' },
  { n: 'crop_original', c: 'e3c4' },
  { n: 'crop_portrait', c: 'e3c5' },
  { n: 'crop_rotate', c: 'e437' },
  { n: 'crop_square', c: 'e3c6' },
  { n: 'dashboard', c: 'e871' },
  { n: 'data_usage', c: 'e1af' },
  { n: 'date_range', c: 'e916' },
  { n: 'dehaze', c: 'e3c7' },
  { n: 'delete', c: 'e872' },
  { n: 'delete_forever', c: 'e92b' },
  { n: 'delete_outline', c: 'e92e' },
  { n: 'delete_sweep', c: 'e16c' },
  { n: 'departure_board', c: 'e576' },
  { n: 'description', c: 'e873' },
  { n: 'desktop_mac', c: 'e30b' },
  { n: 'desktop_windows', c: 'e30c' },
  { n: 'details', c: 'e3c8' },
  { n: 'developer_board', c: 'e30d' },
  { n: 'developer_mode', c: 'e1b0' },
  { n: 'device_hub', c: 'e335' },
  { n: 'device_unknown', c: 'e339' },
  { n: 'devices', c: 'e1b1' },
  { n: 'devices_other', c: 'e337' },
  { n: 'dialer_sip', c: 'e0bb' },
  { n: 'dialpad', c: 'e0bc' },
  { n: 'directions', c: 'e52e' },
  { n: 'directions_bike', c: 'e52f' },
  { n: 'directions_boat', c: 'e532' },
  { n: 'directions_bus', c: 'e530' },
  { n: 'directions_car', c: 'e531' },
  { n: 'directions_railway', c: 'e534' },
  { n: 'directions_run', c: 'e566' },
  { n: 'directions_subway', c: 'e533' },
  { n: 'directions_transit', c: 'e535' },
  { n: 'directions_walk', c: 'e536' },
  { n: 'disc_full', c: 'e610' },
  { n: 'dns', c: 'e875' },
  { n: 'do_not_disturb', c: 'e612' },
  { n: 'do_not_disturb_alt', c: 'e611' },
  { n: 'do_not_disturb_off', c: 'e643' },
  { n: 'do_not_disturb_on', c: 'e644' },
  { n: 'dock', c: 'e30e' },
  { n: 'domain', c: 'e7ee' },
  { n: 'domain_disabled', c: 'e0ef' },
  { n: 'done', c: 'e876' },
  { n: 'done_all', c: 'e877' },
  { n: 'done_outline', c: 'e92f' },
  { n: 'donut_large', c: 'e917' },
  { n: 'donut_small', c: 'e918' },
  { n: 'drafts', c: 'e151' },
  { n: 'drag_handle', c: 'e25d' },
  { n: 'drag_indicator', c: 'e945' },
  { n: 'drive_eta', c: 'e613' },
  { n: 'dvr', c: 'e1b2' },
  { n: 'edit', c: 'e3c9' },
  { n: 'edit_attributes', c: 'e578' },
  { n: 'edit_location', c: 'e568' },
  { n: 'edit_off', c: 'e950' },
  { n: 'eject', c: 'e8fb' },
  { n: 'email', c: 'e0be' },
  { n: 'enhanced_encryption', c: 'e63f' },
  { n: 'equalizer', c: 'e01d' },
  { n: 'error', c: 'e000' },
  { n: 'error_outline', c: 'e001' },
  { n: 'euro_symbol', c: 'e926' },
  { n: 'ev_station', c: 'e56d' },
  { n: 'event', c: 'e878' },
  { n: 'event_available', c: 'e614' },
  { n: 'event_busy', c: 'e615' },
  { n: 'event_note', c: 'e616' },
  { n: 'event_seat', c: 'e903' },
  { n: 'exit_to_app', c: 'e879' },
  { n: 'expand', c: 'e94f' },
  { n: 'expand_less', c: 'e5ce' },
  { n: 'expand_more', c: 'e5cf' },
  { n: 'explicit', c: 'e01e' },
  { n: 'explore', c: 'e87a' },
  { n: 'exposure', c: 'e3ca' },
  { n: 'exposure_neg_1', c: 'e3cb' },
  { n: 'exposure_neg_2', c: 'e3cc' },
  { n: 'exposure_plus_1', c: 'e3cd' },
  { n: 'exposure_plus_2', c: 'e3ce' },
  { n: 'exposure_zero', c: 'e3cf' },
  { n: 'extension', c: 'e87b' },
  { n: 'face', c: 'e87c' },
  { n: 'fast_forward', c: 'e01f' },
  { n: 'fast_rewind', c: 'e020' },
  { n: 'fastfood', c: 'e57a' },
  { n: 'favorite', c: 'e87d' },
  { n: 'favorite_border', c: 'e87e' },
  { n: 'featured_play_list', c: 'e06d' },
  { n: 'featured_video', c: 'e06e' },
  { n: 'feedback', c: 'e87f' },
  { n: 'fiber_dvr', c: 'e05d' },
  { n: 'fiber_manual_record', c: 'e061' },
  { n: 'fiber_new', c: 'e05e' },
  { n: 'fiber_pin', c: 'e06a' },
  { n: 'fiber_smart_record', c: 'e062' },
  { n: 'file_copy', c: 'e173' },
  { n: 'file_download', c: 'e2c4' },
  { n: 'file_upload', c: 'e2c6' },
  { n: 'filter', c: 'e3d3' },
  { n: 'filter_1', c: 'e3d0' },
  { n: 'filter_2', c: 'e3d1' },
  { n: 'filter_3', c: 'e3d2' },
  { n: 'filter_4', c: 'e3d4' },
  { n: 'filter_5', c: 'e3d5' },
  { n: 'filter_6', c: 'e3d6' },
  { n: 'filter_7', c: 'e3d7' },
  { n: 'filter_8', c: 'e3d8' },
  { n: 'filter_9', c: 'e3d9' },
  { n: 'filter_9_plus', c: 'e3da' },
  { n: 'filter_b_and_w', c: 'e3db' },
  { n: 'filter_center_focus', c: 'e3dc' },
  { n: 'filter_drama', c: 'e3dd' },
  { n: 'filter_frames', c: 'e3de' },
  { n: 'filter_hdr', c: 'e3df' },
  { n: 'filter_list', c: 'e152' },
  { n: 'filter_none', c: 'e3e0' },
  { n: 'filter_tilt_shift', c: 'e3e2' },
  { n: 'filter_vintage', c: 'e3e3' },
  { n: 'find_in_page', c: 'e880' },
  { n: 'find_replace', c: 'e881' },
  { n: 'fingerprint', c: 'e90d' },
  { n: 'first_page', c: 'e5dc' },
  { n: 'fitness_center', c: 'eb43' },
  { n: 'flag', c: 'e153' },
  { n: 'flare', c: 'e3e4' },
  { n: 'flash_auto', c: 'e3e5' },
  { n: 'flash_off', c: 'e3e6' },
  { n: 'flash_on', c: 'e3e7' },
  { n: 'flight', c: 'e539' },
  { n: 'flight_land', c: 'e904' },
  { n: 'flight_takeoff', c: 'e905' },
  { n: 'flip', c: 'e3e8' },
  { n: 'flip_to_back', c: 'e882' },
  { n: 'flip_to_front', c: 'e883' },
  { n: 'folder', c: 'e2c7' },
  { n: 'folder_open', c: 'e2c8' },
  { n: 'folder_shared', c: 'e2c9' },
  { n: 'folder_special', c: 'e617' },
  { n: 'font_download', c: 'e167' },
  { n: 'format_align_center', c: 'e234' },
  { n: 'format_align_justify', c: 'e235' },
  { n: 'format_align_left', c: 'e236' },
  { n: 'format_align_right', c: 'e237' },
  { n: 'format_bold', c: 'e238' },
  { n: 'format_clear', c: 'e239' },
  { n: 'format_color_fill', c: 'e23a' },
  { n: 'format_color_reset', c: 'e23b' },
  { n: 'format_color_text', c: 'e23c' },
  { n: 'format_indent_decrease', c: 'e23d' },
  { n: 'format_indent_increase', c: 'e23e' },
  { n: 'format_italic', c: 'e23f' },
  { n: 'format_line_spacing', c: 'e240' },
  { n: 'format_list_bulleted', c: 'e241' },
  { n: 'format_list_numbered', c: 'e242' },
  { n: 'format_list_numbered_rtl', c: 'e267' },
  { n: 'format_paint', c: 'e243' },
  { n: 'format_quote', c: 'e244' },
  { n: 'format_shapes', c: 'e25e' },
  { n: 'format_size', c: 'e245' },
  { n: 'format_strikethrough', c: 'e246' },
  { n: 'format_textdirection_l_to_r', c: 'e247' },
  { n: 'format_textdirection_r_to_l', c: 'e248' },
  { n: 'format_underlined', c: 'e249' },
  { n: 'forum', c: 'e0bf' },
  { n: 'forward', c: 'e154' },
  { n: 'forward_10', c: 'e056' },
  { n: 'forward_30', c: 'e057' },
  { n: 'forward_5', c: 'e058' },
  { n: 'free_breakfast', c: 'eb44' },
  { n: 'fullscreen', c: 'e5d0' },
  { n: 'fullscreen_exit', c: 'e5d1' },
  { n: 'functions', c: 'e24a' },
  { n: 'g_translate', c: 'e927' },
  { n: 'gamepad', c: 'e30f' },
  { n: 'games', c: 'e021' },
  { n: 'gavel', c: 'e90e' },
  { n: 'gesture', c: 'e155' },
  { n: 'get_app', c: 'e884' },
  { n: 'gif', c: 'e908' },
  { n: 'golf_course', c: 'eb45' },
  { n: 'gps_fixed', c: 'e1b3' },
  { n: 'gps_not_fixed', c: 'e1b4' },
  { n: 'gps_off', c: 'e1b5' },
  { n: 'grade', c: 'e885' },
  { n: 'gradient', c: 'e3e9' },
  { n: 'grain', c: 'e3ea' },
  { n: 'graphic_eq', c: 'e1b8' },
  { n: 'grid_off', c: 'e3eb' },
  { n: 'grid_on', c: 'e3ec' },
  { n: 'group', c: 'e7ef' },
  { n: 'group_add', c: 'e7f0' },
  { n: 'group_work', c: 'e886' },
  { n: 'hd', c: 'e052' },
  { n: 'hdr_off', c: 'e3ed' },
  { n: 'hdr_on', c: 'e3ee' },
  { n: 'hdr_strong', c: 'e3f1' },
  { n: 'hdr_weak', c: 'e3f2' },
  { n: 'headset', c: 'e310' },
  { n: 'headset_mic', c: 'e311' },
  { n: 'headset_off', c: 'e33a' },
  { n: 'healing', c: 'e3f3' },
  { n: 'hearing', c: 'e023' },
  { n: 'help', c: 'e887' },
  { n: 'help_outline', c: 'e8fd' },
  { n: 'high_quality', c: 'e024' },
  { n: 'highlight', c: 'e25f' },
  { n: 'highlight_off', c: 'e888' },
  { n: 'history', c: 'e889' },
  { n: 'home', c: 'e88a' },
  { n: 'horizontal_split', c: 'e947' },
  { n: 'hot_tub', c: 'eb46' },
  { n: 'hotel', c: 'e53a' },
  { n: 'hourglass_empty', c: 'e88b' },
  { n: 'hourglass_full', c: 'e88c' },
  { n: 'how_to_reg', c: 'e174' },
  { n: 'how_to_vote', c: 'e175' },
  { n: 'http', c: 'e902' },
  { n: 'https', c: 'e88d' },
  { n: 'image', c: 'e3f4' },
  { n: 'image_aspect_ratio', c: 'e3f5' },
  { n: 'image_search', c: 'e43f' },
  { n: 'import_contacts', c: 'e0e0' },
  { n: 'import_export', c: 'e0c3' },
  { n: 'important_devices', c: 'e912' },
  { n: 'inbox', c: 'e156' },
  { n: 'indeterminate_check_box', c: 'e909' },
  { n: 'info', c: 'e88e' },
  { n: 'info_outline', c: 'e88f' },
  { n: 'input', c: 'e890' },
  { n: 'insert_chart', c: 'e24b' },
  { n: 'insert_chart_outlined', c: 'e26a' },
  { n: 'insert_comment', c: 'e24c' },
  { n: 'insert_drive_file', c: 'e24d' },
  { n: 'insert_emoticon', c: 'e24e' },
  { n: 'insert_invitation', c: 'e24f' },
  { n: 'insert_link', c: 'e250' },
  { n: 'insert_photo', c: 'e251' },
  { n: 'invert_colors', c: 'e891' },
  { n: 'invert_colors_off', c: 'e0c4' },
  { n: 'iso', c: 'e3f6' },
  { n: 'keyboard', c: 'e312' },
  { n: 'keyboard_arrow_down', c: 'e313' },
  { n: 'keyboard_arrow_left', c: 'e314' },
  { n: 'keyboard_arrow_right', c: 'e315' },
  { n: 'keyboard_arrow_up', c: 'e316' },
  { n: 'keyboard_backspace', c: 'e317' },
  { n: 'keyboard_capslock', c: 'e318' },
  { n: 'keyboard_hide', c: 'e31a' },
  { n: 'keyboard_return', c: 'e31b' },
  { n: 'keyboard_tab', c: 'e31c' },
  { n: 'keyboard_voice', c: 'e31d' },
  { n: 'kitchen', c: 'eb47' },
  { n: 'label', c: 'e892' },
  { n: 'label_important', c: 'e937' },
  { n: 'label_important_outline', c: 'e948' },
  { n: 'label_outline', c: 'e893' },
  { n: 'landscape', c: 'e3f7' },
  { n: 'language', c: 'e894' },
  { n: 'laptop', c: 'e31e' },
  { n: 'laptop_chromebook', c: 'e31f' },
  { n: 'laptop_mac', c: 'e320' },
  { n: 'laptop_windows', c: 'e321' },
  { n: 'last_page', c: 'e5dd' },
  { n: 'launch', c: 'e895' },
  { n: 'layers', c: 'e53b' },
  { n: 'layers_clear', c: 'e53c' },
  { n: 'leak_add', c: 'e3f8' },
  { n: 'leak_remove', c: 'e3f9' },
  { n: 'lens', c: 'e3fa' },
  { n: 'library_add', c: 'e02e' },
  { n: 'library_books', c: 'e02f' },
  { n: 'library_music', c: 'e030' },
  { n: 'lightbulb', c: 'e0f0' },
  { n: 'lightbulb_outline', c: 'e90f' },
  { n: 'line_style', c: 'e919' },
  { n: 'line_weight', c: 'e91a' },
  { n: 'linear_scale', c: 'e260' },
  { n: 'link', c: 'e157' },
  { n: 'link_off', c: 'e16f' },
  { n: 'linked_camera', c: 'e438' },
  { n: 'list', c: 'e896' },
  { n: 'list_alt', c: 'e0ee' },
  { n: 'live_help', c: 'e0c6' },
  { n: 'live_tv', c: 'e639' },
  { n: 'local_activity', c: 'e53f' },
  { n: 'local_airport', c: 'e53d' },
  { n: 'local_atm', c: 'e53e' },
  { n: 'local_bar', c: 'e540' },
  { n: 'local_cafe', c: 'e541' },
  { n: 'local_car_wash', c: 'e542' },
  { n: 'local_convenience_store', c: 'e543' },
  { n: 'local_dining', c: 'e556' },
  { n: 'local_drink', c: 'e544' },
  { n: 'local_florist', c: 'e545' },
  { n: 'local_gas_station', c: 'e546' },
  { n: 'local_grocery_store', c: 'e547' },
  { n: 'local_hospital', c: 'e548' },
  { n: 'local_hotel', c: 'e549' },
  { n: 'local_laundry_service', c: 'e54a' },
  { n: 'local_library', c: 'e54b' },
  { n: 'local_mall', c: 'e54c' },
  { n: 'local_movies', c: 'e54d' },
  { n: 'local_offer', c: 'e54e' },
  { n: 'local_parking', c: 'e54f' },
  { n: 'local_pharmacy', c: 'e550' },
  { n: 'local_phone', c: 'e551' },
  { n: 'local_pizza', c: 'e552' },
  { n: 'local_play', c: 'e553' },
  { n: 'local_post_office', c: 'e554' },
  { n: 'local_printshop', c: 'e555' },
  { n: 'local_see', c: 'e557' },
  { n: 'local_shipping', c: 'e558' },
  { n: 'local_taxi', c: 'e559' },
  { n: 'location_city', c: 'e7f1' },
  { n: 'location_disabled', c: 'e1b6' },
  { n: 'location_off', c: 'e0c7' },
  { n: 'location_on', c: 'e0c8' },
  { n: 'location_searching', c: 'e1b7' },
  { n: 'lock', c: 'e897' },
  { n: 'lock_open', c: 'e898' },
  { n: 'lock_outline', c: 'e899' },
  { n: 'looks', c: 'e3fc' },
  { n: 'looks_3', c: 'e3fb' },
  { n: 'looks_4', c: 'e3fd' },
  { n: 'looks_5', c: 'e3fe' },
  { n: 'looks_6', c: 'e3ff' },
  { n: 'looks_one', c: 'e400' },
  { n: 'looks_two', c: 'e401' },
  { n: 'loop', c: 'e028' },
  { n: 'loupe', c: 'e402' },
  { n: 'low_priority', c: 'e16d' },
  { n: 'loyalty', c: 'e89a' },
  { n: 'mail', c: 'e158' },
  { n: 'mail_outline', c: 'e0e1' },
  { n: 'map', c: 'e55b' },
  { n: 'markunread', c: 'e159' },
  { n: 'markunread_mailbox', c: 'e89b' },
  { n: 'maximize', c: 'e930' },
  { n: 'meeting_room', c: 'eb4f' },
  { n: 'memory', c: 'e322' },
  { n: 'menu', c: 'e5d2' },
  { n: 'merge_type', c: 'e252' },
  { n: 'message', c: 'e0c9' },
  { n: 'mic', c: 'e029' },
  { n: 'mic_none', c: 'e02a' },
  { n: 'mic_off', c: 'e02b' },
  { n: 'minimize', c: 'e931' },
  { n: 'missed_video_call', c: 'e073' },
  { n: 'mms', c: 'e618' },
  { n: 'mobile_friendly', c: 'e200' },
  { n: 'mobile_off', c: 'e201' },
  { n: 'mobile_screen_share', c: 'e0e7' },
  { n: 'mode_comment', c: 'e253' },
  { n: 'mode_edit', c: 'e254' },
  { n: 'monetization_on', c: 'e263' },
  { n: 'money', c: 'e57d' },
  { n: 'money_off', c: 'e25c' },
  { n: 'monochrome_photos', c: 'e403' },
  { n: 'mood', c: 'e7f2' },
  { n: 'mood_bad', c: 'e7f3' },
  { n: 'more', c: 'e619' },
  { n: 'more_horiz', c: 'e5d3' },
  { n: 'more_vert', c: 'e5d4' },
  { n: 'motorcycle', c: 'e91b' },
  { n: 'mouse', c: 'e323' },
  { n: 'move_to_inbox', c: 'e168' },
  { n: 'movie', c: 'e02c' },
  { n: 'movie_creation', c: 'e404' },
  { n: 'movie_filter', c: 'e43a' },
  { n: 'multiline_chart', c: 'e6df' },
  { n: 'music_note', c: 'e405' },
  { n: 'music_off', c: 'e440' },
  { n: 'music_video', c: 'e063' },
  { n: 'my_location', c: 'e55c' },
  { n: 'nature', c: 'e406' },
  { n: 'nature_people', c: 'e407' },
  { n: 'navigate_before', c: 'e408' },
  { n: 'navigate_next', c: 'e409' },
  { n: 'navigation', c: 'e55d' },
  { n: 'near_me', c: 'e569' },
  { n: 'network_cell', c: 'e1b9' },
  { n: 'network_check', c: 'e640' },
  { n: 'network_locked', c: 'e61a' },
  { n: 'network_wifi', c: 'e1ba' },
  { n: 'new_releases', c: 'e031' },
  { n: 'next_week', c: 'e16a' },
  { n: 'nfc', c: 'e1bb' },
  { n: 'no_encryption', c: 'e641' },
  { n: 'no_meeting_room', c: 'eb4e' },
  { n: 'no_sim', c: 'e0cc' },
  { n: 'not_interested', c: 'e033' },
  { n: 'not_listed_location', c: 'e575' },
  { n: 'note', c: 'e06f' },
  { n: 'note_add', c: 'e89c' },
  { n: 'notes', c: 'e26c' },
  { n: 'notification_important', c: 'e004' },
  { n: 'notifications', c: 'e7f4' },
  { n: 'notifications_active', c: 'e7f7' },
  { n: 'notifications_none', c: 'e7f5' },
  { n: 'notifications_off', c: 'e7f6' },
  { n: 'notifications_paused', c: 'e7f8' },
  { n: 'offline_bolt', c: 'e932' },
  { n: 'offline_pin', c: 'e90a' },
  { n: 'ondemand_video', c: 'e63a' },
  { n: 'opacity', c: 'e91c' },
  { n: 'open_in_browser', c: 'e89d' },
  { n: 'open_in_new', c: 'e89e' },
  { n: 'open_with', c: 'e89f' },
  { n: 'outlined_flag', c: 'e16e' },
  { n: 'pages', c: 'e7f9' },
  { n: 'pageview', c: 'e8a0' },
  { n: 'palette', c: 'e40a' },
  { n: 'pan_tool', c: 'e925' },
  { n: 'panorama', c: 'e40b' },
  { n: 'panorama_fish_eye', c: 'e40c' },
  { n: 'panorama_horizontal', c: 'e40d' },
  { n: 'panorama_vertical', c: 'e40e' },
  { n: 'panorama_wide_angle', c: 'e40f' },
  { n: 'party_mode', c: 'e7fa' },
  { n: 'pause', c: 'e034' },
  { n: 'pause_circle_filled', c: 'e035' },
  { n: 'pause_circle_outline', c: 'e036' },
  { n: 'pause_presentation', c: 'e0ea' },
  { n: 'payment', c: 'e8a1' },
  { n: 'people', c: 'e7fb' },
  { n: 'people_outline', c: 'e7fc' },
  { n: 'perm_camera_mic', c: 'e8a2' },
  { n: 'perm_contact_calendar', c: 'e8a3' },
  { n: 'perm_data_setting', c: 'e8a4' },
  { n: 'perm_device_information', c: 'e8a5' },
  { n: 'perm_identity', c: 'e8a6' },
  { n: 'perm_media', c: 'e8a7' },
  { n: 'perm_phone_msg', c: 'e8a8' },
  { n: 'perm_scan_wifi', c: 'e8a9' },
  { n: 'person', c: 'e7fd' },
  { n: 'person_add', c: 'e7fe' },
  { n: 'person_outline', c: 'e7ff' },
  { n: 'person_pin', c: 'e55a' },
  { n: 'person_pin_circle', c: 'e56a' },
  { n: 'personal_video', c: 'e63b' },
  { n: 'pets', c: 'e91d' },
  { n: 'phone', c: 'e0cd' },
  { n: 'phone_android', c: 'e324' },
  { n: 'phone_bluetooth_speaker', c: 'e61b' },
  { n: 'phone_callback', c: 'e649' },
  { n: 'phone_forwarded', c: 'e61c' },
  { n: 'phone_in_talk', c: 'e61d' },
  { n: 'phone_iphone', c: 'e325' },
  { n: 'phone_locked', c: 'e61e' },
  { n: 'phone_missed', c: 'e61f' },
  { n: 'phone_paused', c: 'e620' },
  { n: 'phonelink', c: 'e326' },
  { n: 'phonelink_erase', c: 'e0db' },
  { n: 'phonelink_lock', c: 'e0dc' },
  { n: 'phonelink_off', c: 'e327' },
  { n: 'phonelink_ring', c: 'e0dd' },
  { n: 'phonelink_setup', c: 'e0de' },
  { n: 'photo', c: 'e410' },
  { n: 'photo_album', c: 'e411' },
  { n: 'photo_camera', c: 'e412' },
  { n: 'photo_filter', c: 'e43b' },
  { n: 'photo_library', c: 'e413' },
  { n: 'photo_size_select_actual', c: 'e432' },
  { n: 'photo_size_select_large', c: 'e433' },
  { n: 'photo_size_select_small', c: 'e434' },
  { n: 'picture_as_pdf', c: 'e415' },
  { n: 'picture_in_picture', c: 'e8aa' },
  { n: 'picture_in_picture_alt', c: 'e911' },
  { n: 'pie_chart', c: 'e6c4' },
  { n: 'pie_chart_outlined', c: 'e6c5' },
  { n: 'pin_drop', c: 'e55e' },
  { n: 'place', c: 'e55f' },
  { n: 'play_arrow', c: 'e037' },
  { n: 'play_circle_filled', c: 'e038' },
  { n: 'play_circle_outline', c: 'e039' },
  { n: 'play_for_work', c: 'e906' },
  { n: 'playlist_add', c: 'e03b' },
  { n: 'playlist_add_check', c: 'e065' },
  { n: 'playlist_play', c: 'e05f' },
  { n: 'plus_one', c: 'e800' },
  { n: 'poll', c: 'e801' },
  { n: 'polymer', c: 'e8ab' },
  { n: 'pool', c: 'eb48' },
  { n: 'portable_wifi_off', c: 'e0ce' },
  { n: 'portrait', c: 'e416' },
  { n: 'power', c: 'e63c' },
  { n: 'power_input', c: 'e336' },
  { n: 'power_off', c: 'e646' },
  { n: 'power_settings_new', c: 'e8ac' },
  { n: 'pregnant_woman', c: 'e91e' },
  { n: 'present_to_all', c: 'e0df' },
  { n: 'print', c: 'e8ad' },
  { n: 'priority_high', c: 'e645' },
  { n: 'public', c: 'e80b' },
  { n: 'publish', c: 'e255' },
  { n: 'query_builder', c: 'e8ae' },
  { n: 'question_answer', c: 'e8af' },
  { n: 'queue', c: 'e03c' },
  { n: 'queue_music', c: 'e03d' },
  { n: 'queue_play_next', c: 'e066' },
  { n: 'radio', c: 'e03e' },
  { n: 'radio_button_checked', c: 'e837' },
  { n: 'radio_button_unchecked', c: 'e836' },
  { n: 'rate_review', c: 'e560' },
  { n: 'receipt', c: 'e8b0' },
  { n: 'recent_actors', c: 'e03f' },
  { n: 'record_voice_over', c: 'e91f' },
  { n: 'redeem', c: 'e8b1' },
  { n: 'redo', c: 'e15a' },
  { n: 'refresh', c: 'e5d5' },
  { n: 'remove', c: 'e15b' },
  { n: 'remove_circle', c: 'e15c' },
  { n: 'remove_circle_outline', c: 'e15d' },
  { n: 'remove_from_queue', c: 'e067' },
  { n: 'remove_red_eye', c: 'e417' },
  { n: 'remove_shopping_cart', c: 'e928' },
  { n: 'reorder', c: 'e8fe' },
  { n: 'repeat', c: 'e040' },
  { n: 'repeat_one', c: 'e041' },
  { n: 'replay', c: 'e042' },
  { n: 'replay_10', c: 'e059' },
  { n: 'replay_30', c: 'e05a' },
  { n: 'replay_5', c: 'e05b' },
  { n: 'reply', c: 'e15e' },
  { n: 'reply_all', c: 'e15f' },
  { n: 'report', c: 'e160' },
  { n: 'report_off', c: 'e170' },
  { n: 'report_problem', c: 'e8b2' },
  { n: 'restaurant', c: 'e56c' },
  { n: 'restaurant_menu', c: 'e561' },
  { n: 'restore', c: 'e8b3' },
  { n: 'restore_from_trash', c: 'e938' },
  { n: 'restore_page', c: 'e929' },
  { n: 'ring_volume', c: 'e0d1' },
  { n: 'room', c: 'e8b4' },
  { n: 'room_service', c: 'eb49' },
  { n: 'rotate_90_degrees_ccw', c: 'e418' },
  { n: 'rotate_left', c: 'e419' },
  { n: 'rotate_right', c: 'e41a' },
  { n: 'rounded_corner', c: 'e920' },
  { n: 'router', c: 'e328' },
  { n: 'rowing', c: 'e921' },
  { n: 'rss_feed', c: 'e0e5' },
  { n: 'rv_hookup', c: 'e642' },
  { n: 'satellite', c: 'e562' },
  { n: 'save', c: 'e161' },
  { n: 'save_alt', c: 'e171' },
  { n: 'scanner', c: 'e329' },
  { n: 'scatter_plot', c: 'e268' },
  { n: 'schedule', c: 'e8b5' },
  { n: 'school', c: 'e80c' },
  { n: 'score', c: 'e269' },
  { n: 'screen_lock_landscape', c: 'e1be' },
  { n: 'screen_lock_portrait', c: 'e1bf' },
  { n: 'screen_lock_rotation', c: 'e1c0' },
  { n: 'screen_rotation', c: 'e1c1' },
  { n: 'screen_share', c: 'e0e2' },
  { n: 'sd_card', c: 'e623' },
  { n: 'sd_storage', c: 'e1c2' },
  { n: 'search', c: 'e8b6' },
  { n: 'security', c: 'e32a' },
  { n: 'select_all', c: 'e162' },
  { n: 'send', c: 'e163' },
  { n: 'sentiment_dissatisfied', c: 'e811' },
  { n: 'sentiment_neutral', c: 'e812' },
  { n: 'sentiment_satisfied', c: 'e813' },
  { n: 'sentiment_satisfied_alt', c: 'e0ed' },
  { n: 'sentiment_very_dissatisfied', c: 'e814' },
  { n: 'sentiment_very_satisfied', c: 'e815' },
  { n: 'settings', c: 'e8b8' },
  { n: 'settings_applications', c: 'e8b9' },
  { n: 'settings_backup_restore', c: 'e8ba' },
  { n: 'settings_bluetooth', c: 'e8bb' },
  { n: 'settings_brightness', c: 'e8bd' },
  { n: 'settings_cell', c: 'e8bc' },
  { n: 'settings_ethernet', c: 'e8be' },
  { n: 'settings_input_antenna', c: 'e8bf' },
  { n: 'settings_input_component', c: 'e8c0' },
  { n: 'settings_input_composite', c: 'e8c1' },
  { n: 'settings_input_hdmi', c: 'e8c2' },
  { n: 'settings_input_svideo', c: 'e8c3' },
  { n: 'settings_overscan', c: 'e8c4' },
  { n: 'settings_phone', c: 'e8c5' },
  { n: 'settings_power', c: 'e8c6' },
  { n: 'settings_remote', c: 'e8c7' },
  { n: 'settings_system_daydream', c: 'e1c3' },
  { n: 'settings_voice', c: 'e8c8' },
  { n: 'share', c: 'e80d' },
  { n: 'shop', c: 'e8c9' },
  { n: 'shop_two', c: 'e8ca' },
  { n: 'shopping_basket', c: 'e8cb' },
  { n: 'shopping_cart', c: 'e8cc' },
  { n: 'short_text', c: 'e261' },
  { n: 'show_chart', c: 'e6e1' },
  { n: 'shuffle', c: 'e043' },
  { n: 'shutter_speed', c: 'e43d' },
  { n: 'signal_cellular_4_bar', c: 'e1c8' },
  { n: 'signal_cellular_alt', c: 'e202' },
  { n: 'signal_cellular_connected_no_internet_4_bar', c: 'e1cd' },
  { n: 'signal_cellular_no_sim', c: 'e1ce' },
  { n: 'signal_cellular_null', c: 'e1cf' },
  { n: 'signal_cellular_off', c: 'e1d0' },
  { n: 'signal_wifi_4_bar', c: 'e1d8' },
  { n: 'signal_wifi_4_bar_lock', c: 'e1d9' },
  { n: 'signal_wifi_off', c: 'e1da' },
  { n: 'sim_card', c: 'e32b' },
  { n: 'sim_card_alert', c: 'e624' },
  { n: 'skip_next', c: 'e044' },
  { n: 'skip_previous', c: 'e045' },
  { n: 'slideshow', c: 'e41b' },
  { n: 'slow_motion_video', c: 'e068' },
  { n: 'smartphone', c: 'e32c' },
  { n: 'smoke_free', c: 'eb4a' },
  { n: 'smoking_rooms', c: 'eb4b' },
  { n: 'sms', c: 'e625' },
  { n: 'sms_failed', c: 'e626' },
  { n: 'snooze', c: 'e046' },
  { n: 'sort', c: 'e164' },
  { n: 'sort_by_alpha', c: 'e053' },
  { n: 'spa', c: 'eb4c' },
  { n: 'space_bar', c: 'e256' },
  { n: 'speaker', c: 'e32d' },
  { n: 'speaker_group', c: 'e32e' },
  { n: 'speaker_notes', c: 'e8cd' },
  { n: 'speaker_notes_off', c: 'e92a' },
  { n: 'speaker_phone', c: 'e0d2' },
  { n: 'spellcheck', c: 'e8ce' },
  { n: 'star', c: 'e838' },
  { n: 'star_border', c: 'e83a' },
  { n: 'star_half', c: 'e839' },
  { n: 'stars', c: 'e8d0' },
  { n: 'stay_current_landscape', c: 'e0d3' },
  { n: 'stay_current_portrait', c: 'e0d4' },
  { n: 'stay_primary_landscape', c: 'e0d5' },
  { n: 'stay_primary_portrait', c: 'e0d6' },
  { n: 'stop', c: 'e047' },
  { n: 'stop_screen_share', c: 'e0e3' },
  { n: 'storage', c: 'e1db' },
  { n: 'store', c: 'e8d1' },
  { n: 'store_mall_directory', c: 'e563' },
  { n: 'straighten', c: 'e41c' },
  { n: 'streetview', c: 'e56e' },
  { n: 'strikethrough_s', c: 'e257' },
  { n: 'style', c: 'e41d' },
  { n: 'subdirectory_arrow_left', c: 'e5d9' },
  { n: 'subdirectory_arrow_right', c: 'e5da' },
  { n: 'subject', c: 'e8d2' },
  { n: 'subscriptions', c: 'e064' },
  { n: 'subtitles', c: 'e048' },
  { n: 'subway', c: 'e56f' },
  { n: 'supervised_user_circle', c: 'e939' },
  { n: 'supervisor_account', c: 'e8d3' },
  { n: 'surround_sound', c: 'e049' },
  { n: 'swap_calls', c: 'e0d7' },
  { n: 'swap_horiz', c: 'e8d4' },
  { n: 'swap_horizontal_circle', c: 'e933' },
  { n: 'swap_vert', c: 'e8d5' },
  { n: 'swap_vertical_circle', c: 'e8d6' },
  { n: 'switch_camera', c: 'e41e' },
  { n: 'switch_video', c: 'e41f' },
  { n: 'sync', c: 'e627' },
  { n: 'sync_disabled', c: 'e628' },
  { n: 'sync_problem', c: 'e629' },
  { n: 'system_update', c: 'e62a' },
  { n: 'system_update_alt', c: 'e8d7' },
  { n: 'tab', c: 'e8d8' },
  { n: 'tab_unselected', c: 'e8d9' },
  { n: 'table_chart', c: 'e265' },
  { n: 'tablet', c: 'e32f' },
  { n: 'tablet_android', c: 'e330' },
  { n: 'tablet_mac', c: 'e331' },
  { n: 'tag_faces', c: 'e420' },
  { n: 'tap_and_play', c: 'e62b' },
  { n: 'terrain', c: 'e564' },
  { n: 'text_fields', c: 'e262' },
  { n: 'text_format', c: 'e165' },
  { n: 'text_rotate_up', c: 'e93a' },
  { n: 'text_rotate_vertical', c: 'e93b' },
  { n: 'text_rotation_down', c: 'e93e' },
  { n: 'text_rotation_none', c: 'e93f' },
  { n: 'textsms', c: 'e0d8' },
  { n: 'texture', c: 'e421' },
  { n: 'theaters', c: 'e8da' },
  { n: 'thumb_down', c: 'e8db' },
  { n: 'thumb_down_alt', c: 'e816' },
  { n: 'thumb_up', c: 'e8dc' },
  { n: 'thumb_up_alt', c: 'e817' },
  { n: 'thumbs_up_down', c: 'e8dd' },
  { n: 'time_to_leave', c: 'e62c' },
  { n: 'timelapse', c: 'e422' },
  { n: 'timeline', c: 'e922' },
  { n: 'timer', c: 'e425' },
  { n: 'timer_10', c: 'e423' },
  { n: 'timer_3', c: 'e424' },
  { n: 'timer_off', c: 'e426' },
  { n: 'title', c: 'e264' },
  { n: 'toc', c: 'e8de' },
  { n: 'today', c: 'e8df' },
  { n: 'toll', c: 'e8e0' },
  { n: 'tonality', c: 'e427' },
  { n: 'touch_app', c: 'e913' },
  { n: 'toys', c: 'e332' },
  { n: 'track_changes', c: 'e8e1' },
  { n: 'traffic', c: 'e565' },
  { n: 'train', c: 'e570' },
  { n: 'tram', c: 'e571' },
  { n: 'transfer_within_a_station', c: 'e572' },
  { n: 'transform', c: 'e428' },
  { n: 'transit_enterexit', c: 'e579' },
  { n: 'translate', c: 'e8e2' },
  { n: 'trending_down', c: 'e8e3' },
  { n: 'trending_flat', c: 'e8e4' },
  { n: 'trending_up', c: 'e8e5' },
  { n: 'trip_origin', c: 'e57b' },
  { n: 'tune', c: 'e429' },
  { n: 'turned_in', c: 'e8e6' },
  { n: 'turned_in_not', c: 'e8e7' },
  { n: 'tv', c: 'e333' },
  { n: 'tv_off', c: 'e647' },
  { n: 'unarchive', c: 'e169' },
  { n: 'undo', c: 'e166' },
  { n: 'unfold_less', c: 'e5d6' },
  { n: 'unfold_more', c: 'e5d7' },
  { n: 'unsubscribe', c: 'e0eb' },
  { n: 'update', c: 'e923' },
  { n: 'usb', c: 'e1e0' },
  { n: 'verified_user', c: 'e8e8' },
  { n: 'vertical_align_bottom', c: 'e258' },
  { n: 'vertical_align_center', c: 'e259' },
  { n: 'vertical_align_top', c: 'e25a' },
  { n: 'vertical_split', c: 'e949' },
  { n: 'vibration', c: 'e62d' },
  { n: 'video_call', c: 'e070' },
  { n: 'video_label', c: 'e071' },
  { n: 'video_library', c: 'e04a' },
  { n: 'videocam', c: 'e04b' },
  { n: 'videocam_off', c: 'e04c' },
  { n: 'videogame_asset', c: 'e338' },
  { n: 'view_agenda', c: 'e8e9' },
  { n: 'view_array', c: 'e8ea' },
  { n: 'view_carousel', c: 'e8eb' },
  { n: 'view_column', c: 'e8ec' },
  { n: 'view_comfy', c: 'e42a' },
  { n: 'view_compact', c: 'e42b' },
  { n: 'view_day', c: 'e8ed' },
  { n: 'view_headline', c: 'e8ee' },
  { n: 'view_list', c: 'e8ef' },
  { n: 'view_module', c: 'e8f0' },
  { n: 'view_quilt', c: 'e8f1' },
  { n: 'view_stream', c: 'e8f2' },
  { n: 'view_week', c: 'e8f3' },
  { n: 'vignette', c: 'e435' },
  { n: 'visibility', c: 'e8f4' },
  { n: 'visibility_off', c: 'e8f5' },
  { n: 'voice_chat', c: 'e62e' },
  { n: 'voice_over_off', c: 'e94a' },
  { n: 'voicemail', c: 'e0d9' },
  { n: 'volume_down', c: 'e04d' },
  { n: 'volume_mute', c: 'e04e' },
  { n: 'volume_off', c: 'e04f' },
  { n: 'volume_up', c: 'e050' },
  { n: 'vpn_key', c: 'e0da' },
  { n: 'vpn_lock', c: 'e62f' },
  { n: 'wallpaper', c: 'e1bc' },
  { n: 'warning', c: 'e002' },
  { n: 'watch', c: 'e334' },
  { n: 'watch_later', c: 'e924' },
  { n: 'waves', c: 'e176' },
  { n: 'wb_auto', c: 'e42c' },
  { n: 'wb_cloudy', c: 'e42d' },
  { n: 'wb_incandescent', c: 'e42e' },
  { n: 'wb_iridescent', c: 'e436' },
  { n: 'wb_sunny', c: 'e430' },
  { n: 'wc', c: 'e63d' },
  { n: 'web', c: 'e051' },
  { n: 'web_asset', c: 'e069' },
  { n: 'weekend', c: 'e16b' },
  { n: 'whatshot', c: 'e80e' },
  { n: 'where_to_vote', c: 'e177' },
  { n: 'widgets', c: 'e1bd' },
  { n: 'wifi', c: 'e63e' },
  { n: 'wifi_lock', c: 'e1e1' },
  { n: 'wifi_off', c: 'e648' },
  { n: 'wifi_tethering', c: 'e1e2' },
  { n: 'work', c: 'e8f9' },
  { n: 'work_off', c: 'e942' },
  { n: 'work_outline', c: 'e943' },
  { n: 'wrap_text', c: 'e25b' },
  { n: 'youtube_searched_for', c: 'e8fa' },
  { n: 'zoom_in', c: 'e8ff' },
  { n: 'zoom_out', c: 'e900' },
  { n: 'zoom_out_map', c: 'e56b' }
];

export enum IconFamily {
  COMMUNITY_ICONS,
  GOOGLE_ICONS
}

export interface IconData {
  name: string;
  codePoint: number;
  family: IconFamily;
  apiFamily: string;
}

type IconMapping = Record<string, IconData>;

const communityIconsMap = communityMaterialIcons.reduce(
  (agg: IconMapping, icon) => {
    const codePoint = parseInt(icon.c, 16);

    agg[codePoint] = {
      family: IconFamily.COMMUNITY_ICONS,
      name: icon.n,
      codePoint,
      apiFamily: 'MaterialDesignIconFont'
    };

    return agg;
  },
  {}
);

const googleIconsMap = googleMaterialIcons.reduce((agg: IconMapping, icon) => {
  const codePoint = parseInt(icon.c, 16);

  agg[codePoint] = {
    family: IconFamily.GOOGLE_ICONS,
    name: icon.n,
    codePoint,
    apiFamily: 'MaterialIcons'
  };

  return agg;
}, {});

const communityIcons = Object.values(communityIconsMap);
communityIcons.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

const lookupIcon = (
  apiFamily: string,
  codePoint: number
): IconData | undefined => {
  switch (apiFamily) {
    case 'MaterialDesignIconFont':
      return communityIconsMap[codePoint];

    case 'MaterialIcons':
      return googleIconsMap[codePoint];

    default:
      console.error(`Unknown font family: ${apiFamily}`);
      return communityIconsMap[61441];
  }
};

export default {
  lookup(apiFamily: string, codePoint: number): IconData {
    const iconData = lookupIcon(apiFamily, codePoint);

    if (!iconData) {
      console.error(
        `Couldn't find icon; family: ${apiFamily}, codePoint: ${codePoint}`
      );
      return communityIconsMap[61441];
    }

    return iconData;
  },
  icons: communityIcons,
  defaultIcon: communityIconsMap[61441]
};
